  export const theme1hor = `<!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>тема 1 горизонтальная</title>
    </head>
    <body>
      <div class="container">
        <div class="design-3 widget-analog-clock-M-11-3 analog-clock-M">
          <canvas id="canvas1-3" width="246px" height="246px">
            <style>
              @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
              * {
                margin: 0;
                padding: 0;
              }
              :root {
                --size-2: 246px;
                --background-widgets: rgba(255, 255, 255, 1);
              }
              .design-3 {
                background-color: var(--background-widgets);
                border-radius: 32px;
              }
              .widget-analog-clock-M-11-3 {
                display: flex;
                justify-content: center;
                align-items: center;
                width: var(--size-2);
                height: var(--size-2);
                position: absolute;
                top: 16px;
                left: 16px;
              }
            </style>
            <script>
              analogClock_11_3();
              function analogClock_11_3() {
                let center_x = 123;
                let center_y = 123;
                let radius = 117;
                pi = Math.PI;
                drawClock_11_3();
                setInterval(drawClock_11_3, 100);

                function drawClock_11_3() {
                  clock_11_3();
                  mark_circle_seconds1();
                  mark_circle_hours1(ctx, radius);
                  drawWBlackNumbers(ctx, radius);
                  timing_11_3();
                }
                // стрелки
                function timing_11_3() {
                  const d = new Date();
                  angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                  // часовая
                  ctx.beginPath();
                  ctx.lineWidth = 8;
                  ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                  ctx.moveTo(center_x, center_y);
                  let newX4 =
                    center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                  let newY4 =
                    center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                  ctx.lineTo(
                    center_x + Math.sin((d.getHours() * Math.PI) / 6),
                    center_y - Math.cos((d.getHours() * Math.PI) / 6)
                  );
                  ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                  ctx.moveTo(newX4, newY4);
                  ctx.lineTo(
                    newX4 +
                      Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                    newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                  );
                  ctx.lineCap = "round";
                  ctx.stroke();
                  ctx.closePath();

                  ctx.beginPath();
                  ctx.lineWidth = 4;
                  ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                  ctx.moveTo(center_x, center_y);
                  ctx.lineTo(
                    center_x +
                      Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                    center_y -
                      Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                  );
                  ctx.lineCap = "round";
                  ctx.stroke();
                  ctx.closePath();
                  //минутная
                  ctx.beginPath();
                  ctx.lineWidth = 8;
                  ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                  ctx.moveTo(center_x, center_y);
                  let newX3 =
                    center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                  let newY3 =
                    center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                  ctx.lineTo(
                    center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                    center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                  );
                  ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                  ctx.moveTo(newX3, newY3);
                  ctx.lineTo(
                    newX3 +
                      Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                    newY3 -
                      Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                  );
                  ctx.lineCap = "round";
                  ctx.stroke();
                  ctx.closePath();

                  ctx.beginPath();
                  ctx.lineWidth = 4;
                  ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                  ctx.moveTo(center_x, center_y);
                  ctx.lineTo(
                    center_x +
                      Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                    center_y -
                      Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                  );
                  ctx.lineCap = "round";
                  ctx.stroke();
                  ctx.closePath();
                  // секундная
                  ctx.lineWidth = 3;
                  ctx.beginPath();
                  ctx.moveTo(center_x, center_y);
                  ctx.lineTo(
                    canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                    canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                  );
                  ctx.moveTo(canvas.width / 2, canvas.height / 2);
                  ctx.lineTo(
                    canvas.width / 2 - Math.cos(angle) * 20,
                    canvas.height / 2 - Math.sin(angle) * 20
                  );
                  ctx.lineCap = "round";
                  ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                  ctx.stroke();
                  ctx.closePath();

                  ctx.beginPath(); // начало нового пути
                  ctx.fillStyle = "rgba(0, 0, 0, 1)";
                  // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                  ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
                // метки секундные серые
                function mark_circle_seconds1() {
                  for (var i = 0; i < 60; i++) {
                    angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                    ctx.lineWidth = 3; // HAND WIDTH.
                    ctx.beginPath();
                    ctx.fillStyle = "rgba(204, 204, 204, 1)";
                    var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                    var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                    ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                    ctx.fill();
                    ctx.closePath();
                  }
                }
                // часовые метки серые точечные
                function mark_circle_hours1(ctx, radius) {
                  for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                    fill(function () {
                      ctx.fillStyle = "rgba(111, 111, 111, 1)";
                      ctx.arc(
                        ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                        ctx.canvas.height / 2 +
                          ((15 * radius) / 16) * Math.sin(i),
                        3,
                        0,
                        2 * Math.PI
                      );
                    });
                  }
                }
                // отрисовка цифры черные
                function drawWBlackNumbers(ctx, radius) {
                  var ang;
                  var num;
                  ctx.fillStyle = "black";
                  ctx.font = radius * 0.18 + "px rubik";
                  ctx.textBaseline = "middle";
                  ctx.textAlign = "center";
                  for (num = 1; num < 13; num++) {
                    ang = (num * Math.PI) / 6;
                    ctx.rotate(ang);
                    ctx.translate(0, -radius * 0.75);
                    ctx.rotate(-ang);
                    ctx.fillText(num.toString(), center_x, center_y);
                    ctx.rotate(ang);
                    ctx.translate(0, radius * 0.75);
                    ctx.rotate(-ang);
                  }
                }
                function fill(fn, params) {
                  ctx.beginPath();
                  fn(params);
                  ctx.fill();
                  ctx.closePath();
                }
                function clock_11_3() {
                  canvas = document.getElementById("canvas1-3");
                  ctx = canvas.getContext("2d");
                  ctx.beginPath(); // начало нового пути
                  ctx.lineWidth = 2;
                  ctx.fillStyle = "white";
                  ctx.strokeStyle = "white";
                  // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                  ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.stroke();
                  ctx.closePath();

                  ctx.beginPath(); // начало нового пути
                  ctx.fillStyle = "rgba(115, 115, 115, 1)";
                  // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                  ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
            </script>
          </canvas>
        </div>
        <div class="design-3 widget-weather-M-11-3 weather-M">
          <div>
            <img id="current-status-img-11-3" src="" alt="" />
            <p id="current-status-weather-11-3"></p>
            <p id="current-weather-11-3"></p>
          </div>
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: 246px;
              --background-widgets: rgba(255, 255, 255, 1);
              --text-color: rgba(55, 55, 55, 1);
              --color-icon: "";
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-weather-M-11-3 {
              display: flex;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              left: 16px;
              top: 278px;
            }
            .widget-weather-M-11-3 div {
              display: flex;
              flex-direction: column;
              justify-content: space-evenly;
              padding: 30px;
            }
            .widget-weather-M-11-3 p {
              font-family: rubik;
              font-weight: 300;
            }
            .widget-weather-M-11-3 p:nth-child(2) {
              text-align: start;
              color: rgba(115, 115, 115, 1);
              font-size: 26px;
            }
            .widget-weather-M-11-3 p:nth-child(3) {
              color: var(--text-color);
              font-size: 70px;
            }
            .widget-weather-M-11-3 img {
              width: 80px;
              height: 70px;
              filter: var(--color-icon);
            }
            .current-status-weather-11-3 {
              text-align: start;
            }
          </style>
          <script>
            const currentWeather_11_3 = () => {
              fetch("http://212.41.9.251:8000/get_weather", {
                method: "GET",
                headers: {
                  accept: "application/json",
                },
              })
                .then((response) => response.json())
                .then((result) => {
                  document.getElementById("current-weather-11-3").innerHTML =
                    result[0][0];
                  document.getElementById(
                    "current-status-weather-11-3"
                  ).innerHTML = result[0][1];

                  const weather = {
                    Ясно: "http://212.41.9.251:8000/static/dark_weather_clear.svg",
                    Облачно:
                      "http://212.41.9.251:8000/static/dark_weather_cloudy.svg",
                    "Переменная облачность":
                      "http://212.41.9.251:8000/static/dark_weather_p_cloudy.svg",
                    "Местами дождь":
                      "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                    "Местами грозы":
                      "http://212.41.9.251:8000/static/dark_weather_thunderstorm.svg",
                    "Местами легкий дождь с грозой":
                      "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                    "Моросящий дождь":
                      "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  };

                  for (key in weather) {
                    if (key == result[0][1]) {
                      document
                        .getElementById("current-status-img-11-3")
                        .setAttribute("src", weather[key]);
                    }
                  }
                });
            };
            setTimeout(() => {
              setInterval(() => {
                currentWeather_11_3;
              }, 300000);
              currentWeather_11_3();
            }, 5000);
          </script>
        </div>

        <div class="design-3 widget-calendar-XL-11-1 calendar-XL">
          <table id="calendar11-1">
            <thead>
              <tr>
                <td
                  style="
                    font-weight: 500;
                    text-align: center;
                    width: 100%;
                    height: 100%;
                  "
                  colspan="7"
                ></td>
                <td>
                  <tr style="font-weight: 500">
                    <td>пн</td>
                    <td>вт</td>
                    <td>ср</td>
                    <td>чт</td>
                    <td>пт</td>
                    <td>сб</td>
                    <td>вс</td>
                  </tr>
                </td>
              </tr>
            </thead>
            <tbody id="body-calendar-11-1"></tbody>
          </table>
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-3: 377px;
              --size-4: 508px;
              --background-widgets: rgba(255, 255, 255, 1);
              --text-color: rgba(55, 55, 55, 1);
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            #calendar11-1 {
              text-align: center;
              font-size: 26px;
              color: var(--text-color);
              font-weight: 300;
              border-spacing: 15px 5px;
              margin: auto;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
            }
            .widget-calendar-XL-11-1 {
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: Rubik;
              width: var(--size-4);
              height: var(--size-3);
              position: absolute;
              top: 16px;
              left: 278px;
            }
            #today-11-1 {
              color: var(--background-widgets);
              background-color: var(--text-color);
              border-radius: 16px;
            }
            #body-calendar-11-1 tr td {
              width: 46px;
              height: 46px;
              text-align: center;
            }
            thead tr:nth-child(1) {
              display: flex;
              justify-content: center;
            }
            thead tr:nth-child(2) {
              display: flex;
              justify-content: space-evenly;
              align-items: flex-end;
              height: 50px;
            }
            thead tr td {
              width: 46px;
            }
          </style>

          <script>
            const getCalendar_11_1 = () => {
              var D1 = new Date(),
                D1last = new Date(
                  D1.getFullYear(),
                  D1.getMonth() + 1,
                  0
                ).getDate(), // последний день месяца
                D1Nlast = new Date(
                  D1.getFullYear(),
                  D1.getMonth(),
                  D1last
                ).getDay(), // день недели последнего дня месяца
                D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
                calendar1 = "<tr>",
                month = [
                  "Январь",
                  "Февраль",
                  "Март",
                  "Апрель",
                  "Май",
                  "Июнь",
                  "Июль",
                  "Август",
                  "Сентябрь",
                  "Октябрь",
                  "Ноябрь",
                  "Декабрь",
                ]; // название месяца, вместо цифр 0-11

              // пустые клетки до первого дня текущего месяца
              if (D1Nfirst != 0) {
                for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
              } else {
                // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
                for (var i = 0; i < 6; i++) calendar1 += "<td>";
              }

              // дни месяца
              for (var i = 1; i <= D1last; i++) {
                if (i != D1.getDate()) {
                  calendar1 += "<td>" + i;
                } else {
                  calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
                }
                if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                  // если день выпадает на воскресенье, то перевод строки
                  calendar1 += "<tr>";
                }
              }

              // пустые клетки после последнего дня месяца
              if (D1Nlast != 0) {
                for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
              }

              document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
              // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
              document.querySelector(
                "#calendar11-1 thead td:first-child"
              ).innerHTML = month[D1.getMonth()];
            };
            getCalendar_11_1();
          </script>
        </div>

        <div class="design-3 widget-traffic-S-11-3 traffic-XS">
          <p id="current-traffic-11-3"></p>
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-1: 115px;
              --style3: "";
              --background-widgets: rgba(255, 255, 255, 1);
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-traffic-S-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-1);
              height: var(--size-1);
              position: absolute;
              top: 409px;
              left: 278px;
            }
            .widget-traffic-S-11-3 p {
              font-family: rubik;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 90px;
              height: 90px;
              background-color: var(--style3);
              border-radius: 50%;
              font-size: 70px;
              color: var(--background-widgets);
            }
          </style>
          <script>
            const getTraffic_11_3 = () => {
              min = Math.ceil(1);
              max = Math.floor(8);
              return Math.floor(Math.random() * (max - min) + min);
            };
            const updateBackgroud3 = () => {
              let value = document.getElementById(
                "current-traffic-11-3"
              ).innerHTML;
              if (value == "10") {
                var style = \`rgba(250, 46, 35, 1)\`;
              } else if (value == "9") {
                var style = \`rgba(249, 80, 32, 1)\`;
              } else if (value == "8") {
                var style = \`rgba(248, 111, 28, 1)\`;
              } else if (value == "7") {
                var style = \`rgba(247, 138, 25, 1)\`;
              } else if (value == "6") {
                var style = \`rgba(247, 165, 22, 1)\`;
              } else if (value == "5") {
                var style = \`rgba(245, 191, 19, 1)\`;
              } else if (value == "4") {
                var style = \`rgba(239, 222, 21, 1)\`;
              } else if (value == "3") {
                var style = \`rgba(210, 250, 11, 1)\`;
              } else if (value == "2") {
                var style = \`rgba(164, 243, 18, 1)\`;
              } else if (value == "1") {
                var style = \`rgba(144, 243, 13, 1)\`;
              } else {
                var style = \`rgba(77, 243, 12, 1)\`;
              }
              document.documentElement.style.setProperty(\`--style3\`, \`\${style}\`);
            };
            document.getElementById("current-traffic-11-3").innerHTML =
              getTraffic_11_3();
            updateBackgroud3();
            setInterval(() => {
              document.getElementById("current-traffic-11-3").innerHTML =
                getTraffic_11_3();

              updateBackgroud3();
            }, 1800000);
          </script>
        </div>

        <div class="design-3 widget-rates-M-11-6 rates-S">
          <p>USD</p>
          <div class="space-div-7-6"></div>
          <p id="usd-11-6">0,00</p>
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-1: 115px;
              --size-2: 246px;
              --background-widgets: rgba(255, 255, 255, 1);
              --text-color: rgba(55, 55, 55, 1);
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-rates-M-11-6 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-1);
              position: absolute;
              top: 409px;
              left: 409px;
            }
            .widget-rates-M-11-6 p {
              font-family: rubik;
              color: var(--text-color);
              font-size: 32px;
              font-weight: 400;
            }
            .widget-rates-M-11-6 p:first-child {
              color: rgba(115, 115, 115, 1);
            }
            .space-div-7-6 {
              width: 14px;
            }
          </style>
          <script>
            const getUSD_11_6 = () => {
              fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                method: "GET",
              })
                .then((response) => response.json())
                .then((result) => {
                  document.getElementById("usd-11-6").innerHTML =
                    result.Valute.USD.Value.toFixed(2);
                });
            };

            setTimeout(() => {
              setInterval(() => {
                getUSD_11_6;
              }, 43200000);
              getUSD_11_6();
            }, 5000);
          </script>
        </div>

        <div class="design-3 widget-rates-M-11-7 rates-S">
          <p>EUR</p>
          <div class="space-div-7-7"></div>
          <p id="eur-11-7">0,00</p>
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-1: 115px;
              --size-2: 246px;
              --background-widgets: rgba(255, 255, 255, 1);
              --text-color: rgba(55, 55, 55, 1);
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-rates-M-11-7 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-1);
              position: absolute;
              top: 409px;
              left: 671px;
            }
            .widget-rates-M-11-7 p {
              font-family: rubik;
              color: var(--text-color);
              font-size: 32px;
              font-weight: 400;
            }
            .widget-rates-M-11-7 p:first-child {
              color: rgba(115, 115, 115, 1);
            }
            .space-div-7-7 {
              width: 14px;
            }
          </style>
          <script>
            const getEUR_11_7 = () => {
              fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
                method: "GET",
              })
                .then((response) => response.json())
                .then((result) => {
                  document.getElementById("eur-11-7").innerHTML =
                    result.Valute.EUR.Value.toFixed(2);
                });
            };

            setTimeout(() => {
              setInterval(() => {
                getEUR_11_7;
              }, 43200000);
              getEUR_11_7();
            }, 5000);
          </script>
        </div>

        <div class="design-3 widget-news-11-1 news-L">
          <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
            ------
          </p>
          <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
            ------
          </p>
          <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
            ------
          </p>
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: 246px;
              --size-4: 508px;
              --background-widgets: rgba(255, 255, 255, 1);
              --text-color: rgba(55, 55, 55, 1);
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-news-11-1 {
              width: 392px;
              height: 377px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              top: 16px;
              left: 802px;
            }
            .widget-news-11-1 p {
              color: var(--text-color);
              font-family: Rubik;
              font-weight: 300;
              font-size: 26px;
              text-align: start;
              margin-left: 32px;
              padding-left: 16px;
              margin-right: 32px;
              border-left: 3px solid var(--text-color);
            }
          </style>
          <script>
            const getNews_11_1 = () => {
              fetch("http://212.41.9.251:8000/news", {
                method: "GET",
                headers: {
                  accept: "application/json",
                },
              })
                .then((response) => response.json())
                .then((result) => {
                  const news = result.filter((item) => {
                    return item.length >= 15 && item.length <= 60;
                  });
                  document.getElementById("header-news-11-1").innerHTML = news[0];
                  document.getElementById("header-news-11-2").innerHTML = news[1];
                  document.getElementById("header-news-11-3").innerHTML = news[2];
                });
            };
            setTimeout(() => {
              setInterval(() => {
                getNews_11_1();
              }, 300000);
              getNews_11_1();
            }, 5000);
          </script>
        </div>
        <div class="design-3 video">
          <video
            id="videoPlayer"
            autoplay=""
            poster="http://legacy.reactjs.org/logo-og.png"
          ></video>
          <style>
            .video {
              position: absolute;
              top: 16px;
              left: 1210px;
            }
            .video video {
              object-fit: fill;
              width: 694px;
              height: 377px;
              border-radius: 32px;
            }
          </style>
          <script>
            const player = async () => {
              let currentVideoIndex = 0;
              let videoSources = [];
              const getVideos = async () => {
                const response = await fetch(
                  \`http://212.41.9.251:8000/files/\${panelId}\`,
                  {
                    method: "GET",
                    headers: { Accept: "application/json" },
                  }
                );
                const result = await response.json();
                videoSources = result.files.filter((elem) =>
                  elem.endsWith(".mp4")
                );
                videoSources = videoSources.map(
                  (elem) => "http://212.41.9.251:8000" + elem
                );
                console.log(videoSources);
              };
              await getVideos();
              const videoPlayer = document.getElementById("videoPlayer");
              const loadNext = async () => {
                currentVideoIndex == videoSources.length - 1
                  ? (currentVideoIndex = 0)
                  : (currentVideoIndex += 1);
                videoPlayer.src = videoSources[currentVideoIndex];
                videoPlayer.load();
                videoPlayer.play();
              };
              videoPlayer.src = videoSources[currentVideoIndex];
              videoPlayer.load();
              videoPlayer.play();

              videoPlayer.addEventListener("ended", loadNext);
              setInterval(getVideos, 1800000);
            };
            player();
          </script>
        </div>

        <div class="design-3 widget-about-company-11-1 company-L">
          <div>
            <p>Лифт обслуживает компания</p>
            <p>Meteor</p>
          </div>
          <div>
            <p>Телефон поддержки</p>
            <p>+7(800)555-35-35</p>
          </div>
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-1: 115px;
              --size-4: 508px;
              --background-widgets: rgba(255, 255, 255, 1);
              --text-color: rgba(55, 55, 55, 1);
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-about-company-11-1 {
              display: flex;
              flex-direction: column;
              justify-content: space-evenly;
              width: 447px;
              height: var(--size-1);
              position: absolute;
              top: 409px;
              left: 933px;
            }
            .widget-about-company-11-1 div {
              display: flex;
              justify-content: space-around;
            }
            .widget-about-company-11-1 p {
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
            }
            .widget-about-company-11-1 p:first-child {
              color: rgba(115, 115, 115, 1);
            }
          </style>
        </div>

        <div class="design-3 widget-about-company-11-2 company-L">
          <img src="http://212.41.9.251:8000/static/dark_qr.svg" alt="" />
          <div>
            <img
              style="width: 116px; height: 12px"
              src="http://212.41.9.251:8000/static/dark_ipanel.svg"
              alt=""
            />
            <div class="space-div-9-2"></div>
            <img
              src="http://212.41.9.251:8000/static/dark_liftbrand.svg"
              alt=""
            />
          </div>
          <img
            src="http://212.41.9.251:8000/static/dark_videovision.svg"
            alt=""
          />
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-1: 115px;
              --size-4: 508px;
              --background-widgets: rgba(255, 255, 255, 1);
              --color-icon: "";
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-about-company-11-2 {
              display: flex;
              align-items: center;
              justify-content: space-around;
              width: var(--size-4);
              height: var(--size-1);
              position: absolute;
              top: 409px;
              left: 1396px;
            }
            .widget-about-company-11-2 div {
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            .space-div-9-2 {
              height: 16px;
            }
            .widget-about-company-11-2 img {
              filter: var(--color-icon);
            }
          </style>
        </div>
      </div>
    </body>
    <style>
      * {
        margin: 0;
        padding: 0;
      }
      .container {
        position: relative;
        width: 1920px;
        height: 540px;
        background-color: rgba(234, 234, 234, 1);
      }
    </style>
  </html>
`;
export const theme1ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 1 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-3 widget-weather-XL-11-1 weather-XL">
        <div class="current-weather-11-1">
          <div>
            <p id="current-weather-11-1"></p>
            <p id="status-weather-11-1"></p>
          </div>
          <img id="current-status-img-11-1" src="" alt="" />
        </div>
        <div class="weather-per-day-11-1">
          <div>
            <img id="status-img-11-1-1" src="" alt="" />
            <p>Утро</p>
          </div>
          <div>
            <img id="status-img-11-1-2" src="" alt="" />
            <p>День</p>
          </div>
          <div>
            <img id="status-img-11-1-3" src="" alt="" />
            <p>Вечер</p>
          </div>
          <div>
            <img id="status-img-11-1-4" src="" alt="" />
            <p>Ночь</p>
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            left: 16px;
            top: 16px;
          }

          .current-weather-11-1 {
            display: flex;
            justify-content: space-around;
            align-items: center;
          }
          .current-weather-11-1 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 70px;
            font-weight: 300;
            text-align: start;
          }
          .current-weather-11-1 p:nth-child(2) {
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .current-weather-11-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .weather-per-day-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .weather-per-day-11-1 p {
            font-family: rubik;
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .weather-per-day-11-1 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .weather-per-day-11-1 img {
            width: 46px;
            height: 46px;
          }
        </style>
        <script>
          const get_weather_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-1").innerHTML =
                  result[0][0];
                document.getElementById("status-weather-11-1").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/dark_weather_clear.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/dark_weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/dark_weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Местами грозы":
                    "http://212.41.9.251:8000/static/dark_weather_thunderstorm.svg",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-11-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-11-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-11-1-3")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][3][1]) {
                    document
                      .getElementById("status-img-11-1-4")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              get_weather_11_1;
            }, 300000);
            get_weather_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-3 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: 246px;
              --background-widgets: rgba(255, 255, 255, 1);
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              left: 16px;
              top: 278px;
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>
      <div class="design-3 widget-date-11-5 dates-S">
        <p id="current-day-11-5"></p>
        <p id="current-month-11-5"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-11-5 {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            right: 16px;
            top: 278px;
          }
          .widget-date-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 140px;
            font-weight: 300;
          }
          .widget-date-11-5 p:nth-child(1) {
            line-height: 120px;
          }
          .widget-date-11-5 p:nth-child(2) {
            font-family: rubik;
            font-size: 32px;
            font-weight: 400;
          }
        </style>
        <script>
          const currentDay_11_5 = () => {
            let date = new Date();
            return \`\${date.getDate()}\`;
          };
          const currentMonth_11_5 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            return \`\${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-day-11-5").innerHTML =
              currentDay_11_5();
          }, 100);
          setInterval(() => {
            document.getElementById("current-month-11-5").innerHTML =
              currentMonth_11_5();
          }, 100);
        </script>
      </div>
      <div class="design-3 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            top: 540px;
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>
      <div class="design-3 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --style2: "";
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            right: 16px;
            top: 540px;
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>
      <div class="design-3 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: 16px;
            top: 671px;
          }
          .video img {
            width: 508px;
            height: 276px;
            border-radius: 32px;
          }
        </style>
      </div>
      <div class="design-3 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-1 {
            width: var(--size-4);
            height: 411px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 16px;
            top: 969px;
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-metals-XL-11-1 metal-XL">
        <div>
          <p class="name-metal-11-1">Нефть</p>
          <p id="oil-divide-price-11-1">---,--</p>
          <p id="oil-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="oil-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Серебро</p>
          <p id="silver-divide-price-11-1">---,--</p>
          <p id="silver-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="silver-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Золото</p>
          <p id="gold-divide-price-11-1">---,--</p>
          <p id="gold-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="gold-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Платина</p>
          <p id="platinum-divide-price-11-1">---,--</p>
          <p id="platinum-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="platinum-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Палладий</p>
          <p id="palladium-divide-price-11-1">---,--</p>
          <p id="palladium-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="palladium-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            left: 16px;
            bottom: 278px;
          }
          .widget-metals-XL-11-1 div {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-1 {
            color: var(--text-color);
            text-align: start;
            width: 129px;
          }
          .widget-metals-XL-11-1 div p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            width: 61px;
            text-align: end;
          }
          .widget-metals-XL-11-1 div p:nth-child(3) {
            color: rgba(115, 115, 115, 1);
            width: 80px;
            text-align: end;
          }
          .widget-metal-last-11-1 p {
            width: 125px;
            text-align: end;
          }
          .widget-metals-XL-11-1 img {
            width: 12px;
            height: 11px;
          }
          .space-div-8-1 {
            width: 6px;
          }
        </style>
        <script>
          const getOil_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-1").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-1-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-1").innerHTML = result[1];
                document.getElementById("oil-divide-price-11-1").innerHTML =
                  result[2];
                document.getElementById("oil-perc-price-11-1").innerHTML =
                  result[3];
              });
          };
          const getMetal_11_1 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-1").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-1-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-divide-price-11-1").innerHTML =
                  (new_silver_price - old_silver_price).toFixed(2);
                document.getElementById(
                  "silver-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_silver_price - old_silver_price) / new_silver_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("silver-price-11-1").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-1").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-1-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-divide-price-11-1").innerHTML = (
                  new_gold_price - old_gold_price
                ).toFixed(2);
                document.getElementById("gold-perc-price-11-1").innerHTML = \`\${(
                  ((new_gold_price - old_gold_price) / new_gold_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("gold-price-11-1").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-1"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-1-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById(
                  "platinum-divide-price-11-1"
                ).innerHTML = (new_gold_price - old_platinum_price).toFixed(2);
                document.getElementById(
                  "platinum-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_platinum_price - old_platinum_price) /
                    new_platinum_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("platinum-price-11-1").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-1"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-1-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById(
                  "palladium-divide-price-11-1"
                ).innerHTML = (
                  new_palladium_price - old_palladium_price
                ).toFixed(2);
                document.getElementById(
                  "palladium-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_palladium_price - old_palladium_price) /
                    new_palladium_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("palladium-price-11-1").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_1();
              getMetal_11_1();
            }, 172800000);
            getOil_11_1();
            getMetal_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-1">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            top: 1658px;
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
      </div>
      <div class="design-3 widget-about-company-11-2">
        <img src="http://212.41.9.251:8000/static/dark_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/dark_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/dark_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/dark_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            top: 1789px;
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-9-2 {
            height: 16px;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: 540px;
      height: 1920px;
      background-color: rgba(234, 234, 234, 1);
      position: relative;
    }
  </style>
</html>
`;

export const theme2hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 2 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-1 widget-digital-clock-XL-11-2 digital-clock-XL">
        <p id="hour-minutes11-2"></p>
        <p id="seconds11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-digital-clock-XL-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: 16px;
            left: 16px;
          }
          .widget-digital-clock-XL-11-2 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
          .widget-digital-clock-XL-11-2 p:first-child {
            width: 380px;
            text-align: center;
          }
          .widget-digital-clock-XL-11-2 p:nth-child(2) {
            margin-top: 50px;
            width: 88px;
            font-size: 70px;
            color: rgba(64, 64, 64, 1);
          }
        </style>
        <script>
          setInterval(function setTime_11_2() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-date-S-11-6 dates-XS">
        <p id="current-date-11-6"></p>
        <p id="current-day-11-6"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-S-11-6 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            top: 278px;
          }

          .widget-date-S-11-6 p {
            color: var(--text-color);
            font-family: Rubik;
            font-size: 26px;
            font-weight: 500;
          }
          .widget-date-S-11-6 p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
        </style>
        <script>
          const currentDate_11_6 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${date.getDate()} \${month[date.getMonth()]}\`;
          };

          const currentDay_11_6 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-date-11-6").innerHTML =
              currentDate_11_6();
            document.getElementById("current-day-11-6").innerHTML =
              currentDay_11_6();
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: 278px;
            left: 278px;
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: 413px;
            height: var(--size-1);
            position: absolute;
            left: 16px;
            bottom: 16px;
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
      </div>

      <div class="design-1 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img src="http://212.41.9.251:8000/static/light_liftbrand.svg" alt="" />
        </div>
        <img src="http://212.41.9.251:8000/static/light_videovision.svg" alt="" />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            left: 445px;
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-9-2 {
            height: 16px;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>

      <div class="design-1 widget-weather-L-11-2 weather-L">
        <p id="current-weather-11-2"></p>
        <img id="current-status-img-11-2" src="" alt="" />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-3: 377px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-L-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: 282px;
            height: var(--size-1);
            position: absolute;
            top: 16px;
            left: 540px;
          }
          .widget-weather-L-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-weather-L-11-2 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
        </style>
        <script>
          const get_weather_11_2 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-2").innerHTML =
                  result[0][0];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-2")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              get_weather_11_2;
            }, 300000);
            get_weather_11_2();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-traffic-S-11-3 traffic-XS">
        <p id="current-traffic-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --style3: "";
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-S-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-1);
            height: var(--size-1);
            position: absolute;
            top: 16px;
            left: 838px;
          }
          .widget-traffic-S-11-3 p {
            font-family: rubik;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 90px;
            background-color: var(--style3);
            border-radius: 50%;
            font-size: 70px;
            color: rgba(30, 30, 30, 1);
          }
        </style>
        <script>
          const getTraffic_11_3 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud3 = () => {
            let value = document.getElementById(
              "current-traffic-11-3"
            ).innerHTML;
            if (value == "10") {
              var style = \`rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style3\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-3").innerHTML =
            getTraffic_11_3();
          updateBackgroud3();
          setInterval(() => {
            document.getElementById("current-traffic-11-3").innerHTML =
              getTraffic_11_3();

            updateBackgroud3();
          }, 1800000);
        </script>
      </div>

      <div class="design-1 widget-news-11-2 news-L">
        <div class="left-line-11-2"></div>
        <div><p id="header-news-11-2">------</p></div>
        <div class="left-line-11-2"></div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-2 {
            width: 413px;
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 147px;
            left: 540px;
          }
          .widget-news-11-2 div:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .widget-news-11-2 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: center;
            padding-left: 32px;
            padding-right: 32px;
          }
          .left-line-11-2 {
            width: 40%;
            height: 3px;
            background-color: var(--text-color);
            margin-top: 26px;
            margin-bottom: 26px;
          }
        </style>
        <script>
          const getNews_11_2 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("header-news-11-2").innerHTML =
                  result[0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_2();
            }, 300000);
            getNews_11_2();
          }, 5000);
        </script>
      </div>
      <div class="design-1 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            top: 16px;
            right: 16px;
          }
          .video img {
            width: 935px;
            height: 508px;
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: 1920px;
      height: 540px;
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;
export const theme2ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 2 вертикальная</title>
  </head>
  <body>
    <div class="container">
      
      <div class="design-1 widget-weather-XL-11-1 weather-XL">
        <div class="current-weather-11-1">
          <div>
            <p id="current-weather-11-1"></p>
            <p id="status-weather-11-1"></p>
          </div>
          <img id="current-status-img-11-1" src="" alt="" />
        </div>
        <div class="weather-per-day-11-1">
          <div>
            <img id="status-img-11-1-1" src="" alt="" />
            <p>Утро</p>
          </div>
          <div>
            <img id="status-img-11-1-2" src="" alt="" />
            <p>День</p>
          </div>
          <div>
            <img id="status-img-11-1-3" src="" alt="" />
            <p>Вечер</p>
          </div>
          <div>
            <img id="status-img-11-1-4" src="" alt="" />
            <p>Ночь</p>
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            left: 16px;
            top: 16px;
          }

          .current-weather-11-1 {
            display: flex;
            justify-content: space-around;
            align-items: center;
          }
          .current-weather-11-1 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 70px;
            font-weight: 300;
            text-align: start;
          }
          .current-weather-11-1 p:nth-child(2) {
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .current-weather-11-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .weather-per-day-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .weather-per-day-11-1 p {
            font-family: rubik;
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .weather-per-day-11-1 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .weather-per-day-11-1 img {
            width: 46px;
            height: 46px;
          }
        </style>
        <script>
          const get_weather_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById(
                  "current-weather-11-1"
                ).innerHTML = result[0][0];
                document.getElementById(
                  "status-weather-11-1"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-11-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-11-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-11-1-3")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][3][1]) {
                    document
                      .getElementById("status-img-11-1-4")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              get_weather_11_1;
            }, 300000);
            get_weather_11_1();
          }, 1000);
        </script>
      </div>
    

      <div class="design-1 widget-digital-clock-XL-11-2 digital-clock-XL">
        <p id="hour-minutes11-2"></p>
        <p id="seconds11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-digital-clock-XL-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            left: 16px;
            top: 278px;
          }
          .widget-digital-clock-XL-11-2 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
          .widget-digital-clock-XL-11-2 p:first-child {
            width: 380px;
            text-align: center;
          }
          .widget-digital-clock-XL-11-2 p:nth-child(2) {
            margin-top: 50px;
            width: 88px;
            font-size: 70px;
            color: rgba(64, 64, 64, 1);
          }
        </style>
        <script>
          setInterval(function setTime_11_2() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-date-M-11-3 dates-L">
        <p id="current-day-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-M-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            top: 540px;
          }
          .widget-date-M-11-3 p {
            font-family: rubik;
            font-size: 32px;
            color: var(--text-color);
          }
        </style>
        <script>
          const currentDate_11_3 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          setInterval(() => {
            document.getElementById("current-day-11-3").innerHTML =
              currentDate_11_3();
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-traffic-L-11-1 traffic-L">
        <p>Пробки</p>
        <div class="space-div-5-1"></div>
        <p id="current-traffic-11-1"></p>
        <div class="space-div-5-1"></div>
        <p>баллов</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --style: "";
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-L-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            top: 671px;
          }
          .widget-traffic-L-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-L-11-1 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style);
            border-radius: 50%;
          }
          .space-div-5-1 {
            width: 16px;
          }
        </style>
        <script>
          const getTraffic_11_1 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud = () => {
            let value = document.getElementById(
              "current-traffic-11-1"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-1").innerHTML =
            getTraffic_11_1();
          updateBackgroud();
          setInterval(() => {
            document.getElementById("current-traffic-11-1").innerHTML =
              getTraffic_11_1();

            updateBackgroud();
          }, 1800000);
        </script>
      </div>
      <div class="design-1 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: 16px;
            top: 802px;
          }
          .video img {
            width: 508px;
            height: 276px;
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-1 widget-rates-M-11-6 rates-S">
        <p>USD</p>
        <div class="space-div-7-6"></div>
        <p id="usd-11-6">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-6 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            top: 1094px;
          }
          .widget-rates-M-11-6 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-6 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-6 {
            width: 14px;
          }
        </style>
        <script>
          const getUSD_11_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_11_6;
            }, 43200000);
            getUSD_11_6();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-rates-M-11-7 rates-S">
        <p>EUR</p>
        <div class="space-div-7-7"></div>
        <p id="eur-11-7">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: 1094px;
            right: 16px;
          }
          .widget-rates-M-11-7 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-7 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-7 {
            width: 14px;
          }
        </style>
        <script>
          const getEUR_11_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-11-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_11_7;
            }, 43200000);
            getEUR_11_7();
          }, 5000);
        </script>
      </div>

      
      <div class="design-1 widget-metals-11-2 metal-L">
        <div>
          <p class="name-metal-11-2">Нефть</p>
          <p id="oil-divide-price-11-2">---,--</p>
          <p id="oil-perc-price-11-2">---,--</p>
          <div class="widget-metal-last-11-2">
            <p id="oil-price-11-2">---,--</p>
            <div class="space-div-8-2"></div>
            <img
              id="updown-11-2-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-2">Серебро</p>
          <p id="silver-divide-price-11-2">---,--</p>
          <p id="silver-perc-price-11-2">---,--</p>
          <div class="widget-metal-last-11-2">
            <p id="silver-price-11-2">---,--</p>
            <div class="space-div-8-2"></div>
            <img
              id="updown-11-2-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-2">Золото</p>
          <p id="gold-divide-price-11-2">---,--</p>
          <p id="gold-perc-price-11-2">---,--</p>
          <div class="widget-metal-last-11-2">
            <p id="gold-price-11-2">---,--</p>
            <div class="space-div-8-2"></div>
            <img
              id="updown-11-2-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-11-2 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            bottom: 580px;
          }
          .widget-metals-11-2 div {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-2 {
            color: white;
            text-align: start;
            width: 106px;
          }
          .widget-metals-11-2 div p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            width: 61px;
            text-align: end;
          }
          .widget-metals-11-2 div p:nth-child(3) {
            color: rgba(115, 115, 115, 1);
            width: 80px;
            text-align: end;
          }
          .widget-metals-11-2 div p:nth-child(4) {
            width: 100px;
            text-align: end;
          }
          .widget-metals-11-2 img {
            width: 12px;
            height: 11px;
          }
          .space-div-8-2 {
            width: 6px;
          }
          .widget-metal-last-11-2 p {
            width: 108px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_2 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-2").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-2-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-2-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-2").innerHTML =
                  result[1];
                document.getElementById(
                  "oil-divide-price-11-2"
                ).innerHTML = result[2];
                document.getElementById(
                  "oil-perc-price-11-2"
                ).innerHTML = result[3];
              });
          };
          const getMetal_11_2 = () => {
            fetch(
              "http://212.41.9.251:8000/metal",
              {
                method: "GET",
              }
            )
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById(
                    "silver-price-11-2"
                  ).innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-2-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-2-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById(
                  "silver-divide-price-11-2"
                ).innerHTML = (
                  new_silver_price - old_silver_price
                ).toFixed(2);
                document.getElementById(
                  "silver-perc-price-11-2"
                ).innerHTML = \`\${(
                  ((new_silver_price - old_silver_price) /
                    new_silver_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById(
                  "silver-price-11-2"
                ).innerHTML = result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById(
                    "gold-price-11-2"
                  ).innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-2-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-2-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById(
                  "gold-divide-price-11-2"
                ).innerHTML = (
                  new_gold_price - old_gold_price
                ).toFixed(2);
                document.getElementById(
                  "gold-perc-price-11-2"
                ).innerHTML = \`\${(
                  ((new_gold_price - old_gold_price) /
                    new_gold_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("gold-price-11-2").innerHTML =
                  result.rates.USDXAU.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_2();
              getMetal_11_2();
            }, 172800000);
            getOil_11_2();
            getMetal_11_2();
          }, 1000);
        </script>
      </div>
    

      <div class="design-1 widget-news-11-2 news-L">
        <div class="left-line-11-2"></div>
        <div><p id="header-news-11-2">------</p></div>
        <div class="left-line-11-2"></div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-2 {
            width: var(--size-4);
            height: 286px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: 16px;
            bottom: 278px;
          }
          .widget-news-11-2 div:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .widget-news-11-2 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: center;
            padding-left: 32px;
            padding-right: 32px;
          }
          .left-line-11-2 {
            width: 40%;
            height: 3px;
            background-color: var(--text-color);
            margin-top: 26px;
            margin-bottom: 26px;
          }
        </style>
        <script>
          const getNews_11_2 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("header-news-11-2").innerHTML =
                  result[0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_2();
            }, 300000);
            getNews_11_2();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            bottom: 147px;
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
      </div>

      <div class="design-1 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img src="http://212.41.9.251:8000/static/light_liftbrand.svg" alt="" />
        </div>
        <img src="http://212.41.9.251:8000/static/light_videovision.svg" alt="" />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            left: 16px;
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-9-2 {
            height: 16px;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: 540px;
      height: 1920px;
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;

export const theme3hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 3 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-4 widget-analog-clock-M-11-7 analog-clock-M">
        <canvas id="canvas1-7" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: 246px;
              --background-widgets: rgba(0, 0, 0, 0.4);
            }
            .design-4 {
              background-color: var(--background-widgets);
              border-radius: 32px;
              backdrop-filter: blur(60px);
            }
            .widget-analog-clock-M-11-7 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              top: 16px;
              left: 16px;
            }
          </style>
          <script>
            analogClock_11_7();
            function analogClock_11_7() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_7();
              setInterval(drawClock_11_7, 100);
              function drawClock_11_7() {
                clock_11_7();
                mark_circle_seconds2();
                mark_circle_hours2(ctx, radius);
                drawWhiteNumbers(ctx, radius);
                timing_11_7();
              }
              // стрелки
              function timing_11_7() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;
                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 19) / 11,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 19) / 11
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(255, 255, 255, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(255, 255, 255, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              function mark_circle_hours2(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(255, 255, 255, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((10 * radius) / 11) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((10 * radius) / 11) * Math.sin(i),
                      4,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }

              //  секундные метки темно-серые точечные
              function mark_circle_seconds2() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(64, 64, 64, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 14) / 8;
                  var y1 = center_y + (Math.sin(angle) * 60 * 14) / 8;
                  ctx.arc(x1, y1, 4, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              // отрисовка цифр белые
              function drawWhiteNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function clock_11_7() {
                canvas = document.getElementById("canvas1-7");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "rgba(16, 16, 16, 1)";
                ctx.strokeStyle = "rgba(16, 16, 16, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-4 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            bottom: 16px;
            left: 16px;
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы":
                    "http://212.41.9.251:8000/static/weather_thunderstorm.svg",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Небольшой дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-calendar-XL-11-1 calendar-XL">
        <table id="calendar11-1">
          <thead>
            <tr>
              <td
                style="
                  font-weight: 500;
                  text-align: center;
                  width: 100%;
                  height: 100%;
                "
                colspan="7"
              ></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-11-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3: 377px;
            --size-4: 508px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          #calendar11-1 {
            text-align: center;
            font-size: 26px;
            color: var(--text-color);
            font-weight: 300;
            border-spacing: 15px 5px;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .widget-calendar-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Rubik;
            width: var(--size-4);
            height: var(--size-3);
            position: absolute;
            top: 16px;
            left: 278px;
          }
          #today-11-1 {
            color: var(--background-widgets);
            background-color: var(--text-color);
            border-radius: 16px;
          }
          #body-calendar-11-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 50px;
          }
          thead tr td {
            width: 46px;
          }
        </style>

        <script>
          const getCalendar_11_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar11-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_11_1();
        </script>
      </div>

      <div class="design-4 widget-traffic-S-11-3 traffic-XS">
        <p id="current-traffic-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --style3: "";
            --background-widgets: rgba(0, 0, 0, 0.4);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-S-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-1);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            left: 278px;
          }
          .widget-traffic-S-11-3 p {
            font-family: rubik;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 90px;
            background-color: var(--style3);
            border-radius: 50%;
            font-size: 70px;
            color: rgba(30, 30, 30, 1);
          }
        </style>
        <script>
          const getTraffic_11_3 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud3 = () => {
            let value = document.getElementById(
              "current-traffic-11-3"
            ).innerHTML;
            if (value == "10") {
              var style = \`rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style3\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-3").innerHTML =
            getTraffic_11_3();
          updateBackgroud3();
          setInterval(() => {
            document.getElementById("current-traffic-11-3").innerHTML =
              getTraffic_11_3();

            updateBackgroud3();
          }, 1800000);
        </script>
      </div>

      <div class="design-4 widget-rates-M-11-6 rates-S">
        <p>USD</p>
        <div class="space-div-7-6"></div>
        <p id="usd-11-6">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-6 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            left: 409px;
          }
          .widget-rates-M-11-6 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-6 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-6 {
            width: 14px;
          }
        </style>
        <script>
          const getUSD_11_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_11_6;
            }, 43200000);
            getUSD_11_6();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-rates-M-11-7 rates-S">
        <p>EUR</p>
        <div class="space-div-7-7"></div>
        <p id="eur-11-7">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            left: 671px;
          }
          .widget-rates-M-11-7 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-7 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-7 {
            width: 14px;
          }
        </style>
        <script>
          const getEUR_11_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-11-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_11_7;
            }, 43200000);
            getEUR_11_7();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: 392px;
            height: 377px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: 16px;
            left: 802px;
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid white;
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: 447px;
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            right: 540px;
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
      </div>

      <div class="design-4 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            right: 16px;
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-9-2 {
            height: 16px;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>
      <div class="design-4 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            top: 16px;
            right: 16px;
          }
          .video img {
            width: 694px;
            height: 377px;
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: 1920px;
      height: 540px;
      background-image: url("http://212.41.9.251:8000/static/background1.svg");
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;
      overflow: hidden;
    }
  </style>
</html>
`;
export const theme3ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 3 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-4 widget-weather-XL-11-1 weather-XL">
        <div class="current-weather-11-1">
          <div>
            <p id="current-weather-11-1"></p>
            <p id="status-weather-11-1"></p>
          </div>
          <img id="current-status-img-11-1" src="" alt="" />
        </div>
        <div class="weather-per-day-11-1">
          <div>
            <img id="status-img-11-1-1" src="" alt="" />
            <p>Утро</p>
          </div>
          <div>
            <img id="status-img-11-1-2" src="" alt="" />
            <p>День</p>
          </div>
          <div>
            <img id="status-img-11-1-3" src="" alt="" />
            <p>Вечер</p>
          </div>
          <div>
            <img id="status-img-11-1-4" src="" alt="" />
            <p>Ночь</p>
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            left: 16px;
            top: 16px;
          }

          .current-weather-11-1 {
            display: flex;
            justify-content: space-around;
            align-items: center;
          }
          .current-weather-11-1 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 70px;
            font-weight: 300;
            text-align: start;
          }
          .current-weather-11-1 p:nth-child(2) {
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .current-weather-11-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .weather-per-day-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .weather-per-day-11-1 p {
            font-family: rubik;
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .weather-per-day-11-1 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .weather-per-day-11-1 img {
            width: 46px;
            height: 46px;
          }
        </style>
        <script>
          const get_weather_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-1").innerHTML =
                  result[0][0];
                document.getElementById("status-weather-11-1").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-11-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-11-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-11-1-3")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][3][1]) {
                    document
                      .getElementById("status-img-11-1-4")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              get_weather_11_1;
            }, 300000);
            get_weather_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-4 widget-analog-clock-M-11-7 analog-clock-M">
        <canvas id="canvas1-7" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: 246px;
              --background-widgets: rgba(0, 0, 0, 0.4);
            }
            .design-4 {
              background-color: var(--background-widgets);
              border-radius: 32px;
              backdrop-filter: blur(60px);
            }
            .widget-analog-clock-M-11-7 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              left: 16px;
              top: 278px;
            }
          </style>
          <script>
            analogClock_11_7();
            function analogClock_11_7() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_7();
              setInterval(drawClock_11_7, 100);
              function drawClock_11_7() {
                clock_11_7();
                mark_circle_seconds2();
                mark_circle_hours2(ctx, radius);
                drawWhiteNumbers(ctx, radius);
                timing_11_7();
              }
              // стрелки
              function timing_11_7() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;
                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 19) / 11,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 19) / 11
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(255, 255, 255, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(255, 255, 255, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              function mark_circle_hours2(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(255, 255, 255, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((10 * radius) / 11) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((10 * radius) / 11) * Math.sin(i),
                      4,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }

              //  секундные метки темно-серые точечные
              function mark_circle_seconds2() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(64, 64, 64, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 14) / 8;
                  var y1 = center_y + (Math.sin(angle) * 60 * 14) / 8;
                  ctx.arc(x1, y1, 4, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              // отрисовка цифр белые
              function drawWhiteNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function clock_11_7() {
                canvas = document.getElementById("canvas1-7");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "rgba(16, 16, 16, 1)";
                ctx.strokeStyle = "rgba(16, 16, 16, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-4 widget-date-11-5 dates-S">
        <p id="current-day-11-5"></p>
        <p id="current-month-11-5"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-11-5 {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            right: 16px;
            top: 278px;
          }
          .widget-date-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 140px;
            font-weight: 300;
          }
          .widget-date-11-5 p:nth-child(1) {
            line-height: 120px;
          }
          .widget-date-11-5 p:nth-child(2) {
            font-family: rubik;
            font-size: 32px;
            font-weight: 400;
          }
        </style>
        <script>
          const currentDay_11_5 = () => {
            let date = new Date();
            return \`\${date.getDate()}\`;
          };
          const currentMonth_11_5 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            return \`\${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-day-11-5").innerHTML =
              currentDay_11_5();
          }, 100);
          setInterval(() => {
            document.getElementById("current-month-11-5").innerHTML =
              currentMonth_11_5();
          }, 100);
        </script>
      </div>

      <div class="design-4 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            top: 540px;
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --style2: "";
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            right: 16px;
            top: 540px;
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>
      <div class="design-4 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: 16px;
            top: 671px;
          }
          .video img {
            width: 508px;
            height: 276px;
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-4 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: var(--size-4);
            height: 417px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 16px;
            bottom: 540px;
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid white;
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-metals-XL-11-1 metal-XL">
        <div>
          <p class="name-metal-11-1">Нефть</p>
          <p id="oil-divide-price-11-1">---,--</p>
          <p id="oil-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="oil-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Серебро</p>
          <p id="silver-divide-price-11-1">---,--</p>
          <p id="silver-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="silver-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Золото</p>
          <p id="gold-divide-price-11-1">---,--</p>
          <p id="gold-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="gold-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Платина</p>
          <p id="platinum-divide-price-11-1">---,--</p>
          <p id="platinum-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="platinum-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Палладий</p>
          <p id="palladium-divide-price-11-1">---,--</p>
          <p id="palladium-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="palladium-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            left: 16px;
            bottom: 278px;
          }
          .widget-metals-XL-11-1 div {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-1 {
            color: white;
            text-align: start;
            width: 129px;
          }
          .widget-metals-XL-11-1 div p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            width: 61px;
            text-align: end;
          }
          .widget-metals-XL-11-1 div p:nth-child(3) {
            color: rgba(115, 115, 115, 1);
            width: 80px;
            text-align: end;
          }
          .widget-metal-last-11-1 p {
            width: 125px;
            text-align: end;
          }
          .widget-metals-XL-11-1 img {
            width: 12px;
            height: 11px;
          }
          .space-div-8-1 {
            width: 6px;
          }
        </style>
        <script>
          const getOil_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-1").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-1-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-1").innerHTML = result[1];
                document.getElementById("oil-divide-price-11-1").innerHTML =
                  result[2];
                document.getElementById("oil-perc-price-11-1").innerHTML =
                  result[3];
              });
          };
          const getMetal_11_1 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-1").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-1-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-divide-price-11-1").innerHTML =
                  (new_silver_price - old_silver_price).toFixed(2);
                document.getElementById(
                  "silver-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_silver_price - old_silver_price) / new_silver_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("silver-price-11-1").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-1").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-1-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-divide-price-11-1").innerHTML = (
                  new_gold_price - old_gold_price
                ).toFixed(2);
                document.getElementById("gold-perc-price-11-1").innerHTML = \`\${(
                  ((new_gold_price - old_gold_price) / new_gold_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("gold-price-11-1").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-1"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-1-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById(
                  "platinum-divide-price-11-1"
                ).innerHTML = (new_gold_price - old_platinum_price).toFixed(2);
                document.getElementById(
                  "platinum-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_platinum_price - old_platinum_price) /
                    new_platinum_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("platinum-price-11-1").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-1"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-1-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById(
                  "palladium-divide-price-11-1"
                ).innerHTML = (
                  new_palladium_price - old_palladium_price
                ).toFixed(2);
                document.getElementById(
                  "palladium-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_palladium_price - old_palladium_price) /
                    new_palladium_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("palladium-price-11-1").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_1();
              getMetal_11_1();
            }, 172800000);
            getOil_11_1();
            getMetal_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            bottom: 147px;
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
      </div>

      <div class="design-4 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(0, 0, 0, 0.4);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            left: 16px;
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-9-2 {
            height: 16px;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: 540px;
      height: 1920px;
      position: relative;
      background-image: url("http://212.41.9.251:8000/static/background1.svg");
      background-size: cover;
      background-repeat: no-repeat;
    }
  </style>
</html>
`;

export const theme4hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 4 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-1 widget-analog-clock-M-11-7 analog-clock-M">
        <canvas id="canvas1-7" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: 246px;
              --background-widgets: rgba(30, 30, 30, 1);
            }
            .design-1 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-7 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              left: 16px;
              top: 16px;
            }
          </style>
          <script>
            analogClock_11_7();
            function analogClock_11_7() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_7();
              setInterval(drawClock_11_7, 100);
              function drawClock_11_7() {
                clock_11_7();
                mark_circle_seconds2();
                mark_circle_hours2(ctx, radius);
                drawWhiteNumbers(ctx, radius);
                timing_11_7();
              }
              // стрелки
              function timing_11_7() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;
                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 19) / 11,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 19) / 11
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(255, 255, 255, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(255, 255, 255, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              function mark_circle_hours2(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(255, 255, 255, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 +
                        ((90 * radius) / 100) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((90 * radius) / 100) * Math.sin(i),
                      4,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }

              //  секундные метки темно-серые точечные
              function mark_circle_seconds2() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(64, 64, 64, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 14) / 8;
                  var y1 = center_y + (Math.sin(angle) * 60 * 14) / 8;
                  ctx.arc(x1, y1, 4, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              // отрисовка цифр белые
              function drawWhiteNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function clock_11_7() {
                canvas = document.getElementById("canvas1-7");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "rgba(16, 16, 16, 1)";
                ctx.strokeStyle = "rgba(16, 16, 16, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-1 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            bottom: 16px;
            left: 16px;
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-calendar-XL-11-1 calendar-XL">
        <table id="calendar11-1">
          <thead>
            <tr>
              <td
                style="
                  font-weight: 500;
                  text-align: center;
                  width: 100%;
                  height: 100%;
                "
                colspan="7"
              ></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-11-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3: 377px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          #calendar11-1 {
            text-align: center;
            font-size: 26px;
            color: var(--text-color);
            font-weight: 300;
            border-spacing: 15px 5px;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .widget-calendar-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Rubik;
            width: var(--size-4);
            height: var(--size-3);
            position: absolute;
            left: 278px;
            top: 16px;
          }
          #today-11-1 {
            color: var(--background-widgets);
            background-color: var(--text-color);
            border-radius: 16px;
          }
          #body-calendar-11-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 50px;
          }
          thead tr td {
            width: 46px;
          }
        </style>

        <script>
          const getCalendar_11_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar11-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_11_1();
        </script>
      </div>

      <div class="design-1 widget-traffic-S-11-3 traffic-XS">
        <p id="current-traffic-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --style3: "";
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-S-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-1);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            left: 278px;
          }
          .widget-traffic-S-11-3 p {
            font-family: rubik;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 90px;
            background-color: var(--style3);
            border-radius: 50%;
            font-size: 70px;
            color: rgba(30, 30, 30, 1);
          }
        </style>
        <script>
          const getTraffic_11_3 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud3 = () => {
            let value = document.getElementById(
              "current-traffic-11-3"
            ).innerHTML;
            if (value == "10") {
              var style = \`rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style3\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-3").innerHTML =
            getTraffic_11_3();
          updateBackgroud3();
          setInterval(() => {
            document.getElementById("current-traffic-11-3").innerHTML =
              getTraffic_11_3();

            updateBackgroud3();
          }, 1800000);
        </script>
      </div>

      <div class="design-1 widget-rates-M-11-6 rates-S">
        <p>USD</p>
        <div class="space-div-7-6"></div>
        <p id="usd-11-6">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-6 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            left: 409px;
          }
          .widget-rates-M-11-6 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-6 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-6 {
            width: 14px;
          }
        </style>
        <script>
          const getUSD_11_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_11_6;
            }, 43200000);
            getUSD_11_6();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-rates-M-11-7 rates-S">
        <p>EUR</p>
        <div class="space-div-7-7"></div>
        <p id="eur-11-7">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            left: 671px;
          }
          .widget-rates-M-11-7 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-7 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-7 {
            width: 14px;
          }
        </style>
        <script>
          const getEUR_11_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-11-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_11_7;
            }, 43200000);
            getEUR_11_7();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-1 {
            width: 392px;
            height: 377px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: 16px;
            left: 802px;
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid white;
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: 447px;
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            right: 540px;
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
      </div>

      <div class="design-1 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            right: 16px;
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-9-2 {
            height: 16px;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>
      <div class="design-1 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            top: 16px;
            right: 16px;
          }
          .video img {
            width: 694px;
            height: 377px;
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: 1920px;
      height: 540px;
      background-color: rgba(16, 16, 16, 1);
      position: relative;
    }
  </style>
</html>
`;
export const theme4ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 4 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-1 widget-weather-XL-11-1 weather-XL">
        <div class="current-weather-11-1">
          <div>
            <p id="current-weather-11-1"></p>
            <p id="status-weather-11-1"></p>
          </div>
          <img id="current-status-img-11-1" src="" alt="" />
        </div>
        <div class="weather-per-day-11-1">
          <div>
            <img id="status-img-11-1-1" src="" alt="" />
            <p>Утро</p>
          </div>
          <div>
            <img id="status-img-11-1-2" src="" alt="" />
            <p>День</p>
          </div>
          <div>
            <img id="status-img-11-1-3" src="" alt="" />
            <p>Вечер</p>
          </div>
          <div>
            <img id="status-img-11-1-4" src="" alt="" />
            <p>Ночь</p>
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: 16px;
            left: 16px;
          }

          .current-weather-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .current-weather-11-1 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 70px;
            font-weight: 300;
            text-align: start;
          }
          .current-weather-11-1 p:nth-child(2) {
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .current-weather-11-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .weather-per-day-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .weather-per-day-11-1 p {
            font-family: rubik;
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .weather-per-day-11-1 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .weather-per-day-11-1 img {
            width: 46px;
            height: 46px;
          }
        </style>
        <script>
          const get_weather_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-1").innerHTML =
                  result[0][0];
                document.getElementById("status-weather-11-1").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-11-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-11-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-11-1-3")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][3][1]) {
                    document
                      .getElementById("status-img-11-1-4")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              get_weather_11_1;
            }, 300000);
            get_weather_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-1 widget-analog-clock-M-11-7 analog-clock-M">
        <canvas id="canvas1-7" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: 246px;
              --background-widgets: rgba(30, 30, 30, 1);
            }
            .design-1 {
              background-color: var(--background-widgets);
              border-radius: 32px;
              backdrop-filter: blur(60px);
            }
            .widget-analog-clock-M-11-7 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              left: 16px;
              top: 278px;
            }
          </style>
          <script>
            analogClock_11_7();
            function analogClock_11_7() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_7();
              setInterval(drawClock_11_7, 100);
              function drawClock_11_7() {
                clock_11_7();
                mark_circle_seconds2();
                mark_circle_hours2(ctx, radius);
                drawWhiteNumbers(ctx, radius);
                timing_11_7();
              }
              // стрелки
              function timing_11_7() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;
                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 19) / 11,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 19) / 11
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(255, 255, 255, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(255, 255, 255, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              function mark_circle_hours2(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(255, 255, 255, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((10 * radius) / 11) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((10 * radius) / 11) * Math.sin(i),
                      4,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }

              //  секундные метки темно-серые точечные
              function mark_circle_seconds2() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(64, 64, 64, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 14) / 8;
                  var y1 = center_y + (Math.sin(angle) * 60 * 14) / 8;
                  ctx.arc(x1, y1, 4, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              // отрисовка цифр белые
              function drawWhiteNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function clock_11_7() {
                canvas = document.getElementById("canvas1-7");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "rgba(16, 16, 16, 1)";
                ctx.strokeStyle = "rgba(16, 16, 16, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-1 widget-date-11-5 dates-S">
        <p id="current-day-11-5"></p>
        <p id="current-month-11-5"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-11-5 {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            right: 16px;
            top: 278px;
          }
          .widget-date-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 140px;
            font-weight: 300;
          }
          .widget-date-11-5 p:nth-child(1) {
            line-height: 120px;
          }
          .widget-date-11-5 p:nth-child(2) {
            font-family: rubik;
            font-size: 32px;
            font-weight: 400;
          }
        </style>
        <script>
          const currentDay_11_5 = () => {
            let date = new Date();
            return \`\${date.getDate()}\`;
          };
          const currentMonth_11_5 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            return \`\${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-day-11-5").innerHTML =
              currentDay_11_5();
          }, 100);
          setInterval(() => {
            document.getElementById("current-month-11-5").innerHTML =
              currentMonth_11_5();
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            top: 540px;
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --style2: "";
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            right: 16px;
            top: 540px;
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>
      <div class="design-1 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: 16px;
            top: 671px;
          }
          .video img {
            width: 508px;
            height: 276px;
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-1 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: var(--size-4);
            height: 417px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 16px;
            bottom: 540px;
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid white;
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-metals-XL-11-1 metal-XL">
        <div>
          <p class="name-metal-11-1">Нефть</p>
          <p id="oil-divide-price-11-1">---,--</p>
          <p id="oil-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="oil-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Серебро</p>
          <p id="silver-divide-price-11-1">---,--</p>
          <p id="silver-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="silver-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Золото</p>
          <p id="gold-divide-price-11-1">---,--</p>
          <p id="gold-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="gold-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Платина</p>
          <p id="platinum-divide-price-11-1">---,--</p>
          <p id="platinum-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="platinum-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Палладий</p>
          <p id="palladium-divide-price-11-1">---,--</p>
          <p id="palladium-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="palladium-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            left: 16px;
            bottom: 278px;
          }
          .widget-metals-XL-11-1 div {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-1 {
            color: white;
            text-align: start;
            width: 129px;
          }
          .widget-metals-XL-11-1 div p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            width: 61px;
            text-align: end;
          }
          .widget-metals-XL-11-1 div p:nth-child(3) {
            color: rgba(115, 115, 115, 1);
            width: 80px;
            text-align: end;
          }
          .widget-metal-last-11-1 p {
            width: 125px;
            text-align: end;
          }
          .widget-metals-XL-11-1 img {
            width: 12px;
            height: 11px;
          }
          .space-div-8-1 {
            width: 6px;
          }
        </style>
        <script>
          const getOil_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-1").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-1-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-1").innerHTML = result[1];
                document.getElementById("oil-divide-price-11-1").innerHTML =
                  result[2];
                document.getElementById("oil-perc-price-11-1").innerHTML =
                  result[3];
              });
          };
          const getMetal_11_1 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-1").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-1-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-divide-price-11-1").innerHTML =
                  (new_silver_price - old_silver_price).toFixed(2);
                document.getElementById(
                  "silver-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_silver_price - old_silver_price) / new_silver_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("silver-price-11-1").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-1").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-1-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-divide-price-11-1").innerHTML = (
                  new_gold_price - old_gold_price
                ).toFixed(2);
                document.getElementById("gold-perc-price-11-1").innerHTML = \`\${(
                  ((new_gold_price - old_gold_price) / new_gold_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("gold-price-11-1").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-1"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-1-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById(
                  "platinum-divide-price-11-1"
                ).innerHTML = (new_gold_price - old_platinum_price).toFixed(2);
                document.getElementById(
                  "platinum-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_platinum_price - old_platinum_price) /
                    new_platinum_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("platinum-price-11-1").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-1"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-1-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById(
                  "palladium-divide-price-11-1"
                ).innerHTML = (
                  new_palladium_price - old_palladium_price
                ).toFixed(2);
                document.getElementById(
                  "palladium-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_palladium_price - old_palladium_price) /
                    new_palladium_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("palladium-price-11-1").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_1;
              getMetal_11_1;
            }, 172800000);
            getOil_11_1();
            getMetal_11_1();
          }, 1000);
        </script>
      </div>
      <div class="design-1 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            bottom: 147px;
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
      </div>

      <div class="design-1 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            bottom: 16px;
            left: 16px;
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-9-2 {
            height: 16px;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: 540px;
      height: 1920px;
      position: relative;
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;

export const theme5hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 5 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-5 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            top: 16px;
            left: 16px;
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            color: var(--background-widgets);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы":
                    "http://212.41.9.251:8000/static/weather_thunderstorm.svg",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Небольшой дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: 246px;
              --background-widgets: rgba(208, 208, 208, 0.4);
            }
            .design-5 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              left: 16px;
              bottom: 16px;
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-5 widget-rates-M-11-6 rates-S">
        <p>USD</p>
        <div class="space-div-7-6"></div>
        <p id="usd-11-6">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-rates-M-11-6 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: 16px;
            left: 277px;
          }
          .widget-rates-M-11-6 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-6 p:first-child {
            color: var(--background-widgets);
          }
          .space-div-7-6 {
            width: 14px;
          }
        </style>
        <script>
          const getUSD_11_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_11_6;
            }, 43200000);
            getUSD_11_6();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-rates-M-11-7 rates-S">
        <p>EUR</p>
        <div class="space-div-7-7"></div>
        <p id="eur-11-7">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-rates-M-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: 277px;
            top: 147px;
          }
          .widget-rates-M-11-7 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-7 p:first-child {
            color: var(--background-widgets);
          }
          .space-div-7-7 {
            width: 14px;
          }
        </style>
        <script>
          const getEUR_11_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-11-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_11_7;
            }, 43200000);
            getEUR_11_7();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-date-11-5 dates-S">
        <p id="current-day-11-5"></p>
        <p id="current-month-11-5"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-date-11-5 {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: 277px;
            bottom: 16px;
          }
          .widget-date-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 140px;
            font-weight: 300;
          }
          .widget-date-11-5 p:nth-child(1) {
            line-height: 120px;
          }
          .widget-date-11-5 p:nth-child(2) {
            font-family: rubik;
            font-size: 32px;
            font-weight: 400;
          }
        </style>
        <script>
          const currentDay_11_5 = () => {
            let date = new Date();
            return \`\${date.getDate()}\`;
          };
          const currentMonth_11_5 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            return \`\${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-day-11-5").innerHTML =
              currentDay_11_5();
          }, 100);
          setInterval(() => {
            document.getElementById("current-month-11-5").innerHTML =
              currentMonth_11_5();
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-news-11-1 {
            width: 413px;
            height: 311px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: 16px;
            left: 539px;
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid white;
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>
      <div class="design-5 widget-about-company-11-4 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Заводской номер панели</p>
          <p>000000001</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-about-company-11-4 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: 413px;
            height: 180px;
            position: absolute;
            bottom: 16px;
            left: 539px;
          }
          .widget-about-company-11-4 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-4 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
          }
        </style>
      </div>
      <div class="design-5 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            top: 16px;
            right: 16px;
          }
          .video img {
            width: 936px;
            height: 507px;
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: 1920px;
      height: 540px;
      position: relative;
      background-image: url("http://212.41.9.251:8000/static/background2.svg");
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
    }
    .container::before {
      position: absolute;
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -o-transform: rotate(90deg);
      transform: rotate(90deg);
    }
  </style>
</html>
`;
export const theme5ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 5 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-5 widget-weather-XL-11-1 weather-XL">
        <div class="current-weather-11-1">
          <div>
            <p id="current-weather-11-1"></p>
            <p id="status-weather-11-1"></p>
          </div>
          <img id="current-status-img-11-1" src="" alt="" />
        </div>
        <div class="weather-per-day-11-1">
          <div>
            <img id="status-img-11-1-1" src="" alt="" />
            <p>Утро</p>
          </div>
          <div>
            <img id="status-img-11-1-2" src="" alt="" />
            <p>День</p>
          </div>
          <div>
            <img id="status-img-11-1-3" src="" alt="" />
            <p>Вечер</p>
          </div>
          <div>
            <img id="status-img-11-1-4" src="" alt="" />
            <p>Ночь</p>
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-weather-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: 16px;
            left: 16px;
          }

          .current-weather-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .current-weather-11-1 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 70px;
            font-weight: 300;
            text-align: start;
          }
          .current-weather-11-1 p:nth-child(2) {
            font-size: 26px;
            font-weight: 300;
            color: var(--background-widgets);
          }
          .current-weather-11-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .weather-per-day-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .weather-per-day-11-1 p {
            font-family: rubik;
            font-size: 26px;
            font-weight: 300;
            color: var(--background-widgets);
          }
          .weather-per-day-11-1 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .weather-per-day-11-1 img {
            width: 46px;
            height: 46px;
          }
        </style>
        <script>
          const get_weather_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-1").innerHTML =
                  result[0][0];
                document.getElementById("status-weather-11-1").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-11-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-11-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-11-1-3")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][3][1]) {
                    document
                      .getElementById("status-img-11-1-4")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              get_weather_11_1;
            }, 300000);
            get_weather_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-5 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: 246px;
              --background-widgets: rgba(208, 208, 208, 0.4);
            }
            .design-5 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              left: 16px;
              top: 278px;
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-5 widget-date-11-5 dates-S">
        <p id="current-day-11-5"></p>
        <p id="current-month-11-5"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-date-11-5 {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            right: 16px;
            top: 278px;
          }
          .widget-date-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 140px;
            font-weight: 300;
          }
          .widget-date-11-5 p:nth-child(1) {
            line-height: 120px;
          }
          .widget-date-11-5 p:nth-child(2) {
            font-family: rubik;
            font-size: 32px;
            font-weight: 400;
          }
        </style>
        <script>
          const currentDay_11_5 = () => {
            let date = new Date();
            return \`\${date.getDate()}\`;
          };
          const currentMonth_11_5 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            return \`\${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-day-11-5").innerHTML =
              currentDay_11_5();
          }, 100);
          setInterval(() => {
            document.getElementById("current-month-11-5").innerHTML =
              currentMonth_11_5();
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-rates-M-11-6 rates-S">
        <p>USD</p>
        <div class="space-div-7-6"></div>
        <p id="usd-11-6">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-rates-M-11-6 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            top: 540px;
          }
          .widget-rates-M-11-6 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-6 p:first-child {
            color: var(--background-widgets);
          }
          .space-div-7-6 {
            width: 14px;
          }
        </style>
        <script>
          const getUSD_11_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_11_6;
            }, 43200000);
            getUSD_11_6();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-rates-M-11-7 rates-S">
        <p>EUR</p>
        <div class="space-div-7-7"></div>
        <p id="eur-11-7">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-2: 246px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-rates-M-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            right: 16px;
            top: 540px;
          }
          .widget-rates-M-11-7 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-7 p:first-child {
            color: var(--background-widgets);
          }
          .space-div-7-7 {
            width: 14px;
          }
        </style>
        <script>
          const getEUR_11_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-11-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_11_7;
            }, 43200000);
            getEUR_11_7();
          }, 5000);
        </script>
      </div>
      <div class="design-5 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: 16px;
            top: 671px;
          }
          .video img {
            width: 509px;
            height: 272px;
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-5 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-news-11-1 {
            width: var(--size-4);
            height: 350px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 16px;
            top: 959px;
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid white;
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-metals-XL-11-1 metal-XL">
        <div>
          <p class="name-metal-11-1">Нефть</p>
          <p id="oil-divide-price-11-1">---,--</p>
          <p id="oil-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="oil-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Серебро</p>
          <p id="silver-divide-price-11-1">---,--</p>
          <p id="silver-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="silver-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Золото</p>
          <p id="gold-divide-price-11-1">---,--</p>
          <p id="gold-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="gold-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Платина</p>
          <p id="platinum-divide-price-11-1">---,--</p>
          <p id="platinum-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="platinum-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-1">Палладий</p>
          <p id="palladium-divide-price-11-1">---,--</p>
          <p id="palladium-perc-price-11-1">---,--</p>
          <div class="widget-metal-last-11-1">
            <p id="palladium-price-11-1">---,--</p>
            <div class="space-div-8-1"></div>
            <img
              id="updown-11-1-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: 246px;
            --size-4: 508px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            left: 16px;
            bottom: 343px;
          }
          .widget-metals-XL-11-1 div {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-1 {
            color: white;
            text-align: start;
            width: 129px;
          }
          .widget-metals-XL-11-1 div p:nth-child(2) {
            color: var(--background-widgets);
            width: 61px;
            text-align: end;
          }
          .widget-metals-XL-11-1 div p:nth-child(3) {
            color: var(--background-widgets);
            width: 80px;
            text-align: end;
          }
          .widget-metal-last-11-1 p {
            width: 125px;
            text-align: end;
          }
          .widget-metals-XL-11-1 img {
            width: 12px;
            height: 11px;
          }
          .space-div-8-1 {
            width: 6px;
          }
        </style>
        <script>
          const getOil_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-1").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-1-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-1").innerHTML = result[1];
                document.getElementById("oil-divide-price-11-1").innerHTML =
                  result[2];
                document.getElementById("oil-perc-price-11-1").innerHTML =
                  result[3];
              });
          };
          const getMetal_11_1 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-1").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-1-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-divide-price-11-1").innerHTML =
                  (new_silver_price - old_silver_price).toFixed(2);
                document.getElementById(
                  "silver-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_silver_price - old_silver_price) / new_silver_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("silver-price-11-1").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-1").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-1-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-divide-price-11-1").innerHTML = (
                  new_gold_price - old_gold_price
                ).toFixed(2);
                document.getElementById("gold-perc-price-11-1").innerHTML = \`\${(
                  ((new_gold_price - old_gold_price) / new_gold_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("gold-price-11-1").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-1"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-1-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById(
                  "platinum-divide-price-11-1"
                ).innerHTML = (new_gold_price - old_platinum_price).toFixed(2);
                document.getElementById(
                  "platinum-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_platinum_price - old_platinum_price) /
                    new_platinum_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("platinum-price-11-1").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-1"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-1-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-1-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById(
                  "palladium-divide-price-11-1"
                ).innerHTML = (
                  new_palladium_price - old_palladium_price
                ).toFixed(2);
                document.getElementById(
                  "palladium-perc-price-11-1"
                ).innerHTML = \`\${(
                  ((new_palladium_price - old_palladium_price) /
                    new_palladium_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("palladium-price-11-1").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_1;
              getMetal_11_1;
            }, 172800000);
            getOil_11_1();
            getMetal_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-5 widget-traffic-L-11-1 traffic-L">
        <p>Пробки</p>
        <div class="space-div-5-1"></div>
        <p id="current-traffic-11-1"></p>
        <div class="space-div-5-1"></div>
        <p>баллов</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --style: "";
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-traffic-L-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: 16px;
            bottom: 212px;
          }
          .widget-traffic-L-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-L-11-1 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style);
            border-radius: 50%;
          }
          .space-div-5-1 {
            width: 16px;
          }
        </style>
        <script>
          const getTraffic_11_1 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud = () => {
            let value = document.getElementById(
              "current-traffic-11-1"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-1").innerHTML =
            getTraffic_11_1();
          updateBackgroud();
          setInterval(() => {
            document.getElementById("current-traffic-11-1").innerHTML =
              getTraffic_11_1();

            updateBackgroud();
          }, 1800000);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-4 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Заводской номер панели</p>
          <p>000000001</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: 115px;
            --size-4: 508px;
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(50px);
          }
          .widget-about-company-11-4 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: 180px;
            position: absolute;
            bottom: 16px;
            left: 16px;
          }
          .widget-about-company-11-4 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-4 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: 540px;
      height: 1920px;
      background-image: url("http://212.41.9.251:8000/static/background2.svg");
      background-size: cover;
      background-repeat: no-repeat;
    }
  </style>
</html>
`;

export const theme6hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 6 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-2 widget-analog-clock-16-4 analog-clock-M">
        <canvas id="canvas16-4" width="250px" height="250px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2-2: 252px;
              --background-widgets: rgba(30, 30, 30, 1);
            }
            .design-2 {
              background-color: var(--background-widgets);
              border-radius: 26px;
            }
            .widget-analog-clock-16-4 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2-2);
              height: var(--size-2-2);
              position: absolute;
              top: 12px;
              left: 12px;
            }
          </style>
          <script>
            analogClock16_4();
            function analogClock16_4() {
              let center_x = 125;
              let center_y = 125;
              let radius = 117;
              pi = Math.PI;
              drawClock16_4();
              setInterval(drawClock16_4, 100);

              function drawClock16_4() {
                clock16_4();
                drawWBlackNumbers(ctx, radius);
                timing16_4();
              }
              // стрелки
              function timing16_4() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 5;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.4,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.4
                );
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 5;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.7,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.7
                );
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.strokeStyle = "rgb(57, 182, 251, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(57, 182, 251, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 8, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(255, 255, 255, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 5, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // отрисовка цифры белые
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "white";
                ctx.font = radius * 0.18 + "px Montserrat";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.85);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.85);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock16_4() {
                canvas = document.getElementById("canvas16-4");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 3;
                ctx.fillStyle = "rgba(30, 30, 30, 1)";
                ctx.strokeStyle = "rgba(57, 182, 251, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-2 widget-weather-16-1 weather-XL">
        <div class="current-weather-16-1">
          <img id="current-status-img-16-1" src="" alt="" />
          <p id="current-status-16-1"></p>
          <p id="current-weather-16-1"></p>
        </div>
        <div class="time-16-1">
          <div>
            <p>04:00</p>
            <p>12:00</p>
            <p>20:00</p>
          </div>
          <div>
            <img id="status-img-16-1-1" src="" alt="" />
            <img id="status-img-16-1-2" src="" alt="" />
            <img id="status-img-16-1-3" src="" alt="" />
          </div>
          <div>
            <p id="weather-16-1-1"></p>
            <p id="weather-16-1-2"></p>
            <p id="weather-16-1-3"></p>
          </div>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: 252px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .space-div-13-1 {
            width: 91px;
          }
          .widget-weather-16-1 {
            display: flex;
            justify-content: space-evenly;
            width: var(--size-4-2);
            height: var(--size-2-2);
            position: absolute;
            bottom: 12px;
            left: 12px;
          }
          .current-weather-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .current-weather-16-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }

          .current-weather-16-1 p {
            color: white;
            font-size: 70px;
            font-weight: 100;
            font-family: Montserrat;
          }
          .current-weather-16-1 p:nth-child(2) {
            font-size: 26px;
            color: rgba(115, 115, 115, 1);
          }
          .time-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 320px;
            color: white;
            font-size: 26px;
            font-family: Montserrat;
            font-weight: 400;
          }
          .time-16-1 div {
            display: flex;
            justify-content: space-evenly;
          }
          .time-16-1 img {
            width: 60px;
            height: 60px;
          }
        </style>
        <script>
          const getWeather16_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-16-1").innerHTML =
                  result[0][0];
                document.getElementById("current-status-16-1").innerHTML =
                  result[0][1];
                document.getElementById("weather-16-1-1").innerHTML =
                  result[1][0][0];
                document.getElementById("weather-16-1-2").innerHTML =
                  result[1][1][0];
                document.getElementById("weather-16-1-3").innerHTML =
                  result[1][3][0];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-16-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-16-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-16-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-16-1-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getWeather16_1;
            }, 30000);
            getWeather16_1();
          }, 1000);
        </script>
      </div>

      <div class="design-2 widget-date-16-3 dates-M">
        <p id="previous-date-16-3-2"></p>
        <p id="previous-date-16-3-1"></p>
        <p id="current-date-16-3"></p>
        <p id="next-date-16-3-1"></p>
        <p id="next-date-16-3-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: 252px;
            --size-3-2: 384px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-date-16-3 {
            display: flex;
            justify-content: space-evenly;
            flex-direction: column;
            align-items: center;
            width: var(--size-3-2);
            height: var(--size-2-2);
            position: absolute;
            top: 12px;
            left: 276px;
          }
          .widget-date-16-3 p {
            font-family: Montserrat;
            color: rgba(64, 64, 64, 1);
            font-size: 20px;
          }
          .widget-date-16-3 p:nth-child(3) {
            color: white;
            font-size: 26px;
          }
        </style>
        <script>
          const currentDate_16_3 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };

          const previous_date_16_3_1 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() - 1);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const previous_date_16_3_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() - 2);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const next_date_16_3_1 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() + 1);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const next_date_16_3_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() + 2);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };

          setInterval(() => {
            document.getElementById("current-date-16-3").innerHTML =
              currentDate_16_3();
            document.getElementById("previous-date-16-3-1").innerHTML =
              previous_date_16_3_1();
            document.getElementById("previous-date-16-3-2").innerHTML =
              previous_date_16_3_2();
            document.getElementById("next-date-16-3-1").innerHTML =
              next_date_16_3_1();
            document.getElementById("next-date-16-3-2").innerHTML =
              next_date_16_3_2();
          }, 100);
        </script>
      </div>

      <div class="design-2 widget-traffic-16-5 traffic-XS">
        <canvas id="canvas16-7" width="120px" height="120px"></canvas>
        <p id="current-traffic-16-5"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: 120px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          #current-traffic-16-5 {
            position: absolute;
            font-size: 70px;
            font-family: Montserrat;
            font-weight: 200;
            color: white;
          }
          .widget-traffic-16-5 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-1-2);
            height: var(--size-1 -2);
            position: absolute;
            top: 276px;
            left: 540px;
          }
          .widget-traffic-16-5 div:nth-child(2) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 60px;
            border: 3px solid rgba(57, 182, 251, 1);
            border-radius: 50%;
          }
          .widget-traffic-16-5 div p {
            font-size: 30px;
            font-family: Montserrat;
            color: white;
          }
        </style>
        <script>
          const getTraffic_16_5 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };

          document.getElementById("current-traffic-16-5").innerHTML =
            getTraffic_16_5();
          setInterval(() => {
            document.getElementById("current-traffic-16-5").innerHTML =
              getTraffic_16_5();
          }, 1800000);
          traffic3();
          function traffic3() {
            canvas = document.getElementById("canvas16-7");
            ctx = canvas.getContext("2d");
            ctx.beginPath(); // начало нового пути
            ctx.lineWidth = 3;
            ctx.strokeStyle = "rgba(57, 182, 251, 1)";
            // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
            ctx.arc(60, 60, 52, 0 - (5 * Math.PI) / 6, 0 - Math.PI / 6, false);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath(); // начало нового пути
            ctx.lineWidth = 3;
            ctx.strokeStyle = "rgba(57, 182, 251, 1)";
            // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
            ctx.arc(
              60,
              87,
              69,
              0 - (73 * Math.PI) / 100,
              0 - (28 * Math.PI) / 100,
              false
            );
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath(); // начало нового пути
            ctx.lineWidth = 3;
            ctx.strokeStyle = "rgba(255, 255, 255, 1)";
            // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
            ctx.arc(60, 60, 52, 0 - Math.PI / 8, Math.PI + Math.PI / 8, false);
            ctx.stroke();
            ctx.closePath();
          }
        </script>
      </div>

      <div class="design-2 widget-rates-16-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-16-5"></div>
          <p id="usd-16-5">0.00</p>
        </div>

        <div>
          <p>EUR</p>
          <div class="space-div-16-5"></div>
          <p id="eur-16-5">0.00</p>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: 120px;
            --size-2-2: 252px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-rates-16-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            width: var(--size-2-2);
            height: var(--size-1-2);
            position: absolute;
            left: 540px;
            bottom: 12px;
          }
          .widget-rates-16-5 div {
            display: flex;
            justify-content: space-around;
            font-size: 30px;
            font-family: Montserrat;
          }
          .widget-rates-16-5 div p:nth-child(1) {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-16-5 div p:nth-child(3) {
            color: white;
          }
          .space-div-16-5 {
            width: 26px;
          }
        </style>
        <script>
          const getUSD_EUR_16_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-16-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-16-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_16_5;
            }, 43200000);
            getUSD_EUR_16_5();
          }, 10000);
        </script>
      </div>

      <div class="design-2 widget-news-16-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: 252px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-news-16-1 {
            width: 541px;
            height: 384px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: 12px;
            left: 672px;
          }
          .widget-news-16-1 p {
            color: white;
            font-family: Montserrat;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const getNews_16_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-16-1").innerHTML = news[0];
                document.getElementById("header-news-16-2").innerHTML = news[1];
                document.getElementById("header-news-16-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_16_1();
            }, 300000);
            getNews_16_1();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: 120px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: 576px;
            height: var(--size-1-2);
            position: absolute;
            bottom: 12px;
            right: 540px;
          }
          .widget-about-company-16-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-16-1 p {
            font-family: Montserrat;
            color: white;
            font-size: 20px;
            font-weight: 400;
          }
          .widget-about-company-16-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
      </div>

      <div class="design-2 widget-about-company-16-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-18-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: 120px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4-2);
            height: var(--size-1-2);
            position: absolute;
            right: 12px;
            bottom: 12px;
          }
          .widget-about-company-16-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-18-2 {
            height: 16px;
          }
          .widget-about-company-16-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>
      <div class="design-2 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            top: 12px;
            right: 12px;
          }
          .video img {
            width: 683px;
            height: 384px;
            border-radius: 26px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: 1920px;
      height: 540px;
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;
export const theme6ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 6 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-2 widget-weather-16-1 weather-XL">
        <div class="current-weather-16-1">
          <img id="current-status-img-16-1" src="" alt="" />
          <p id="current-status-16-1"></p>
          <p id="current-weather-16-1"></p>
        </div>
        <div class="time-16-1">
          <div>
            <p>04:00</p>
            <p>12:00</p>
            <p>20:00</p>
          </div>
          <div>
            <img id="status-img-16-1-1" src="" alt="" />
            <img id="status-img-16-1-2" src="" alt="" />
            <img id="status-img-16-1-3" src="" alt="" />
          </div>
          <div>
            <p id="weather-16-1-1"></p>
            <p id="weather-16-1-2"></p>
            <p id="weather-16-1-3"></p>
          </div>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: 252px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-weather-16-1 {
            display: flex;
            justify-content: space-evenly;
            width: var(--size-4-2);
            height: var(--size-2-2);
            position: absolute;
            top: 12px;
            left: 12px;
          }
          .current-weather-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .current-weather-16-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }

          .current-weather-16-1 p {
            color: white;
            font-size: 70px;
            font-weight: 100;
            font-family: Montserrat;
          }
          .current-weather-16-1 p:nth-child(2) {
            font-size: 26px;
            color: rgba(115, 115, 115, 1);
          }
          .time-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 320px;
            color: white;
            font-size: 26px;
            font-family: Montserrat;
            font-weight: 400;
          }
          .time-16-1 div {
            display: flex;
            justify-content: space-evenly;
          }
          .time-16-1 img {
            width: 60px;
            height: 60px;
          }
        </style>
        <script>
          const getWeather16_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-16-1").innerHTML =
                  result[0][0];
                document.getElementById("current-status-16-1").innerHTML =
                  result[0][1];
                document.getElementById("weather-16-1-1").innerHTML =
                  result[1][0][0];
                document.getElementById("weather-16-1-2").innerHTML =
                  result[1][1][0];
                document.getElementById("weather-16-1-3").innerHTML =
                  result[1][3][0];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-16-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-16-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-16-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-16-1-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getWeather16_1;
            }, 30000);
            getWeather16_1();
          }, 1000);
        </script>
      </div>

      <div class="design-2 widget-digital-clock-16-1 digital-clock-XL">
        <p id="hour-minutes16-1"></p>
        <p id="seconds16-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: 252px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-digital-clock-16-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4-2);
            height: var(--size-2-2);
            position: absolute;
            top: 276px;
            left: 12px;
          }
          .widget-digital-clock-16-1 p {
            font-family: Montserrat;
            font-size: 130px;
            font-weight: 100;
            background-image: linear-gradient(
              0deg,
              rgba(57, 182, 251, 1) 0%,
              rgba(57, 182, 251, 1) 50%,
              rgba(255, 255, 251, 1) 50%,
              rgba(255, 255, 251, 1) 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
          }
          .widget-digital-clock-16-1 p:nth-child(1) {
            width: 365px;
            text-align: center;
          }
          .widget-digital-clock-16-1 p:nth-child(2) {
            width: 93px;
            margin-top: 50px;
            font-size: 70px;
            color: var(--actent-color);
            text-align: center;
          }
        </style>
        <script>
          setInterval(function setTime_16_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes16-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds16-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-2 widget-date-16-2 dates-L">
        <p id="current-day-16-2"></p>
        <div class="space-div-11-1"></div>
        <p id="current-date-16-2"></p>
        <div class="space-div-11-1"></div>
        <p id="current-month-16-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: 120px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-date-16-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4-2);
            height: var(--size-1-2);
            position: absolute;
            left: 12px;
            top: 540px;
          }
          .widget-date-16-2 p {
            font-family: Montserrat;
            color: white;
            font-size: 26px;
          }
          .space-div-11-1 {
            width: 8px;
          }
          .widget-date-16-2 p:nth-child(3) {
            height: 30px;
            text-decoration: underline 2px rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const currentDay_16_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}, \`;
          };
          const currentDate_16_2 = () => {
            let date = new Date();
            return \`\${date.getDate()}\`;
          };
          const currentMonth_16_2 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            return \`\${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-day-16-2").innerHTML =
              currentDay_16_2();
            document.getElementById("current-date-16-2").innerHTML =
              currentDate_16_2();
            document.getElementById("current-month-16-2").innerHTML =
              currentMonth_16_2();
          }, 100);
        </script>
      </div>
      <div class="design-2 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: 12px;
            top: 672px;
          }
          .video img {
            width: 516px;
            height: 290px;
            border-radius: 26px;
          }
        </style>
      </div>

      <div class="design-2 widget-rates-16-6 rates-S">
        <p id="usd-16-6">0.00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: 120px;
            --size-2-2: 252px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-rates-16-6 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-2-2);
            height: var(--size-1-2);
            background-image: url("http://212.41.9.251:8000/static/\$.svg");
            background-repeat: no-repeat;
            background-size: contain;
            position: absolute;
            left: 12px;
            top: 974px;
          }
          .widget-rates-16-6 p {
            font-size: 70px;
            font-family: Montserrat;
            color: white;
            font-weight: 200;
          }
        </style>
        <script>
          const getUSD_16_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-16-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_16_6;
            }, 43200000);
            getUSD_16_6();
          }, 10000);
        </script>
      </div>

      <div class="design-2 widget-rates-16-7 rates-S">
        <p id="eur-16-7">0.00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: 120px;
            --size-2-2: 252px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-rates-16-7 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-2-2);
            height: var(--size-1-2);
            background-image: url("http://212.41.9.251:8000/static/€.svg");
            background-repeat: no-repeat;
            background-size: contain;
            position: absolute;
            right: 12px;
            top: 974px;
          }
          .widget-rates-16-7 p {
            font-size: 70px;
            font-family: Montserrat;
            color: white;
            font-weight: 200;
          }
        </style>
        <script>
          const getEUR_16_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-16-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_16_7;
            }, 43200000);
            getEUR_16_7();
          }, 10000);
        </script>
      </div>

      <div class="design-2 widget-news-16-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: 252px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-news-16-1 {
            width: var(--size-4-2);
            height: 408px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 12px;
            top: 1106px;
          }
          .widget-news-16-1 p {
            color: white;
            font-family: Montserrat;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const getNews_16_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-16-1").innerHTML = news[0];
                document.getElementById("header-news-16-2").innerHTML = news[1];
                document.getElementById("header-news-16-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_16_1();
            }, 300000);
            getNews_16_1();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-metals-16-2 metal-L">
        <div>
          <p class="name-metal-16-2">Нефть</p>
          <p id="oil-divide-price-16-2">---,--</p>
          <p id="oil-perc-price-16-2">---,--</p>
          <div class="widget-metal-last-16-2">
            <p id="oil-price-16-2">---,--</p>
            <div class="space-div-17-2"></div>
            <img
              id="updown-16-2-1"
              src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-16-2">Серебро</p>
          <p id="silver-divide-price-16-2">---,--</p>
          <p id="silver-perc-price-16-2">---,--</p>
          <div class="widget-metal-last-16-2">
            <p id="silver-price-16-2">---,--</p>
            <div class="space-div-17-2"></div>
            <img
              id="updown-16-2-2"
              src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-16-2">Золото</p>
          <p id="gold-divide-price-16-2">---,--</p>
          <p id="gold-perc-price-16-2">---,--</p>
          <div class="widget-metal-last-16-2">
            <p id="gold-price-16-2">---,--</p>
            <div class="space-div-17-2"></div>
            <img
              id="updown-16-2-3"
              src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
            />
          </div>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: 120px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-metals-16-2 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4-2);
            height: var(--size-1-2);
            position: absolute;
            left: 12px;
            bottom: 276px;
          }

          .widget-metals-16-2 div {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            color: white;
            font-family: Montserrat;
            font-size: 20px;
          }
          .name-metal-16-2 {
            color: white;
            text-align: start;
            width: 106px;
          }
          .widget-metals-16-2 div p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            width: 61px;
            text-align: end;
          }
          .widget-metals-16-2 div p:nth-child(3) {
            color: rgba(115, 115, 115, 1);
            width: 80px;
            text-align: end;
          }
          .widget-metals-16-2 div p:nth-child(4) {
            width: 100px;
            text-align: end;
          }

          .widget-metals-16-2 div img {
            width: 18px;
            height: 14px;
          }
          .widget-metal-last-16-2 p {
            width: 108px;
            text-align: end;
          }
          .space-div-17-2 {
            width: 6px;
          }
        </style>
        <script>
          const getOil_16_2 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-16-2").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-16-2-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-16-2-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                    );
                }
                document.getElementById("oil-price-16-2").innerHTML = result[1];
                document.getElementById("oil-divide-price-16-2").innerHTML =
                  result[2];
                document.getElementById("oil-perc-price-16-2").innerHTML =
                  result[3];
              });
          };

          const getMetal_16_2 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-16-2").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-16-2-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-16-2-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                    );
                }
                document.getElementById("silver-divide-price-16-2").innerHTML =
                  (new_silver_price - old_silver_price).toFixed(2);
                document.getElementById(
                  "silver-perc-price-16-2"
                ).innerHTML = \`\${(
                  ((new_silver_price - old_silver_price) / new_silver_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("silver-price-16-2").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-16-2").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-16-2-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-16-2-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                    );
                }
                document.getElementById("gold-divide-price-16-2").innerHTML = (
                  new_gold_price - old_gold_price
                ).toFixed(2);
                document.getElementById("gold-perc-price-16-2").innerHTML = \`\${(
                  ((new_gold_price - old_gold_price) / new_gold_price) *
                  100
                ).toFixed(2)}%\`;
                document.getElementById("gold-price-16-2").innerHTML =
                  result.rates.USDXAU.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_16_2();
              getMetal_16_2();
            }, 172800000);
            getOil_16_2();
            getMetal_16_2();
          }, 1000);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-18-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: 120px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4-2);
            height: var(--size-1-2);
            position: absolute;
            left: 12px;
            bottom: 144px;
          }
          .widget-about-company-16-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-18-2 {
            height: 16px;
          }
          .widget-about-company-16-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>

      <div class="design-2 widget-about-company-16-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <p>Meteor</p>
        </div>
        <div>
          <p>Телефон поддержки</p>
          <p>+7(800)555-35-35</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: 120px;
            --size-4-2: 516px;
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4-2);
            height: var(--size-1-2);
            position: absolute;
            left: 12px;
            bottom: 12px;
          }
          .widget-about-company-16-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-16-1 p {
            font-family: Montserrat;
            color: white;
            font-size: 20px;
            font-weight: 400;
          }
          .widget-about-company-16-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: 540px;
      height: 1920px;
      position: relative;
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;

export const theme7hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 7 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-2 widget-analog-clock-16-4 analog-clock-M">
        <canvas id="canvas16-4" width="250px" height="250px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2-2: calc(252px * 2);
              --background-widgets: rgba(30, 30, 30, 1);
            }
            .design-2 {
              background-color: var(--background-widgets);
              border-radius: 26px;
            }
            .widget-analog-clock-16-4 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2-2);
              height: var(--size-2-2);
              position: absolute;
              top: calc(12px * 2);
              left: calc(12px * 2);
            }
          </style>
          <script>
            analogClock16_4();
            function analogClock16_4() {
              let center_x = 125;
              let center_y = 125;
              let radius = 117;
              pi = Math.PI;
              drawClock16_4();
              setInterval(drawClock16_4, 100);

              function drawClock16_4() {
                clock16_4();
                drawWBlackNumbers(ctx, radius);
                timing16_4();
              }
              // стрелки
              function timing16_4() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 5;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.4,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.4
                );
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 5;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.7,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.7
                );
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.strokeStyle = "rgb(57, 182, 251, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(57, 182, 251, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 8, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(255, 255, 255, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 5, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // отрисовка цифры белые
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "white";
                ctx.font = radius * 0.18 + "px Montserrat";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.85);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.85);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock16_4() {
                canvas = document.getElementById("canvas16-4");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 3;
                ctx.fillStyle = "rgba(30, 30, 30, 1)";
                ctx.strokeStyle = "rgba(57, 182, 251, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-2 widget-weather-16-3 weather-M">
        <div>
          <img id="current-status-img-16-3" src="" alt="" />
          <p id="current-status-16-3"></p>
          <p id="current-weather-16-3"></p>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-weather-16-3 {
            display: flex;
            width: var(--size-2-2);
            height: var(--size-2-2);
            justify-content: center;
            text-align: start;
            position: absolute;
            top: calc(12px * 2);
            left: calc(276px * 2);
          }
          .widget-weather-16-3 div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 10px;
          }
          .widget-weather-16-3 p {
            font-family: Montserrat;
            font-weight: 100;
            font-size: 70px;
            color: white;
          }
          .widget-weather-16-3 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .widget-weather-16-3 p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            font-size: 30px;
          }
        </style>
        <script>
          const getWeather16_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-16-3").innerHTML =
                  result[0][0];
                document.getElementById("current-status-16-3").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-16-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getWeather16_3;
            }, 30000);
            getWeather16_3();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-traffic-16-3 traffic-M">
        <p>Пробки</p>
        <div class="space-div-14-3"></div>
        <div>
          <p id="current-traffic-16-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-2-2: calc(252px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-traffic-16-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(269px * 2);
            height: var(--size-1-2);
            position: absolute;
            top: calc(12px * 2);
            left: calc(540px * 2);
          }
          .widget-traffic-16-3 p {
            font-family: Montserrat;
            font-weight: 200;
            color: white;
            font-size: 32px;
          }
          .widget-traffic-16-3 div:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 76px;
            height: 76px;
            border: 3px solid rgba(57, 182, 251, 1);
            border-radius: 50%;
          }
          .widget-traffic-16-3 div p {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 70px;
          }
          .space-div-14-3 {
            width: 13px;
          }
        </style>
        <script>
          const getTraffic_16_3 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };

          document.getElementById("current-traffic-16-3").innerHTML =
            getTraffic_16_3();
          setInterval(() => {
            document.getElementById("current-traffic-16-3").innerHTML =
              getTraffic_16_3();
          }, 1800000);
        </script>
      </div>

      <div class="design-2 widget-rates-16-5 rates-M">
        <div>
          <p>USD</p>
          <div class="space-div-16-5"></div>
          <p id="usd-16-5">0,00</p>
        </div>

        <div>
          <p>EUR</p>
          <div class="space-div-16-5"></div>
          <p id="eur-16-5">0,00</p>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-2-2: calc(252px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-rates-16-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            width: calc(269px * 2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(540px * 2);
            top: calc(144px * 2);
          }
          .widget-rates-16-5 div {
            display: flex;
            justify-content: space-around;
            font-size: 30px;
            font-family: Montserrat;
          }
          .widget-rates-16-5 div p:nth-child(1) {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-16-5 div p:nth-child(3) {
            color: white;
          }
          .space-div-16-5 {
            width: 26px;
          }
        </style>
        <script>
          const getUSD_EUR_16_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-16-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-16-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_16_5;
            }, 43200000);
            getUSD_EUR_16_5();
          }, 10000);
        </script>
      </div>

      <div class="design-2 widget-date-16-7 dates-XS">
        <p id="current-day-16-7"></p>
        <div class="space-div-12-7"></div>
        <p id="current-month-16-7"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-2-2: calc(252px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-date-16-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2-2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 2);
            top: calc(276px * 2);
          }
          .widget-date-16-7 p {
            font-size: 26px;
            font-weight: 300;
            font-family: Montserrat;
            color: white;
          }
          .widget-date-16-7 p:nth-child(1) {
            text-decoration: underline 2px rgba(57, 182, 251, 1);
          }
          .space-div-12-7 {
            width: 8px;
          }
        </style>
        <script>
          const current_day_16_7 = () => {
            let date = new Date();
            return \`\${date.getDate()}\`;
          };

          const current_month_16_7 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${month[date.getMonth()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-day-16-7").innerHTML =
              current_day_16_7();
            document.getElementById("current-month-16-7").innerHTML =
              current_month_16_7();
          }, 100);
        </script>
      </div>

      <div class="design-2 widget-date-16-8 dates-XS">
        <p id="current-day-16-8"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-2-2: calc(252px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-date-16-8 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2-2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 2);
            top: calc(408px * 2);
          }
          .widget-date-16-8 p {
            font-size: 26px;
            font-weight: 300;
            font-family: Montserrat;
            color: white;
          }
        </style>
        <script>
          const current_day_16_8 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-day-16-8").innerHTML =
              current_day_16_8();
          }, 100);
        </script>
      </div>

      <div class="design-2 widget-news-16-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 2);
            --size-4-2: calc(516px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-news-16-1 {
            width: calc(533px * 2);
            height: var(--size-2-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: calc(276px * 2);
            left: calc(276px * 2);
          }
          .widget-news-16-1 p {
            color: white;
            font-family: Montserrat;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const getNews_16_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  console.log(item);
                  return item.length < 70;
                });
                document.getElementById("header-news-16-1").innerHTML = news[0];
                document.getElementById("header-news-16-2").innerHTML = news[1];
                document.getElementById("header-news-16-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_16_1();
            }, 300000);
            getNews_16_1();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-18-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-4-2: calc(516px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(447px * 2);
            height: var(--size-1-2);
            position: absolute;
            top: calc(408px * 2);
            left: calc(821px * 2);
          }
          .widget-about-company-16-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-18-2 {
            height: 16px;
          }
          .widget-about-company-16-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>

      <div class="design-2 widget-about-company-16-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-4-2: calc(516px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(447px * 2);
            height: var(--size-1-2);
            position: absolute;
            top: calc(276px * 2);
            left: calc(821px * 2);
          }
          .widget-about-company-16-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-16-1 p {
            font-family: Montserrat;
            color: white;
            font-size: 20px;
            font-weight: 400;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-16-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>
      <div class="design-2 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            top: calc(12px * 2);
            left: calc(821px * 2);
          }
          .video img {
            width: calc(448px * 2);
            height: calc(252px * 2);
            border-radius: 26px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1280px * 2);
      height: calc(540px * 2);
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;
export const theme7ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 7 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-2 widget-analog-clock-16-4 analog-clock-M">
        <canvas id="canvas16-4" width="250px" height="250px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2-2: calc(252px * 2);
              --background-widgets: rgba(30, 30, 30, 1);
            }
            .design-2 {
              background-color: var(--background-widgets);
              border-radius: 26px;
            }
            .widget-analog-clock-16-4 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2-2);
              height: var(--size-2-2);
              position: absolute;
              top: calc(12px * 2);
              left: calc(12px * 2);
            }
          </style>
          <script>
            analogClock16_4();
            function analogClock16_4() {
              let center_x = 125;
              let center_y = 125;
              let radius = 117;
              pi = Math.PI;
              drawClock16_4();
              setInterval(drawClock16_4, 100);

              function drawClock16_4() {
                clock16_4();
                drawWBlackNumbers(ctx, radius);
                timing16_4();
              }
              // стрелки
              function timing16_4() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 5;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.4,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.4
                );
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 5;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.7,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.7
                );
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.strokeStyle = "rgb(57, 182, 251, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(57, 182, 251, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 8, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(255, 255, 255, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 5, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // отрисовка цифры белые
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "white";
                ctx.font = radius * 0.18 + "px Montserrat";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.85);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.85);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock16_4() {
                canvas = document.getElementById("canvas16-4");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 3;
                ctx.fillStyle = "rgba(30, 30, 30, 1)";
                ctx.strokeStyle = "rgba(57, 182, 251, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-2 widget-weather-16-3 weather-M">
        <div>
          <img id="current-status-img-16-3" src="" alt="" />
          <p id="current-status-16-3"></p>
          <p id="current-weather-16-3"></p>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-weather-16-3 {
            display: flex;
            width: var(--size-2-2);
            height: var(--size-2-2);
            justify-content: center;
            text-align: start;
            position: absolute;
            top: calc(12px * 2);
            left: calc(276px * 2);
          }
          .widget-weather-16-3 div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 10px;
          }
          .widget-weather-16-3 p {
            font-family: Montserrat;
            font-weight: 100;
            font-size: 70px;
            color: white;
          }
          .widget-weather-16-3 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .widget-weather-16-3 p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            font-size: 30px;
          }
        </style>
        <script>
          const getWeather16_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-16-3").innerHTML =
                  result[0][0];
                document.getElementById("current-status-16-3").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-16-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getWeather16_3;
            }, 30000);
            getWeather16_3();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-date-16-2 dates-L">
        <p id="current-day-16-2"></p>
        <div class="space-div-11-1"></div>
        <p id="current-date-16-2"></p>
        <div class="space-div-11-1"></div>
        <p id="current-month-16-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-4-2: calc(516px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-date-16-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4-2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 2);
            top: calc(276px * 2);
          }
          .widget-date-16-2 p {
            font-family: Montserrat;
            color: white;
            font-size: 26px;
          }
          .space-div-11-1 {
            width: 8px;
          }
          .widget-date-16-2 p:nth-child(3) {
            height: 30px;
            text-decoration: underline 2px rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const currentDay_16_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}, \`;
          };
          const currentDate_16_2 = () => {
            let date = new Date();
            return \`\${date.getDate()}\`;
          };
          const currentMonth_16_2 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            return \`\${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-day-16-2").innerHTML =
              currentDay_16_2();
            document.getElementById("current-date-16-2").innerHTML =
              currentDate_16_2();
            document.getElementById("current-month-16-2").innerHTML =
              currentMonth_16_2();
          }, 100);
        </script>
      </div>
      <div class="design-2 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(12px * 2);
            top: calc(408px * 2);
          }
          .video img {
            width: calc(516px * 2);
            height: calc(290px * 2);
            border-radius: 26px;
          }
        </style>
      </div>

      <div class="design-2 widget-traffic-16-3 traffic-M">
        <p>Пробки</p>
        <div class="space-div-14-3"></div>
        <div>
          <p id="current-traffic-16-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-2-2: calc(252px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-traffic-16-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2-2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 2);
            top: calc(714px * 2);
          }
          .widget-traffic-16-3 p {
            font-family: Montserrat;
            font-weight: 200;
            color: white;
            font-size: 32px;
          }
          .widget-traffic-16-3 div:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 76px;
            height: 76px;
            border: 3px solid rgba(57, 182, 251, 1);
            border-radius: 50%;
          }
          .widget-traffic-16-3 div p {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 70px;
          }
          .space-div-14-3 {
            width: 13px;
          }
        </style>
        <script>
          const getTraffic_16_3 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };

          document.getElementById("current-traffic-16-3").innerHTML =
            getTraffic_16_3();
          setInterval(() => {
            document.getElementById("current-traffic-16-3").innerHTML =
              getTraffic_16_3();
          }, 1800000);
        </script>
      </div>

      <div class="design-2 widget-rates-16-5 rates-M">
        <div>
          <p>USD</p>
          <div class="space-div-16-5"></div>
          <p id="usd-16-5">0,00</p>
        </div>

        <div>
          <p>EUR</p>
          <div class="space-div-16-5"></div>
          <p id="eur-16-5">0,00</p>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-2-2: calc(252px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-rates-16-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            width: var(--size-2-2);
            height: var(--size-1-2);
            position: absolute;
            top: calc(714px * 2);
            left: calc(276px * 2);
          }
          .widget-rates-16-5 div {
            display: flex;
            justify-content: space-around;
            font-size: 30px;
            font-family: Montserrat;
          }
          .widget-rates-16-5 div p:nth-child(1) {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-16-5 div p:nth-child(3) {
            color: white;
          }
          .space-div-16-5 {
            width: 26px;
          }
        </style>
        <script>
          const getUSD_EUR_16_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-16-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-16-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_16_5;
            }, 43200000);
            getUSD_EUR_16_5();
          }, 10000);
        </script>
      </div>

      <div class="design-2 widget-news-16-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 2);
            --size-4-2: calc(516px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-news-16-1 {
            width: var(--size-4-2);
            height: calc(159px * 2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(12px * 2);
            top: calc(846px * 2);
          }
          .widget-news-16-1 p {
            color: white;
            font-family: Montserrat;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const getNews_16_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length <= 60;
                });
                document.getElementById("header-news-16-1").innerHTML = news[0];
                document.getElementById("header-news-16-2").innerHTML = news[1];
                document.getElementById("header-news-16-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_16_1();
            }, 300000);
            getNews_16_1();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-4-2: calc(516px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4-2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 2);
            top: calc(1017px * 2);
          }
          .widget-about-company-16-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-16-1 p {
            font-family: Montserrat;
            color: white;
            font-size: 20px;
            font-weight: 400;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-16-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-18-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2);
            --size-4-2: calc(516px * 2);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4-2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 2);
            top: calc(1148px * 2);
          }
          .widget-about-company-16-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-18-2 {
            height: 16px;
          }
          .widget-about-company-16-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(540px * 2);
      height: calc(1280px * 2);
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;

export const theme8hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 8 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-2 widget-digital-clock-16-1 digital-clock-XL">
        <p id="hour-minutes16-1"></p>
        <p id="seconds16-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 1.34);
            --size-4-2: calc(516px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-digital-clock-16-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4-2);
            height: var(--size-2-2);
            position: absolute;
            top: calc(12px * 1.34);
            left: calc(12px * 1.34);
          }
          .widget-digital-clock-16-1 p {
            font-family: Montserrat;
            font-size: 150px;
            font-weight: 100;
            background-image: linear-gradient(
              0deg,
              rgba(57, 182, 251, 1) 0%,
              rgba(57, 182, 251, 1) 50%,
              rgba(255, 255, 251, 1) 50%,
              rgba(255, 255, 251, 1) 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
          }
          .widget-digital-clock-16-1 p:nth-child(1) {
            width: 420px;
            text-align: center;
          }
          .widget-digital-clock-16-1 p:nth-child(2) {
            width: 92px;
            margin-top: 50px;
            font-size: 70px;
            color: var(--actent-color);
            text-align: center;
          }
        </style>
        <script>
          setInterval(function setTime_16_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes16-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds16-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-2 widget-calendar-16-1 calendar-XL">
        <table id="calendar16-1">
          <thead>
            <tr>
              <td
                style="
                  font-weight: 500;
                  text-decoration: underline 3px rgba(27, 182, 251, 1);
                  text-align: center;
                "
                colspan="7"
              ></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-16-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3-2: calc(384px * 1.34);
            --size-4-2: calc(516px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          #calendar16-1 {
            text-align: center;
            font-size: 26px;
            color: white;
            font-weight: 300;
            border-spacing: 20px 4px;
            display: flex;
            flex-direction: column;
            margin: auto;
            /* width: 464px; */
            justify-content: space-around;
          }
          .widget-calendar-16-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Montserrat;
            width: var(--size-4-2);
            height: var(--size-3-2);
            position: absolute;
            left: calc(12px * 1.34);
            top: calc(276px * 1.34);
          }
          #today-16-1 {
            border: 3px solid rgba(27, 182, 251, 1);
            border-radius: 50%;
          }
          #body-calendar-16-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 60px;
          }
          thead tr td {
            width: 46px;
          }
        </style>
        <script>
          const getCalendar_16_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-16-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar16-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar16-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar16-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_16_1();
        </script>
      </div>

      <div class="design-2 widget-weather-16-2 weather-L">
        <img id="current-status-img-16-2" src="" alt="" />
        <p id="current-weather-16-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --size-3-2: calc(384px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-weather-16-2 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            width: var(--size-3-2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 1.34);
            top: calc(672px * 1.34);
          }
          .widget-weather-16-2 img {
            width: 120px;
            height: 120px;
            filter: var(--color-icon);
          }
          .widget-weather-16-2 p {
            color: white;
            font-family: Montserrat;
            font-size: 70px;
            font-weight: 100;
          }
        </style>
        <script>
          const getWeather16_2 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-16-2").innerHTML =
                  result[0][0];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-16-2")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getWeather16_2;
            }, 30000);
            getWeather16_2();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-traffic-16-4 traffic-S">
        <div>
          <canvas id="canvas16-5" width="100px" height="80px"></canvas>
        </div>
        <div>
          <p id="current-traffic-16-4"></p>
        </div>
        <div>
          <p>
            <canvas id="canvas16-6" width="100px" height="90px"></canvas>
          </p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --size-2-2: calc(252px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-traffic-16-4 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-1-2);
            height: var(--size-2-2);
            position: absolute;
            top: calc(12px * 1.34);
            left: calc(540px * 1.34);
          }
          .widget-traffic-16-4 div:nth-child(2) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 60px;
            border: 3px solid rgba(57, 182, 251, 1);
            border-radius: 50%;
          }
          .widget-traffic-16-4 div p {
            font-size: 30px;
            font-family: Montserrat;
            color: white;
          }
        </style>
        <script>
          const getTraffic_16_4 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };

          document.getElementById("current-traffic-16-4").innerHTML =
            getTraffic_16_4();
          setInterval(() => {
            document.getElementById("current-traffic-16-4").innerHTML =
              getTraffic_16_4();
          }, 1800000);
          traffic1();
          traffic2();
          function traffic1() {
            canvas = document.getElementById("canvas16-5");
            ctx = canvas.getContext("2d");
            ctx.beginPath(); // начало нового пути
            ctx.lineWidth = 3;
            ctx.strokeStyle = "rgba(64, 64, 64, 1)";
            // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
            ctx.arc(50, 45, 30, 0, 2 * Math.PI, false);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath(); // начало нового пути
            ctx.lineWidth = 3;

            ctx.strokeStyle = "rgba(64, 64, 64, 1)";
            // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
            ctx.arc(50, 45, 40, Math.PI, 0, false);
            ctx.stroke();
            ctx.closePath();
          }
          function traffic2() {
            canvas = document.getElementById("canvas16-6");
            ctx = canvas.getContext("2d");
            ctx.beginPath(); // начало нового пути
            ctx.lineWidth = 3;
            ctx.strokeStyle = "rgba(64, 64, 64, 1)";
            // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
            ctx.arc(50, 40, 30, 0, 2 * Math.PI, false);
            ctx.stroke();
            ctx.closePath();
          }
        </script>
      </div>

      <div class="design-2 widget-rates-16-8 rates-XS">
        <div>
          <p>\$</p>
          <div class="space-div-16-8"></div>
          <p id="usd-16-8">0,00</p>
        </div>
        <div>
          <p>€</p>
          <div class="space-div-16-8"></div>
          <p id="eur-16-8">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-rates-16-8 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            text-align: center;
            width: var(--size-1-2);
            height: calc(156px * 1.34);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(276px * 1.34);
          }
          .widget-rates-16-8 p {
            font-size: 20px;
            color: white;
            font-family: Montserrat;
          }
          .widget-rates-16-8 div {
            display: flex;
          }
          .widget-rates-16-8 div p:nth-child(1) {
            font-size: 20px;
            color: rgba(115, 115, 115, 1);
            font-family: Montserrat;
          }
          .space-div-16-8 {
            width: 10px;
          }
        </style>
        <script>
          const getUSD_EUR_16_8 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-16-8").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-16-8").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_16_8;
            }, 43200000);
            getUSD_EUR_16_8();
          }, 15000);
        </script>
      </div>

      <div class="design-2 widget-metals-16-3 metal-M">
        <div>
          <p class="name-metal-16-3">Нефть</p>
          <div class="widget-metal-last-16-3">
            <p id="oil-price-16-3">---,--</p>
            <div class="space-div-17-3"></div>
            <img
              id="updown-16-3-1"
              src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
            />
          </div>
        </div>

        <div>
          <p class="name-metal-16-3">Серебро</p>
          <div class="widget-metal-last-16-3">
            <p id="silver-price-16-3">---,--</p>
            <div class="space-div-17-3"></div>
            <img
              id="updown-16-3-2"
              src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-16-3">Золото</p>
          <div class="widget-metal-last-16-3">
            <p id="gold-price-16-3">---,--</p>
            <div class="space-div-17-3"></div>
            <img
              id="updown-16-3-3"
              src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-16-3">Платина</p>
          <div class="widget-metal-last-16-3">
            <p id="platinum-price-16-3">---,--</p>
            <div class="space-div-17-3"></div>
            <img
              id="updown-16-3-4"
              src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-16-3">Палладий</p>
          <div class="widget-metal-last-16-3">
            <p id="palladium-price-16-3">---,--</p>
            <div class="space-div-17-3"></div>
            <img
              id="updown-16-3-5"
              src="http://212.41.9.251:8000/static/blue_up_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 1.34);
            --size-3-2: calc(384px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-metals-16-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(350px * 1.34);
            height: calc(216px * 1.34);
            position: absolute;
            top: calc(444px * 1.34);
            left: calc(540px * 1.34);
          }
          .widget-metals-16-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: white;
            font-size: 20px;
            font-family: Montserrat;
          }
          .name-metal-16-3 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-17-3 {
            width: 6px;
          }
          .widget-metals-16-3 img {
            width: 18px;
            height: 14px;
          }
          .widget-metal-last-16-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_16_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-16-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-16-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-16-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                    );
                }
                document.getElementById("oil-price-16-3").innerHTML = result[1];
              });
          };
          const getMetal_16_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-16-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-16-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-16-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                    );
                }
                document.getElementById("silver-price-16-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-16-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-16-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-16-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                    );
                }
                document.getElementById("gold-price-16-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-16-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-16-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-16-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-16-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-16-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-16-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_up_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-16-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/blue_down_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-16-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_16_3();
              getMetal_16_3();
            }, 172800000);
            getOil_16_3();
            getMetal_16_3();
          }, 1000);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --size-4-2: calc(516px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(482px * 1.34);
            height: var(--size-1-2);
            position: absolute;
            top: calc(672px * 1.34);
            left: calc(408px * 1.34);
          }
          .widget-about-company-16-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-16-1 p {
            font-family: Montserrat;
            color: white;
            font-size: 20px;
            font-weight: 400;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-16-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-18-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --size-4-2: calc(516px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4-2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(902px * 1.34);
            top: calc(672px * 1.34);
          }
          .widget-about-company-16-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-18-2 {
            height: 16px;
          }
          .widget-about-company-16-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>

      <div class="design-2 widget-news-16-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 1.34);
            --size-4-2: calc(516px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-news-16-1 {
            width: var(--size-4-2);
            height: calc(216px * 1.34);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(902px * 1.34);
            top: calc(444px * 1.34);
          }
          .widget-news-16-1 p {
            color: white;
            font-family: Montserrat;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const getNews_16_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length <= 60;
                });
                document.getElementById("header-news-16-1").innerHTML = news[0];
                document.getElementById("header-news-16-2").innerHTML = news[1];
                document.getElementById("header-news-16-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_16_1();
            }, 300000);
            getNews_16_1();
          }, 5000);
        </script>
      </div>
      <div class="design-2 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(672px * 1.34);
            top: calc(12px * 1.34);
          }
          .video img {
            width: calc(746px * 1.34);
            height: calc(420px * 1.34);
            border-radius: 26px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1430px * 1.34);
      height: calc(804px * 1.34);
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;
export const theme8ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 8 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-2 widget-digital-clock-16-1 digital-clock-XL">
        <p id="hour-minutes16-1"></p>
        <p id="seconds16-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 1.34);
            --size-4-2: calc(516px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-digital-clock-16-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4-2);
            height: var(--size-2-2);
            position: absolute;
            top: calc(12px * 1.34);
            left: calc(12px * 1.34);
          }
          .widget-digital-clock-16-1 p {
            font-family: Montserrat;
            font-size: 150px;
            font-weight: 100;
            background-image: linear-gradient(
              0deg,
              rgba(57, 182, 251, 1) 0%,
              rgba(57, 182, 251, 1) 50%,
              rgba(255, 255, 251, 1) 50%,
              rgba(255, 255, 251, 1) 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
          }
          .widget-digital-clock-16-1 p:nth-child(1) {
            width: 420px;
            text-align: center;
          }
          .widget-digital-clock-16-1 p:nth-child(2) {
            width: 92px;
            margin-top: 50px;
            font-size: 70px;
            color: var(--actent-color);
            text-align: center;
          }
        </style>
        <script>
          setInterval(function setTime_16_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes16-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds16-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-2 widget-weather-16-3 weather-M">
        <div>
          <img id="current-status-img-16-3" src="" alt="" />
          <p id="current-status-16-3"></p>
          <p id="current-weather-16-3"></p>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-weather-16-3 {
            display: flex;
            width: var(--size-2-2);
            height: var(--size-2-2);
            justify-content: center;
            text-align: start;
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(12px * 1.34);
          }
          .widget-weather-16-3 div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 10px;
          }
          .widget-weather-16-3 p {
            font-family: Montserrat;
            font-weight: 100;
            font-size: 70px;
            color: white;
          }
          .widget-weather-16-3 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .widget-weather-16-3 p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            font-size: 30px;
          }
        </style>
        <script>
          const getWeather16_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-16-3").innerHTML =
                  result[0][0];
                document.getElementById("current-status-16-3").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-16-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getWeather16_3;
            }, 30000);
            getWeather16_3();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-date-16-2 dates-L">
        <p id="current-day-16-2"></p>
        <div class="space-div-11-1"></div>
        <p id="current-date-16-2"></p>
        <div class="space-div-11-1"></div>
        <p id="current-month-16-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --size-4-2: calc(516px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-date-16-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4-2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 1.34);
            top: calc(276px * 1.34);
          }
          .widget-date-16-2 p {
            font-family: Montserrat;
            color: white;
            font-size: 26px;
          }
          .space-div-11-1 {
            width: 8px;
          }
          .widget-date-16-2 p:nth-child(3) {
            height: 30px;
            text-decoration: underline 2px rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const currentDay_16_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}, \`;
          };
          const currentDate_16_2 = () => {
            let date = new Date();
            return \`\${date.getDate()}\`;
          };
          const currentMonth_16_2 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            return \`\${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-day-16-2").innerHTML =
              currentDay_16_2();
            document.getElementById("current-date-16-2").innerHTML =
              currentDate_16_2();
            document.getElementById("current-month-16-2").innerHTML =
              currentMonth_16_2();
          }, 100);
        </script>
      </div>

      <div class="design-2 widget-traffic-16-3 traffic-M">
        <p>Пробки</p>
        <div class="space-div-14-3"></div>
        <div>
          <p id="current-traffic-16-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --size-2-2: calc(252px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-traffic-16-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2-2);
            height: var(--size-1-2);
            position: absolute;
            top: calc(276px * 1.34);
            left: calc(540px * 1.34);
          }
          .widget-traffic-16-3 p {
            font-family: Montserrat;
            font-weight: 200;
            color: white;
            font-size: 32px;
          }
          .widget-traffic-16-3 div:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 76px;
            height: 76px;
            border: 3px solid rgba(57, 182, 251, 1);
            border-radius: 50%;
          }
          .widget-traffic-16-3 div p {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 70px;
          }
          .space-div-14-3 {
            width: 13px;
          }
        </style>
        <script>
          const getTraffic_16_3 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };

          document.getElementById("current-traffic-16-3").innerHTML =
            getTraffic_16_3();
          setInterval(() => {
            document.getElementById("current-traffic-16-3").innerHTML =
              getTraffic_16_3();
          }, 1800000);
        </script>
      </div>

      <div class="design-2 widget-rates-16-6 rates-M">
        <p id="usd-16-6">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --size-2-2: calc(252px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-rates-16-6 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-2-2);
            height: var(--size-1-2);
            background-image: url("http://212.41.9.251:8000/static/\$.svg");
            background-repeat: no-repeat;
            background-size: contain;
            position: absolute;
            left: calc(12px * 1.34);
            top: calc(408px * 1.34);
          }
          .widget-rates-16-6 p {
            font-size: 70px;
            font-family: Montserrat;
            color: white;
            font-weight: 200;
          }
        </style>
        <script>
          const getUSD_16_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-16-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_16_6;
            }, 43200000);
            getUSD_16_6();
          }, 10000);
        </script>
      </div>

      <div class="design-2 widget-rates-16-7 rates-M">
        <p id="eur-16-7">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --size-2-2: calc(252px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-rates-16-7 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-2-2);
            height: var(--size-1-2);
            background-image: url("http://212.41.9.251:8000/static/€.svg");
            background-repeat: no-repeat;
            background-size: contain;
            position: absolute;
            top: calc(540px * 1.34);
            left: calc(12px * 1.34);
          }
          .widget-rates-16-7 p {
            font-size: 70px;
            font-family: Montserrat;
            color: white;
            font-weight: 200;
          }
        </style>
        <script>
          const getEUR_16_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-16-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_16_7;
            }, 43200000);
            getEUR_16_7();
          }, 10000);
        </script>
      </div>

      <div class="design-2 widget-news-16-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 1.34);
            --size-4-2: calc(516px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-news-16-1 {
            width: var(--size-4-2);
            height: var(--size-2-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: calc(408px * 1.34);
            left: calc(276px * 1.34);
          }
          .widget-news-16-1 p {
            color: white;
            font-family: Montserrat;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const getNews_16_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length <= 60;
                });
                document.getElementById("header-news-16-1").innerHTML = news[0];
                document.getElementById("header-news-16-2").innerHTML = news[1];
                document.getElementById("header-news-16-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_16_1();
            }, 300000);
            getNews_16_1();
          }, 5000);
        </script>
      </div>
      <div class="design-2 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(12px * 1.34);
            top: calc(672px * 1.34);
          }
          .video img {
            width: calc(780px * 1.34);
            height: calc(438px * 1.34);
            border-radius: 26px;
          }
        </style>
      </div>

      <div class="design-2 widget-about-company-16-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --size-4-2: calc(516px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(780px * 1.34);
            height: calc(163px * 1.34);
            position: absolute;
            left: calc(12px * 1.34);
            top: calc(1122px * 1.34);
          }
          .widget-about-company-16-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-16-1 p {
            font-family: Montserrat;
            color: white;
            font-size: 20px;
            font-weight: 400;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-16-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-18-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 1.34);
            --size-4-2: calc(516px * 1.34);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(780px * 1.34);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 1.34);
            top: calc(1297px * 1.34);
          }
          .widget-about-company-16-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-18-2 {
            height: 16px;
          }
          .widget-about-company-16-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(804px * 1.34);
      height: calc(1430px * 1.34);
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;

export const theme9hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 9 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-2 widget-digital-clock-16-1 digital-clock-XL">
        <p id="hour-minutes16-1"></p>
        <p id="seconds16-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-digital-clock-16-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4-2);
            height: var(--size-2-2);
            position: absolute;
            top: calc(12px * 2.14);
            left: calc(12px * 2.14);
          }
          .widget-digital-clock-16-1 p {
            font-family: Montserrat;
            font-size: 150px;
            font-weight: 100;
            background-image: linear-gradient(
              0deg,
              rgba(57, 182, 251, 1) 0%,
              rgba(57, 182, 251, 1) 50%,
              rgba(255, 255, 251, 1) 50%,
              rgba(255, 255, 251, 1) 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
          }
          .widget-digital-clock-16-1 p:nth-child(1) {
            width: 420px;
            text-align: center;
          }
          .widget-digital-clock-16-1 p:nth-child(2) {
            width: 92px;
            margin-top: 50px;
            font-size: 70px;
            color: var(--actent-color);
            text-align: center;
          }
        </style>
        <script>
          setInterval(function setTime_16_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes16-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds16-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-2 widget-calendar-16-1 calendar-XL">
        <table id="calendar16-1">
          <thead>
            <tr>
              <td
                style="
                  font-weight: 500;
                  text-decoration: underline 3px rgba(27, 182, 251, 1);
                  text-align: center;
                "
                colspan="7"
              ></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-16-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3-2: calc(384px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          #calendar16-1 {
            text-align: center;
            font-size: 26px;
            color: white;
            font-weight: 300;
            border-spacing: 20px 4px;
            display: flex;
            flex-direction: column;
            margin: auto;
            /* width: 464px; */
            justify-content: space-around;
          }
          .widget-calendar-16-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Montserrat;
            width: var(--size-4-2);
            height: var(--size-3-2);
            position: absolute;
            top: calc(276px * 2.14);
            left: calc(12px * 2.14);
          }
          #today-16-1 {
            border: 3px solid rgba(27, 182, 251, 1);
            border-radius: 50%;
          }
          #body-calendar-16-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 60px;
          }
          thead tr td {
            width: 46px;
          }
        </style>
        <script>
          const getCalendar_16_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-16-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar16-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar16-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar16-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_16_1();
        </script>
      </div>

      <div class="design-2 widget-weather-16-2 weather-L">
        <img id="current-status-img-16-2" src="" alt="" />
        <p id="current-weather-16-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2.14);
            --size-3-2: calc(384px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-weather-16-2 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            width: var(--size-3-2);
            height: var(--size-1-2);
            position: absolute;
            top: calc(12px * 2.14);
            left: calc(540px * 2.14);
          }
          .widget-weather-16-2 img {
            width: 120px;
            height: 120px;
            filter: var(--color-icon);
          }
          .widget-weather-16-2 p {
            color: white;
            font-family: Montserrat;
            font-size: 70px;
            font-weight: 100;
          }
        </style>
        <script>
          const getWeather16_2 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-16-2").innerHTML =
                  result[0][0];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-16-2")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getWeather16_2;
            }, 30000);
            getWeather16_2();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-traffic-16-2 traffic-L">
        <p>Пробки</p>
        <div class="space-div-14-2"></div>
        <p id="current-traffic-16-2"></p>
        <div class="space-div-14-2"></div>
        <p>баллов</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2.14);
            --size-3-2: calc(384px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-traffic-16-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-3-2);
            height: var(--size-1-2);
            position: absolute;
            left: calc(540px * 2.14);
            top: calc(144px * 2.14);
          }
          .widget-traffic-16-2 p {
            font-family: Montserrat;
            font-weight: 200;
            color: white;
            font-size: 32px;
          }
          .widget-traffic-16-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            color: rgba(57, 182, 251, 1);
            font-size: 70px;
          }
          .space-div-14-2 {
            width: 16px;
          }
        </style>
        <script>
          const getTraffic_16_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };

          document.getElementById("current-traffic-16-2").innerHTML =
            getTraffic_16_2();
          setInterval(() => {
            document.getElementById("current-traffic-16-2").innerHTML =
              getTraffic_16_2();
          }, 1800000);
        </script>
      </div>

      <div class="design-2 widget-news-16-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-news-16-1 {
            width: calc(384px * 2.14);
            height: calc(384px * 2.14);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(540px * 2.14);
            top: calc(276px * 2.14);
          }
          .widget-news-16-1 p {
            color: white;
            font-family: Montserrat;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const getNews_16_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length <= 60;
                });
                document.getElementById("header-news-16-1").innerHTML = news[0];
                document.getElementById("header-news-16-2").innerHTML = news[1];
                document.getElementById("header-news-16-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_16_1();
            }, 300000);
            getNews_16_1();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-18-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(656px * 2.14);
            height: var(--size-1-2);
            position: absolute;
            left: calc(936px * 2.14);
            top: calc(540px * 2.14);
          }
          .widget-about-company-16-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-18-2 {
            height: 16px;
          }
          .widget-about-company-16-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>

      <div class="design-2 widget-about-company-16-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            width: calc(656px * 2.14);
            height: calc(136px * 2.14);
            position: absolute;
            left: calc(936px * 2.14);
            top: calc(392px * 2.14);
          }
          .widget-about-company-16-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-16-1 p {
            font-family: Montserrat;
            color: white;
            font-size: 20px;
            font-weight: 400;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-16-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>
      <div class="design-2 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(936px * 2.14);
            top: calc(12px * 2.14);
          }
          .video img {
            width: calc(656px * 2.14);
            height: calc(368px * 2.14);
            border-radius: 26px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1604px * 2.14);
      height: calc(672px * 2.14);
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;
export const theme9ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 9 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-2 widget-digital-clock-16-1 digital-clock-XL">
        <p id="hour-minutes16-1"></p>
        <p id="seconds16-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-digital-clock-16-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4-2);
            height: var(--size-2-2);
            position: absolute;
            top: calc(18px * 2.14);
            left: calc(12px * 2.14);
          }
          .widget-digital-clock-16-1 p {
            font-family: Montserrat;
            font-size: 150px;
            font-weight: 100;
            background-image: linear-gradient(
              0deg,
              rgba(57, 182, 251, 1) 0%,
              rgba(57, 182, 251, 1) 50%,
              rgba(255, 255, 251, 1) 50%,
              rgba(255, 255, 251, 1) 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
          }
          .widget-digital-clock-16-1 p:nth-child(1) {
            width: 420px;
            text-align: center;
          }
          .widget-digital-clock-16-1 p:nth-child(2) {
            width: 92px;
            margin-top: 50px;
            font-size: 70px;
            color: var(--actent-color);
            text-align: center;
          }
        </style>
        <script>
          setInterval(function setTime_16_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes16-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds16-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-2 widget-traffic-16-4 traffic-S">
        <div>
          <canvas id="canvas16-5" width="100px" height="80px"></canvas>
        </div>
        <div>
          <p id="current-traffic-16-4"></p>
        </div>
        <div>
          <p>
            <canvas id="canvas16-6" width="100px" height="90px"></canvas>
          </p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2.14);
            --size-2-2: calc(252px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-traffic-16-4 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-1-2);
            height: var(--size-2-2);
            position: absolute;
            left: calc(540px * 2.14);
            top: calc(18px * 2.14);
          }
          .widget-traffic-16-4 div:nth-child(2) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 60px;
            border: 3px solid rgba(57, 182, 251, 1);
            border-radius: 50%;
          }
          .widget-traffic-16-4 div p {
            font-size: 30px;
            font-family: Montserrat;
            color: white;
          }
        </style>
        <script>
          const getTraffic_16_4 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };

          document.getElementById("current-traffic-16-4").innerHTML =
            getTraffic_16_4();
          setInterval(() => {
            document.getElementById("current-traffic-16-4").innerHTML =
              getTraffic_16_4();
          }, 1800000);
          traffic1();
          traffic2();
          function traffic1() {
            pi = Math.PI;
            canvas = document.getElementById("canvas16-5");
            ctx = canvas.getContext("2d");
            ctx.beginPath(); // начало нового пути
            ctx.lineWidth = 3;
            ctx.strokeStyle = "rgba(64, 64, 64, 1)";
            // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
            ctx.arc(50, 45, 30, 0, 2 * pi, false);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath(); // начало нового пути
            ctx.lineWidth = 3;

            ctx.strokeStyle = "rgba(64, 64, 64, 1)";
            // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
            ctx.arc(50, 45, 40, pi, 0, false);
            ctx.stroke();
            ctx.closePath();
          }
          function traffic2() {
            pi = Math.PI;
            canvas = document.getElementById("canvas16-6");
            ctx = canvas.getContext("2d");
            ctx.beginPath(); // начало нового пути
            ctx.lineWidth = 3;
            ctx.strokeStyle = "rgba(64, 64, 64, 1)";
            // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
            ctx.arc(50, 40, 30, 0, 2 * pi, false);
            ctx.stroke();
            ctx.closePath();
          }
        </script>
      </div>

      <div class="design-2 widget-date-16-2 dates-L">
        <p id="current-day-16-2"></p>
        <div class="space-div-11-1"></div>
        <p id="current-date-16-2"></p>
        <div class="space-div-11-1"></div>
        <p id="current-month-16-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-date-16-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(648px * 2.14);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 2.14);
            top: calc(282px * 2.14);
          }
          .widget-date-16-2 p {
            font-family: Montserrat;
            color: white;
            font-size: 26px;
          }
          .space-div-11-1 {
            width: 8px;
          }
          .widget-date-16-2 p:nth-child(3) {
            height: 30px;
            text-decoration: underline 2px rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const currentDay_16_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}, \`;
          };
          const currentDate_16_2 = () => {
            let date = new Date();
            return \`\${date.getDate()}\`;
          };
          const currentMonth_16_2 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            return \`\${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-day-16-2").innerHTML =
              currentDay_16_2();
            document.getElementById("current-date-16-2").innerHTML =
              currentDate_16_2();
            document.getElementById("current-month-16-2").innerHTML =
              currentMonth_16_2();
          }, 100);
        </script>
      </div>

      <div class="design-2 widget-rates-16-9 rates-S">
        <div>
          <p>USD</p>
          <p id="usd-16-9">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <p id="eur-16-9">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2.14);
            --size-2-2: calc(252px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-rates-16-9 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            width: var(--size-1-2);
            height: var(--size-2-2);
            position: absolute;
            left: calc(12px * 2.14);
            top: calc(414px * 2.14);
          }
          .widget-rates-16-9 p {
            color: white;
            font-size: 20px;
            font-family: Montserrat;
          }
          .widget-rates-16-9 div p:nth-child(1) {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const getUSD_EUR_16_9 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-16-9").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-16-9").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_16_9;
            }, 43200000);
            getUSD_EUR_16_9();
          }, 15000);
        </script>
      </div>

      <div class="design-2 widget-weather-16-1 weather-XL">
        <div class="current-weather-16-1">
          <img id="current-status-img-16-1" src="" alt="" />
          <p id="current-status-16-1"></p>
          <p id="current-weather-16-1"></p>
        </div>
        <div class="time-16-1">
          <div>
            <p>04:00</p>
            <p>12:00</p>
            <p>20:00</p>
          </div>
          <div>
            <img id="status-img-16-1-1" src="" alt="" />
            <img id="status-img-16-1-2" src="" alt="" />
            <img id="status-img-16-1-3" src="" alt="" />
          </div>
          <div>
            <p id="weather-16-1-1"></p>
            <p id="weather-16-1-2"></p>
            <p id="weather-16-1-3"></p>
          </div>
        </div>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .space-div-13-1 {
            width: 91px;
          }
          .widget-weather-16-1 {
            display: flex;
            justify-content: space-evenly;
            width: var(--size-4-2);
            height: var(--size-2-2);
            position: absolute;
            left: calc(144px * 2.14);
            top: calc(414px * 2.14);
          }
          .current-weather-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .current-weather-16-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }

          .current-weather-16-1 p {
            color: white;
            font-size: 70px;
            font-weight: 100;
            font-family: Montserrat;
          }
          .current-weather-16-1 p:nth-child(2) {
            font-size: 26px;
            color: rgba(115, 115, 115, 1);
          }
          .time-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 320px;
            color: white;
            font-size: 26px;
            font-family: Montserrat;
            font-weight: 400;
          }
          .time-16-1 div {
            display: flex;
            justify-content: space-evenly;
          }
          .time-16-1 img {
            width: 60px;
            height: 60px;
          }
        </style>
        <script>
          const getWeather16_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-16-1").innerHTML =
                  result[0][0];
                document.getElementById("current-status-16-1").innerHTML =
                  result[0][1];
                document.getElementById("weather-16-1-1").innerHTML =
                  result[1][0][0];
                document.getElementById("weather-16-1-2").innerHTML =
                  result[1][1][0];
                document.getElementById("weather-16-1-3").innerHTML =
                  result[1][3][0];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear_16.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/weather_cloudy_16.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy_16.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain_16.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-16-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-16-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-16-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-16-1-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getWeather16_1;
            }, 30000);
            getWeather16_1();
          }, 1000);
        </script>
      </div>
      <div class="design-2 video">
        <img src="http://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            top: calc(678px * 2.14);
            left: calc(12px * 2.14);
          }
          .video img {
            width: calc(648px * 2.14);
            height: calc(364px * 2.14);
            border-radius: 26px;
          }
        </style>
      </div>

      <div class="design-2 widget-news-16-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-16-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2-2: calc(252px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-news-16-1 {
            width: calc(648px * 2.14);
            height: calc(274px * 2.14);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(12px * 2.14);
            top: calc(1054px * 2.14);
          }
          .widget-news-16-1 p {
            color: white;
            font-family: Montserrat;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid rgba(57, 182, 251, 1);
          }
        </style>
        <script>
          const getNews_16_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-16-2").innerHTML = news[1];
                document.getElementById("header-news-16-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_16_1();
            }, 300000);
            getNews_16_1();
          }, 5000);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(648px * 2.14);
            height: var(--size-1-2);
            position: absolute;
            left: calc(12px * 2.14);
            top: calc(1340px * 2.14);
          }
          .widget-about-company-16-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-16-1 p {
            font-family: Montserrat;
            color: white;
            font-size: 20px;
            font-weight: 400;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-16-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-2 widget-about-company-16-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-18-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1-2: calc(120px * 2.14);
            --size-4-2: calc(516px * 2.14);
            --actent-color: rgba(57, 182, 251, 1);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-2 {
            background-color: var(--background-widgets);
            border-radius: 26px;
          }
          .widget-about-company-16-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(648px * 2.14);
            height: var(--size-1-2);
            position: absolute;
            top: calc(1472px * 2.14);
            left: calc(12px * 2.14);
          }
          .widget-about-company-16-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .space-div-18-2 {
            height: 16px;
          }
          .widget-about-company-16-2 img {
            filter: var(--color-icon);
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(672px * 2.14);
      height: calc(1604px * 2.14);
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;

export const theme10hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>тема 10 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-3 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: calc(246px * 2);
              --background-widgets: rgba(255, 255, 255, 1);
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              top: calc(16px * 2);
              left: calc(16px * 2);
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-3 widget-date-S-11-8 dates-XS">
        <p id="current-date-11-8"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-S-11-8 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(278px * 2);
          }
          .widget-date-S-11-8 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 32px;
          }
        </style>
        <script>
          const currentDate_11_8 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${date.getDate()} \${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-date-11-8").innerHTML =
              currentDate_11_8();
          }, 100);
        </script>
      </div>

      <div class="design-3 widget-date-S-11-7 dates-XS">
        <p id="current-day-11-7"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-S-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(409px * 2);
          }
          .widget-date-S-11-7 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 32px;
          }
        </style>
        <script>
          const currentDay_11_7 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-day-11-7").innerHTML =
              currentDay_11_7();
          }, 100);
        </script>
      </div>

      <div class="design-3 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 2);
            left: calc(278px * 2);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/dark_weather_clear.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/dark_weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/dark_weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-1 {
            width: calc(534px * 2);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: calc(278px * 2);
            left: calc(278px * 2);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --style2: "";
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(269px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(16px * 2);
            left: calc(543px * 2);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-3 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(269px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(147px * 2);
            left: calc(543px * 2);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/dark_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/dark_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/dark_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/dark_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(437px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 2);
            left: calc(828px * 2);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>

      <div class="design-3 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(437px * 2);
            height: var(--size-1);
            position: absolute;
            left: calc(828px * 2);
            top: calc(278px * 2);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>
      <div class="design-3 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(828px * 2);
            top: calc(16px * 2);
          }
          .video img {
            width: calc(437px * 2);
            height: calc(246px * 2);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: calc(1280px * 2);
      height: calc(540px * 2);
      position: relative;
      background-color: rgba(234, 234, 234, 1);
    }
  </style>
</html>
`;
export const theme10ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 10 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-3 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: calc(246px * 2);
              --background-widgets: rgba(255, 255, 255, 1);
            }
            .design-3 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              top: calc(2 * 16px);
              left: calc(2 * 16px);
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-3 widget-weather-S-11-4 weather-S">
        <p id="current-weather-11-4"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-S-11-4 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(2 * 16px);
            left: calc(2 * 278px);
          }
          .widget-weather-S-11-4 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
        </style>
        <script>
          const currentWeather_11_4 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-4").innerHTML =
                  result[0][0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_4;
            }, 300000);
            currentWeather_11_4();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-date-S-11-6 dates-XS">
        <p id="current-date-11-6"></p>
        <p id="current-day-11-6"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-S-11-6 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(2 * 278px);
            top: calc(2 * 147px);
          }

          .widget-date-S-11-6 p {
            color: var(--text-color);
            font-family: Rubik;
            font-size: 26px;
            font-weight: 500;
          }
          .widget-date-S-11-6 p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
        </style>
        <script>
          const currentDate_11_6 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${date.getDate()} \${month[date.getMonth()]}\`;
          };

          const currentDay_11_6 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-date-11-6").innerHTML =
              currentDate_11_6();
            document.getElementById("current-day-11-6").innerHTML =
              currentDay_11_6();
          }, 100);
        </script>
      </div>

      <div class="design-3 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(2 * 278px);
            left: calc(2 * 16px);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --style2: "";
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(2 * 278px);
            left: calc(2 * 278px);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>
      <div class="design-3 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(2 * 16px);
            top: calc(2 * 409px);
          }
          .video img {
            width: calc(2 * 508px);
            height: calc(2 * 285px);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-3 widget-news-11-2 news-L">
        <div class="left-line-11-2"></div>
        <div><p id="header-news-11-2">------</p></div>
        <div class="left-line-11-2"></div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-2 {
            width: var(--size-4);
            height: calc(2 * 294px);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: calc(16px * 2);
            top: calc(710px * 2);
          }
          .widget-news-11-2 div:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .widget-news-11-2 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: center;
            padding-left: 32px;
            padding-right: 32px;
          }
          .left-line-11-2 {
            width: 40%;
            height: 3px;
            background-color: var(--text-color);
            margin-top: 26px;
            margin-bottom: 26px;
          }
        </style>
        <script>
          const getNews_11_2 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("header-news-11-2").innerHTML =
                  result[0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_2();
            }, 300000);
            getNews_11_2();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            top: calc(1019px * 2);
            left: calc(16px * 2);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/dark_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/dark_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/dark_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/dark_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(1150px * 2);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: calc(2 * 540px);
      height: calc(2 * 1280px);
      position: relative;
      background-color: rgba(234, 234, 234, 1);
    }
  </style>
</html>
`;

export const theme11hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 11 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-5 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: calc(246px * 2);
              --background-widgets: rgba(208, 208, 208, 0.4);
            }
            .design-5 {
              background-color: var(--background-widgets);
              border-radius: 32px;
              backdrop-filter: blur(60px);
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              top: calc(16px * 2);
              left: calc(16px * 2);
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-5 widget-date-S-11-8 dates-XS">
        <p id="current-date-11-8"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-S-11-8 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(278px * 2);
          }
          .widget-date-S-11-8 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 32px;
          }
        </style>
        <script>
          const currentDate_11_8 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${date.getDate()} \${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-date-11-8").innerHTML =
              currentDate_11_8();
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-date-S-11-7 dates-XS">
        <p id="current-day-11-7"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-S-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(409px * 2);
          }
          .widget-date-S-11-7 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 32px;
          }
        </style>
        <script>
          const currentDay_11_7 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-day-11-7").innerHTML =
              currentDay_11_7();
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 2);
            left: calc(278px * 2);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: var(--background-widgets);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: calc(534px * 2);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: calc(278px * 2);
            left: calc(278px * 2);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length <= 70;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --style2: "";
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(269px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(16px * 2);
            left: calc(543px * 2);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-5 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(269px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(147px * 2);
            left: calc(543px * 2);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: var(--background-widgets);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(437px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 2);
            left: calc(828px * 2);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>

      <div class="design-5 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(437px * 2);
            height: var(--size-1);
            position: absolute;
            left: calc(828px * 2);
            top: calc(278px * 2);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: var(--background-widgets);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>
      <div class="design-5 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(828px * 2);
            top: calc(16px * 2);
          }
          .video img {
            width: calc(437px * 2);
            height: calc(246px * 2);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: calc(1280px * 2);
      height: calc(540px * 2);
      position: relative;
      background-image: url("http://212.41.9.251:8000/static/background2.svg");
      background-repeat: no-repeat;
      background-size: cover;
    }
  </style>
</html>
`;
export const theme11ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 11 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-5 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: calc(246px * 2);
              --background-widgets: rgba(208, 208, 208, 0.4);
            }
            .design-5 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              top: calc(16px * 2);
              left: calc(16px * 2);
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-5 widget-weather-S-11-4 weather-S">
        <p id="current-weather-11-4"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-S-11-4 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(16px * 2);
            left: calc(278px * 2);
          }
          .widget-weather-S-11-4 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
        </style>
        <script>
          const currentWeather_11_4 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-4").innerHTML =
                  result[0][0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_4;
            }, 300000);
            currentWeather_11_4();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-date-S-11-6 dates-XS">
        <p id="current-date-11-6"></p>
        <p id="current-day-11-6"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-S-11-6 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(278px * 2);
            top: calc(147px * 2);
          }

          .widget-date-S-11-6 p {
            color: var(--text-color);
            font-family: Rubik;
            font-size: 26px;
            font-weight: 500;
          }
          .widget-date-S-11-6 p:nth-child(2) {
            color: var(--background-widgets);
            font-size: 26px;
          }
        </style>
        <script>
          const currentDate_11_6 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${date.getDate()} \${month[date.getMonth()]}\`;
          };

          const currentDay_11_6 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-date-11-6").innerHTML =
              currentDate_11_6();
            document.getElementById("current-day-11-6").innerHTML =
              currentDay_11_6();
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(278px * 2);
            left: calc(16px * 2);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: var(--background-widgets);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --style2: "";
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(278px * 2);
            left: calc(278px * 2);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>
      <div class="design-5 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 2);
            top: calc(409px * 2);
          }
          .video img {
            width: calc(508px * 2);
            height: calc(285px * 2);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-5 widget-news-11-2 news-L">
        <div class="left-line-11-2"></div>
        <div><p id="header-news-11-2">------</p></div>
        <div class="left-line-11-2"></div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-2 {
            width: var(--size-4);
            height: calc(294px * 2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: calc(16px * 2);
            top: calc(710px * 2);
          }
          .widget-news-11-2 div:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .widget-news-11-2 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: center;
            padding-left: 32px;
            padding-right: 32px;
          }
          .left-line-11-2 {
            width: 40%;
            height: 3px;
            background-color: var(--text-color);
            margin-top: 26px;
            margin-bottom: 26px;
          }
        </style>
        <script>
          const getNews_11_2 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("header-news-11-2").innerHTML =
                  result[0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_2();
            }, 300000);
            getNews_11_2();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            top: calc(1019px * 2);
            left: calc(16px * 2);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: var(--background-widgets);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(1150px * 2);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: calc(540px * 2);
      height: calc(1280px * 2);
      position: relative;
      background-image: url("http://212.41.9.251:8000/static/background2.svg");
      background-repeat: no-repeat;
    }
  </style>
</html>
`;

export const theme12hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 12 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-4 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: calc(246px * 2);
              --background-widgets: rgba(0, 0, 0, 0.4);
            }
            .design-4 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              top: calc(16px * 2);
              left: calc(16px * 2);
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-4 widget-date-S-11-8 dates-XS">
        <p id="current-date-11-8"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-S-11-8 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(278px * 2);
          }
          .widget-date-S-11-8 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 32px;
          }
        </style>
        <script>
          const currentDate_11_8 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${date.getDate()} \${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-date-11-8").innerHTML =
              currentDate_11_8();
          }, 100);
        </script>
      </div>

      <div class="design-4 widget-date-S-11-7 dates-XS">
        <p id="current-day-11-7"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-S-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(409px * 2);
          }
          .widget-date-S-11-7 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 32px;
          }
        </style>
        <script>
          const currentDay_11_7 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-day-11-7").innerHTML =
              currentDay_11_7();
          }, 100);
        </script>
      </div>

      <div class="design-4 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 2);
            left: calc(278px * 2);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: calc(534px * 2);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: calc(278px * 2);
            left: calc(278px * 2);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --style2: "";
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(269px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(16px * 2);
            left: calc(543px * 2);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-4 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(269px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(147px * 2);
            left: calc(543px * 2);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(437px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 2);
            left: calc(828px * 2);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>

      <div class="design-4 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(437px * 2);
            height: var(--size-1);
            position: absolute;
            left: calc(828px * 2);
            top: calc(278px * 2);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(1115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>
      <div class="design-4 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(828px * 2);
            top: calc(16px * 2);
          }
          .video img {
            width: calc(437px * 2);
            height: calc(246px * 2);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: calc(1280px * 2);
      height: calc(540px * 2);
      position: relative;
      background-image: url("http://212.41.9.251:8000/static/background1.svg");
      background-repeat: no-repeat;
      background-size: cover;
    }
  </style>
</html>
`;
export const theme12ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 12 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-4 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: calc(246px * 2);
              --background-widgets: rgba(0, 0, 0, 0.4);
            }
            .design-4 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              top: calc(16px * 2);
              left: calc(16px * 2);
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-4 widget-weather-S-11-4 weather-S">
        <p id="current-weather-11-4"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-S-11-4 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(16px * 2);
            left: calc(278px * 2);
          }
          .widget-weather-S-11-4 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
        </style>
        <script>
          const currentWeather_11_4 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-4").innerHTML =
                  result[0][0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_4;
            }, 300000);
            currentWeather_11_4();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-date-S-11-6 dates-XS">
        <p id="current-date-11-6"></p>
        <p id="current-day-11-6"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-S-11-6 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(278px * 2);
            top: calc(147px * 2);
          }

          .widget-date-S-11-6 p {
            color: var(--text-color);
            font-family: Rubik;
            font-size: 26px;
            font-weight: 500;
          }
          .widget-date-S-11-6 p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
        </style>
        <script>
          const currentDate_11_6 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${date.getDate()} \${month[date.getMonth()]}\`;
          };

          const currentDay_11_6 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-date-11-6").innerHTML =
              currentDate_11_6();
            document.getElementById("current-day-11-6").innerHTML =
              currentDay_11_6();
          }, 100);
        </script>
      </div>

      <div class="design-4 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(278px * 2);
            left: calc(16px * 2);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --style2: "";
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(278px * 2);
            left: calc(278px * 2);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>
      <div class="design-4 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 2);
            top: calc(409px * 2);
          }
          .video img {
            width: calc(508px * 2);
            height: calc(285px * 2);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-4 widget-news-11-2 news-L">
        <div class="left-line-11-2"></div>
        <div><p id="header-news-11-2">------</p></div>
        <div class="left-line-11-2"></div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-2 {
            width: var(--size-4);
            height: calc(294px * 2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: calc(16px * 2);
            top: calc(710px * 2);
          }
          .widget-news-11-2 div:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .widget-news-11-2 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: center;
            padding-left: 32px;
            padding-right: 32px;
          }
          .left-line-11-2 {
            width: 40%;
            height: 3px;
            background-color: var(--text-color);
            margin-top: 26px;
            margin-bottom: 26px;
          }
        </style>
        <script>
          const getNews_11_2 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("header-news-11-2").innerHTML =
                  result[0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_2();
            }, 300000);
            getNews_11_2();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            top: calc(1019px * 2);
            left: calc(16px * 2);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(1150px * 2);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: calc(540px * 2);
      height: calc(1280px * 2);
      position: relative;
      background-image: url("http://212.41.9.251:8000/static/background1.svg");
      background-repeat: no-repeat;
    }
  </style>
</html>
`;

export const theme13hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 13 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-1 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: calc(246px * 2);
              --background-widgets: rgba(30, 30, 30, 1);
            }
            .design-1 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              top: calc(16px * 2);
              left: calc(16px * 2);
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-1 widget-date-S-11-8 dates-XS">
        <p id="current-date-11-8"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-S-11-8 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(278px * 2);
          }
          .widget-date-S-11-8 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 32px;
          }
        </style>
        <script>
          const currentDate_11_8 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${date.getDate()} \${month[date.getMonth()]}\`;
          };
          setInterval(() => {
            document.getElementById("current-date-11-8").innerHTML =
              currentDate_11_8();
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-date-S-11-7 dates-XS">
        <p id="current-day-11-7"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-S-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(409px * 2);
          }
          .widget-date-S-11-7 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 32px;
          }
        </style>
        <script>
          const currentDay_11_7 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-day-11-7").innerHTML =
              currentDay_11_7();
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 2);
            left: calc(278px * 2);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>

        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-1 {
            width: calc(534px * 2);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: calc(278px * 2);
            left: calc(278px * 2);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --style2: "";
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(269px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(16px * 2);
            left: calc(543px * 2);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-1 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(269px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(147px * 2);
            left: calc(543px * 2);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(437px * 2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 2);
            left: calc(828px * 2);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>

      <div class="design-1 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(437px * 2);
            height: var(--size-1);
            position: absolute;
            left: calc(828px * 2);
            top: calc(278px * 2);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>
      <div class="design-1 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(828px * 2);
            top: calc(16px * 2);
          }
          .video img {
            width: calc(437px * 2);
            height: calc(246px * 2);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: calc(1280px * 2);
      height: calc(540px * 2);
      position: relative;
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;
export const theme13ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 13 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-1 widget-analog-clock-M-11-3 analog-clock-M">
        <canvas id="canvas1-3" width="246px" height="246px">
          <style>
            @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
            * {
              margin: 0;
              padding: 0;
            }
            :root {
              --size-2: calc(246px * 2);
              --background-widgets: rgba(30, 30, 30, 1);
            }
            .design-1 {
              background-color: var(--background-widgets);
              border-radius: 32px;
            }
            .widget-analog-clock-M-11-3 {
              display: flex;
              justify-content: center;
              align-items: center;
              width: var(--size-2);
              height: var(--size-2);
              position: absolute;
              top: calc(16px * 2);
              left: calc(16px * 2);
            }
          </style>
          <script>
            analogClock_11_3();
            function analogClock_11_3() {
              let center_x = 123;
              let center_y = 123;
              let radius = 117;
              pi = Math.PI;
              drawClock_11_3();
              setInterval(drawClock_11_3, 100);

              function drawClock_11_3() {
                clock_11_3();
                mark_circle_seconds1();
                mark_circle_hours1(ctx, radius);
                drawWBlackNumbers(ctx, radius);
                timing_11_3();
              }
              // стрелки
              function timing_11_3() {
                const d = new Date();
                angle = Math.PI * 2 * (d.getSeconds() / 60) - (Math.PI * 2) / 4;

                // часовая
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX4 =
                  center_x +
                  Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2;
                let newY4 =
                  center_y -
                  Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getHours() * Math.PI) / 6),
                  center_y - Math.cos((d.getHours() * Math.PI) / 6)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX4, newY4);
                ctx.lineTo(
                  newX4 +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.25,
                  newY4 - Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.25
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getHours() * Math.PI) / 6) * radius * 0.2,
                  center_y -
                    Math.cos((d.getHours() * Math.PI) / 6) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                //минутная
                ctx.beginPath();
                ctx.lineWidth = 8;
                ctx.strokeStyle = "rgba(255, 255, 255, 1)";
                ctx.moveTo(center_x, center_y);
                let newX3 =
                  center_x +
                  Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                let newY3 =
                  center_y -
                  Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2;
                ctx.lineTo(
                  center_x + Math.sin((d.getMinutes() * Math.PI) / 30),
                  center_y - Math.cos((d.getMinutes() * Math.PI) / 30)
                );
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(newX3, newY3);
                ctx.lineTo(
                  newX3 +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.4,
                  newY3 -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.4
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = "rgba(115, 115, 115, 1)";
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  center_x +
                    Math.sin((d.getMinutes() * Math.PI) / 30) * radius * 0.2,
                  center_y -
                    Math.cos((d.getMinutes() * Math.PI) / 30) * radius * 0.2
                );
                ctx.lineCap = "round";
                ctx.stroke();
                ctx.closePath();
                // секундная
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(center_x, center_y);
                ctx.lineTo(
                  canvas.width / 2 + (Math.cos(angle) * 60 * 25) / 14,
                  canvas.height / 2 + (Math.sin(angle) * 60 * 25) / 14
                );
                ctx.moveTo(canvas.width / 2, canvas.height / 2);
                ctx.lineTo(
                  canvas.width / 2 - Math.cos(angle) * 20,
                  canvas.height / 2 - Math.sin(angle) * 20
                );
                ctx.lineCap = "round";
                ctx.strokeStyle = "rgb(0, 0, 0, 1)";
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 4, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
              // метки секундные серые
              function mark_circle_seconds1() {
                for (var i = 0; i < 60; i++) {
                  angle = ((i - 3) * (Math.PI * 2)) / 60; // THE ANGLE TO MARK.
                  ctx.lineWidth = 3; // HAND WIDTH.
                  ctx.beginPath();
                  ctx.fillStyle = "rgba(204, 204, 204, 1)";
                  var x1 = center_x + (Math.cos(angle) * 60 * 18) / 10;
                  var y1 = center_y + (Math.sin(angle) * 60 * 18) / 10;
                  ctx.arc(x1, y1, 3, 0, 2 * pi, false);
                  ctx.fill();
                  ctx.closePath();
                }
              }
              // часовые метки серые точечные
              function mark_circle_hours1(ctx, radius) {
                for (var i = 0; i <= Math.PI * 2; i += (2 * Math.PI) / 12) {
                  fill(function () {
                    ctx.fillStyle = "rgba(111, 111, 111, 1)";
                    ctx.arc(
                      ctx.canvas.width / 2 + ((15 * radius) / 16) * Math.cos(i),
                      ctx.canvas.height / 2 +
                        ((15 * radius) / 16) * Math.sin(i),
                      3,
                      0,
                      2 * Math.PI
                    );
                  });
                }
              }
              // отрисовка цифры черные
              function drawWBlackNumbers(ctx, radius) {
                var ang;
                var num;
                ctx.fillStyle = "black";
                ctx.font = radius * 0.18 + "px rubik";
                ctx.textBaseline = "middle";
                ctx.textAlign = "center";
                for (num = 1; num < 13; num++) {
                  ang = (num * Math.PI) / 6;
                  ctx.rotate(ang);
                  ctx.translate(0, -radius * 0.75);
                  ctx.rotate(-ang);
                  ctx.fillText(num.toString(), center_x, center_y);
                  ctx.rotate(ang);
                  ctx.translate(0, radius * 0.75);
                  ctx.rotate(-ang);
                }
              }
              function fill(fn, params) {
                ctx.beginPath();
                fn(params);
                ctx.fill();
                ctx.closePath();
              }
              function clock_11_3() {
                canvas = document.getElementById("canvas1-3");
                ctx = canvas.getContext("2d");
                ctx.beginPath(); // начало нового пути
                ctx.lineWidth = 2;
                ctx.fillStyle = "white";
                ctx.strokeStyle = "white";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, radius - 2, 0, 2 * pi, false);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.beginPath(); // начало нового пути
                ctx.fillStyle = "rgba(115, 115, 115, 1)";
                // Координаты центра круга, радиус, начальный угол, конечный угол, направление по часовой стрелке
                ctx.arc(center_x, center_y, 7, 0, 2 * pi, false);
                ctx.fill();
                ctx.closePath();
              }
            }
          </script>
        </canvas>
      </div>

      <div class="design-1 widget-weather-S-11-4 weather-S">
        <p id="current-weather-11-4"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-S-11-4 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(16px * 2);
            left: calc(278px * 2);
          }
          .widget-weather-S-11-4 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
        </style>
        <script>
          const currentWeather_11_4 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-4").innerHTML =
                  result[0][0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_4;
            }, 300000);
            currentWeather_11_4();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-date-S-11-6 dates-XS">
        <p id="current-date-11-6"></p>
        <p id="current-day-11-6"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-S-11-6 {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(278px * 2);
            top: calc(147px * 2);
          }

          .widget-date-S-11-6 p {
            color: var(--text-color);
            font-family: Rubik;
            font-size: 26px;
            font-weight: 500;
          }
          .widget-date-S-11-6 p:nth-child(2) {
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
        </style>
        <script>
          const currentDate_11_6 = () => {
            let date = new Date();
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${date.getDate()} \${month[date.getMonth()]}\`;
          };

          const currentDay_11_6 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            return \`\${days[date.getDay()]}\`;
          };

          setInterval(() => {
            document.getElementById("current-date-11-6").innerHTML =
              currentDate_11_6();
            document.getElementById("current-day-11-6").innerHTML =
              currentDay_11_6();
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(278px * 2);
            left: calc(16px * 2);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-2: calc(246px * 2);
            --style2: "";
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(278px * 2);
            left: calc(278px * 2);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>
      <div class="design-1 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 2);
            top: calc(409px * 2);
          }
          .video img {
            width: calc(508px * 2);
            height: calc(285px * 2);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-1 widget-news-11-2 news-L">
        <div class="left-line-11-2"></div>
        <div><p id="header-news-11-2">------</p></div>
        <div class="left-line-11-2"></div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-2 {
            width: var(--size-4);
            height: calc(294px * 2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: calc(16px * 2);
            top: calc(710px * 2);
          }
          .widget-news-11-2 div:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .widget-news-11-2 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: center;
            padding-left: 32px;
            padding-right: 32px;
          }
          .left-line-11-2 {
            width: 40%;
            height: 3px;
            background-color: var(--text-color);
            margin-top: 26px;
            margin-bottom: 26px;
          }
        </style>
        <script>
          const getNews_11_2 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("header-news-11-2").innerHTML =
                  result[0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_2();
            }, 300000);
            getNews_11_2();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            top: calc(1019px * 2);
            left: calc(16px * 2);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 2);
            --size-4: calc(508px * 2);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 2);
            top: calc(1150px * 2);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      width: calc(540px * 2);
      height: calc(1280px * 2);
      position: relative;
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;

export const theme14hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 14 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-3 widget-digital-clock-XL-11-2 digital-clock-XL">
        <p id="hour-minutes11-2"></p>
        <p id="seconds11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-digital-clock-XL-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(639px * 1.34);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-digital-clock-XL-11-2 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
          .widget-digital-clock-XL-11-2 p:first-child {
            width: 380px;
            text-align: center;
          }
          .widget-digital-clock-XL-11-2 p:nth-child(2) {
            margin-top: 50px;
            width: 88px;
            font-size: 70px;
            color: rgba(64, 64, 64, 1);
          }
        </style>
        <script>
          setInterval(function setTime_11_2() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-3 widget-date-11-4 dates-M">
        <p id="previous-day-11-4-2"></p>
        <p id="previous-day-11-4-1"></p>
        <p id="current-day-11-4"></p>
        <p id="next-day-11-4-1"></p>
        <p id="next-day-11-4-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-11-4 {
            display: flex;
            justify-content: space-evenly;
            flex-direction: column;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(278px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-date-11-4 p {
            font-family: rubik;
            color: rgba(64, 64, 64, 1);
            font-size: 22px;
          }
          .widget-date-11-4 p:nth-child(3) {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
        </style>
        <script>
          const currentDate_11_4 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };

          const previous_day_11_4_1 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() - 1);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const previous_day_11_4_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() - 2);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const next_day_11_4_1 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() + 1);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const next_day_11_4_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() + 2);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };

          setInterval(() => {
            document.getElementById("current-day-11-4").innerHTML =
              currentDate_11_4();
            document.getElementById("previous-day-11-4-1").innerHTML =
              previous_day_11_4_1();
            document.getElementById("previous-day-11-4-2").innerHTML =
              previous_day_11_4_2();
            document.getElementById("next-day-11-4-1").innerHTML =
              next_day_11_4_1();
            document.getElementById("next-day-11-4-2").innerHTML =
              next_day_11_4_2();
          }, 100);
        </script>
      </div>

      <div class="design-3 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(540px * 1.34);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/dark_weather_clear.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/dark_weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/dark_weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-traffic-S-11-3 traffic-XS">
        <p id="current-traffic-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --style3: "";
            --background-widgets: rgba(255, 255, 255, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-S-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-1);
            height: calc(153px * 1.34);
            position: absolute;
            top: calc(278px * 1.34);
            left: calc(540px * 1.34);
          }
          .widget-traffic-S-11-3 p {
            font-family: rubik;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 90px;
            background-color: var(--style3);
            border-radius: 50%;
            font-size: 70px;
            color: var(--background-widgets);
          }
        </style>
        <script>
          const getTraffic_11_3 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud3 = () => {
            let value = document.getElementById(
              "current-traffic-11-3"
            ).innerHTML;
            if (value == "10") {
              var style = \`rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style3\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-3").innerHTML =
            getTraffic_11_3();
          updateBackgroud3();
          setInterval(() => {
            document.getElementById("current-traffic-11-3").innerHTML =
              getTraffic_11_3();

            updateBackgroud3();
          }, 1800000);
        </script>
      </div>

      <div class="design-3 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(540px * 1.34);
            left: calc(278px * 1.34);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(608px * 1.34);
            height: var(--size-1);
            position: absolute;
            top: calc(671px * 1.34);
            left: calc(278px * 1.34);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-3 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-3: calc(377px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(346px * 1.34);
            height: calc(208px * 1.34);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(447px * 1.34);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/dark_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/dark_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/dark_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/dark_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(902px * 1.34);
            top: calc(671px * 1.34);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>

      <div class="design-3 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-1 {
            width: var(--size-4);
            height: calc(208px * 1.34);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(902px * 1.34);
            top: calc(447px * 1.34);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>
      <div class="design-3 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(671px * 1.34);
            top: calc(16px * 1.34);
          }
          .video img {
            width: calc(739px * 1.34);
            height: calc(415px * 1.34);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1426px * 1.34);
      height: calc(802px * 1.34);
      background-color: rgba(234, 234, 234, 1);
    }
  </style>
</html>
`;
export const theme14ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 14 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-3 widget-digital-clock-XL-11-2 digital-clock-XL">
        <p id="hour-minutes11-2"></p>
        <p id="seconds11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-digital-clock-XL-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-digital-clock-XL-11-2 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
          .widget-digital-clock-XL-11-2 p:first-child {
            width: 380px;
            text-align: center;
          }
          .widget-digital-clock-XL-11-2 p:nth-child(2) {
            margin-top: 50px;
            width: 88px;
            font-size: 70px;
            color: rgba(64, 64, 64, 1);
          }
        </style>
        <script>
          setInterval(function setTime_11_2() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-3 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(16px * 1.34);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/dark_weather_clear.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/dark_weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/dark_weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-date-M-11-3 dates-L">
        <p id="current-day-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-M-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(278px * 1.34);
          }
          .widget-date-M-11-3 p {
            font-family: rubik;
            font-size: 32px;
            color: var(--text-color);
          }
        </style>
        <script>
          const currentDate_11_3 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          setInterval(() => {
            document.getElementById("current-day-11-3").innerHTML =
              currentDate_11_3();
          }, 100);
        </script>
      </div>

      <div class="design-3 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --style2: "";
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(278px * 1.34);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-3 widget-rates-M-11-6 rates-S">
        <p>USD</p>
        <div class="space-div-7-6"></div>
        <p id="usd-11-6">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-6 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-rates-M-11-6 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-6 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-6 {
            width: 14px;
          }
        </style>
        <script>
          const getUSD_11_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_11_6;
            }, 43200000);
            getUSD_11_6();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-rates-M-11-7 rates-S">
        <p>EUR</p>
        <div class="space-div-7-7"></div>
        <p id="eur-11-7">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(540px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-rates-M-11-7 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-7 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-7 {
            width: 14px;
          }
        </style>
        <script>
          const getEUR_11_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-11-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_11_7;
            }, 43200000);
            getEUR_11_7();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-news-11-2 news-L">
        <div class="left-line-11-2"></div>
        <div><p id="header-news-11-2">------</p></div>
        <div class="left-line-11-2"></div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-2 {
            width: var(--size-4);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: calc(278px * 1.34);
            top: calc(409px * 1.34);
          }
          .widget-news-11-2 div:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .widget-news-11-2 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: center;
            padding-left: 32px;
            padding-right: 32px;
          }
          .left-line-11-2 {
            width: 40%;
            height: 3px;
            background-color: var(--text-color);
            margin-top: 26px;
            margin-bottom: 26px;
          }
        </style>
        <script>
          const getNews_11_2 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("header-news-11-2").innerHTML =
                  result[0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_2();
            }, 300000);
            getNews_11_2();
          }, 5000);
        </script>
      </div>
      <div class="design-3 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(671px * 1.34);
          }
          .video img {
            width: calc(770px * 1.34);
            height: calc(432px * 1.34);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-3 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-3: calc(377px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(273px * 1.34);
            height: calc(293px * 1.34);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(1119px * 1.34);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(483px * 1.34);
            height: calc(162px * 1.34);
            position: absolute;
            top: calc(1119px * 1.34);
            left: calc(305px * 1.34);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/dark_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/dark_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/dark_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/dark_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(483px * 1.34);
            height: var(--size-1);
            position: absolute;
            top: calc(1297px * 1.34);
            left: calc(305px * 1.34);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(802px * 1.34);
      height: calc(1426px * 1.34);
      background-color: rgba(234, 234, 234, 1);
    }
  </style>
</html>
`;

export const theme15hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 15 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-5 widget-digital-clock-XL-11-2 digital-clock-XL">
        <p id="hour-minutes11-2"></p>
        <p id="seconds11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(639px * 1.34);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-digital-clock-XL-11-2 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
          .widget-digital-clock-XL-11-2 p:first-child {
            width: 380px;
            text-align: center;
          }
          .widget-digital-clock-XL-11-2 p:nth-child(2) {
            margin-top: 50px;
            width: 88px;
            font-size: 70px;
            color: var(--background-widgets);
          }
        </style>
        <script>
          setInterval(function setTime_11_2() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-date-11-4 dates-M">
        <p id="previous-day-11-4-2"></p>
        <p id="previous-day-11-4-1"></p>
        <p id="current-day-11-4"></p>
        <p id="next-day-11-4-1"></p>
        <p id="next-day-11-4-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-11-4 {
            display: flex;
            justify-content: space-evenly;
            flex-direction: column;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(278px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-date-11-4 p {
            font-family: rubik;
            color: var(--background-widgets);
            font-size: 22px;
          }
          .widget-date-11-4 p:nth-child(3) {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
        </style>
        <script>
          const currentDate_11_4 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };

          const previous_day_11_4_1 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() - 1);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const previous_day_11_4_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() - 2);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const next_day_11_4_1 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() + 1);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const next_day_11_4_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() + 2);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };

          setInterval(() => {
            document.getElementById("current-day-11-4").innerHTML =
              currentDate_11_4();
            document.getElementById("previous-day-11-4-1").innerHTML =
              previous_day_11_4_1();
            document.getElementById("previous-day-11-4-2").innerHTML =
              previous_day_11_4_2();
            document.getElementById("next-day-11-4-1").innerHTML =
              next_day_11_4_1();
            document.getElementById("next-day-11-4-2").innerHTML =
              next_day_11_4_2();
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(540px * 1.34);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: var(--background-widgets);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-traffic-S-11-3 traffic-XS">
        <p id="current-traffic-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --style3: "";
            --background-widgets: rgba(208, 208, 208, 0.4);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-S-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-1);
            height: calc(153px * 1.34);
            position: absolute;
            top: calc(278px * 1.34);
            left: calc(540px * 1.34);
          }
          .widget-traffic-S-11-3 p {
            font-family: rubik;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 90px;
            background-color: var(--style3);
            border-radius: 50%;
            font-size: 70px;
            color: white;
          }
        </style>
        <script>
          const getTraffic_11_3 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud3 = () => {
            let value = document.getElementById(
              "current-traffic-11-3"
            ).innerHTML;
            if (value == "10") {
              var style = \`rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style3\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-3").innerHTML =
            getTraffic_11_3();
          updateBackgroud3();
          setInterval(() => {
            document.getElementById("current-traffic-11-3").innerHTML =
              getTraffic_11_3();

            updateBackgroud3();
          }, 1800000);
        </script>
      </div>

      <div class="design-5 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(540px * 1.34);
            left: calc(278px * 1.34);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: var(--background-widgets);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(608px * 1.34);
            height: var(--size-1);
            position: absolute;
            top: calc(671px * 1.34);
            left: calc(278px * 1.34);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: var(--background-widgets);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-5 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-3: calc(377px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(346px * 1.34);
            height: calc(208px * 1.34);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(447px * 1.34);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: var(--background-widgets);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(902px * 1.34);
            top: calc(671px * 1.34);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>

      <div class="design-5 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: var(--size-4);
            height: calc(208px * 1.34);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(902px * 1.34);
            top: calc(447px * 1.34);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>
      <div class="design-5 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(671px * 1.34);
            top: calc(16px * 1.34);
          }
          .video img {
            width: calc(739px * 1.34);
            height: calc(415px * 1.34);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1426px * 1.34);
      height: calc(802px * 1.34);
      background-image: url("http://212.41.9.251:8000/static/background2.svg");
      background-repeat: no-repeat;
      background-size: cover;
    }
  </style>
</html>
`;
export const theme15ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 15 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-5 widget-digital-clock-XL-11-2 digital-clock-XL">
        <p id="hour-minutes11-2"></p>
        <p id="seconds11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-digital-clock-XL-11-2 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
          .widget-digital-clock-XL-11-2 p:first-child {
            width: 380px;
            text-align: center;
          }
          .widget-digital-clock-XL-11-2 p:nth-child(2) {
            margin-top: 50px;
            width: 88px;
            font-size: 70px;
            color: var(--background-widgets);
          }
        </style>
        <script>
          setInterval(function setTime_11_2() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(16px * 1.34);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: var(--background-widgets);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-date-M-11-3 dates-L">
        <p id="current-day-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-M-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(278px * 1.34);
          }
          .widget-date-M-11-3 p {
            font-family: rubik;
            font-size: 32px;
            color: var(--text-color);
          }
        </style>
        <script>
          const currentDate_11_3 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          setInterval(() => {
            document.getElementById("current-day-11-3").innerHTML =
              currentDate_11_3();
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --style2: "";
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(278px * 1.34);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-5 widget-rates-M-11-6 rates-S">
        <p>USD</p>
        <div class="space-div-7-6"></div>
        <p id="usd-11-6">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-6 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-rates-M-11-6 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-6 p:first-child {
            color: var(--background-widgets);
          }
          .space-div-7-6 {
            width: 14px;
          }
        </style>
        <script>
          const getUSD_11_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_11_6;
            }, 43200000);
            getUSD_11_6();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-rates-M-11-7 rates-S">
        <p>EUR</p>
        <div class="space-div-7-7"></div>
        <p id="eur-11-7">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(540px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-rates-M-11-7 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-7 p:first-child {
            color: var(--background-widgets);
          }
          .space-div-7-7 {
            width: 14px;
          }
        </style>
        <script>
          const getEUR_11_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-11-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_11_7;
            }, 43200000);
            getEUR_11_7();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-news-11-2 news-L">
        <div class="left-line-11-2"></div>
        <div><p id="header-news-11-2">------</p></div>
        <div class="left-line-11-2"></div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-2 {
            width: var(--size-4);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: calc(278px * 1.34);
            top: calc(409px * 1.34);
          }
          .widget-news-11-2 div:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .widget-news-11-2 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: center;
            padding-left: 32px;
            padding-right: 32px;
          }
          .left-line-11-2 {
            width: 40%;
            height: 3px;
            background-color: var(--text-color);
            margin-top: 26px;
            margin-bottom: 26px;
          }
        </style>
        <script>
          const getNews_11_2 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("header-news-11-2").innerHTML =
                  result[0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_2();
            }, 300000);
            getNews_11_2();
          }, 5000);
        </script>
      </div>
      <div class="design-5 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(671px * 1.34);
          }
          .video img {
            width: calc(770px * 1.34);
            height: calc(432px * 1.34);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-5 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-3: calc(377px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(273px * 1.34);
            height: calc(293px * 1.34);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(1119px * 1.34);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: var(--background-widgets);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(483px * 1.34);
            height: calc(162px * 1.34);
            position: absolute;
            top: calc(1119px * 1.34);
            left: calc(305px * 1.34);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: var(--background-widgets);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(483px * 1.34);
            height: var(--size-1);
            position: absolute;
            top: calc(1297px * 1.34);
            left: calc(305px * 1.34);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(802px * 1.34);
      height: calc(1426px * 1.34);
      background-image: url("http://212.41.9.251:8000/static/background2.svg");
      background-repeat: no-repeat;
    }
  </style>
</html>
`;

export const theme16hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 16 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-4 widget-digital-clock-XL-11-2 digital-clock-XL">
        <p id="hour-minutes11-2"></p>
        <p id="seconds11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(639px * 1.34);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-digital-clock-XL-11-2 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
          .widget-digital-clock-XL-11-2 p:first-child {
            width: 380px;
            text-align: center;
          }
          .widget-digital-clock-XL-11-2 p:nth-child(2) {
            margin-top: 50px;
            width: 88px;
            font-size: 70px;
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          setInterval(function setTime_11_2() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-4 widget-date-11-4 dates-M">
        <p id="previous-day-11-4-2"></p>
        <p id="previous-day-11-4-1"></p>
        <p id="current-day-11-4"></p>
        <p id="next-day-11-4-1"></p>
        <p id="next-day-11-4-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-11-4 {
            display: flex;
            justify-content: space-evenly;
            flex-direction: column;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(278px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-date-11-4 p {
            font-family: rubik;
            color: rgba(115, 115, 115, 1);
            font-size: 22px;
          }
          .widget-date-11-4 p:nth-child(3) {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
        </style>
        <script>
          const currentDate_11_4 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };

          const previous_day_11_4_1 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() - 1);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const previous_day_11_4_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() - 2);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const next_day_11_4_1 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() + 1);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const next_day_11_4_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() + 2);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };

          setInterval(() => {
            document.getElementById("current-day-11-4").innerHTML =
              currentDate_11_4();
            document.getElementById("previous-day-11-4-1").innerHTML =
              previous_day_11_4_1();
            document.getElementById("previous-day-11-4-2").innerHTML =
              previous_day_11_4_2();
            document.getElementById("next-day-11-4-1").innerHTML =
              next_day_11_4_1();
            document.getElementById("next-day-11-4-2").innerHTML =
              next_day_11_4_2();
          }, 100);
        </script>
      </div>

      <div class="design-4 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(540px * 1.34);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-traffic-S-11-3 traffic-XS">
        <p id="current-traffic-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --style3: "";
            --background-widgets: rgba(0, 0, 0, 0.4);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-S-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-1);
            height: calc(153px * 1.34);
            position: absolute;
            top: calc(278px * 1.34);
            left: calc(540px * 1.34);
          }
          .widget-traffic-S-11-3 p {
            font-family: rubik;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 90px;
            background-color: var(--style3);
            border-radius: 50%;
            font-size: 70px;
            color: var(--background-widgets);
          }
        </style>
        <script>
          const getTraffic_11_3 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud3 = () => {
            let value = document.getElementById(
              "current-traffic-11-3"
            ).innerHTML;
            if (value == "10") {
              var style = \`rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style3\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-3").innerHTML =
            getTraffic_11_3();
          updateBackgroud3();
          setInterval(() => {
            document.getElementById("current-traffic-11-3").innerHTML =
              getTraffic_11_3();

            updateBackgroud3();
          }, 1800000);
        </script>
      </div>

      <div class="design-4 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(540px * 1.34);
            left: calc(278px * 1.34);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(608px * 1.34);
            height: var(--size-1);
            position: absolute;
            top: calc(671px * 1.34);
            left: calc(278px * 1.34);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-4 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-3: calc(377px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(346px * 1.34);
            height: calc(208px * 1.34);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(447px * 1.34);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(902px * 1.34);
            top: calc(671px * 1.34);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>

      <div class="design-4 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: var(--size-4);
            height: calc(208px * 1.34);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(902px * 1.34);
            top: calc(447px * 1.34);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>
      <div class="design-4 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(671px * 1.34);
            top: calc(16px * 1.34);
          }
          .video img {
            width: calc(739px * 1.34);
            height: calc(415px * 1.34);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1426px * 1.34);
      height: calc(802px * 1.34);
      background-image: url("http://212.41.9.251:8000/static/background1.svg");
      background-repeat: no-repeat;
      background-size: cover;
    }
  </style>
</html>
`;
export const theme16ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 16 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-4 widget-digital-clock-XL-11-2 digital-clock-XL">
        <p id="hour-minutes11-2"></p>
        <p id="seconds11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-digital-clock-XL-11-2 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
          .widget-digital-clock-XL-11-2 p:first-child {
            width: 380px;
            text-align: center;
          }
          .widget-digital-clock-XL-11-2 p:nth-child(2) {
            margin-top: 50px;
            width: 88px;
            font-size: 70px;
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          setInterval(function setTime_11_2() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-4 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(16px * 1.34);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-date-M-11-3 dates-L">
        <p id="current-day-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-M-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(278px * 1.34);
          }
          .widget-date-M-11-3 p {
            font-family: rubik;
            font-size: 32px;
            color: var(--text-color);
          }
        </style>
        <script>
          const currentDate_11_3 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          setInterval(() => {
            document.getElementById("current-day-11-3").innerHTML =
              currentDate_11_3();
          }, 100);
        </script>
      </div>

      <div class="design-4 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --style2: "";
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(278px * 1.34);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-4 widget-rates-M-11-6 rates-S">
        <p>USD</p>
        <div class="space-div-7-6"></div>
        <p id="usd-11-6">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-6 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-rates-M-11-6 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-6 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-6 {
            width: 14px;
          }
        </style>
        <script>
          const getUSD_11_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_11_6;
            }, 43200000);
            getUSD_11_6();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-rates-M-11-7 rates-S">
        <p>EUR</p>
        <div class="space-div-7-7"></div>
        <p id="eur-11-7">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(540px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-rates-M-11-7 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-7 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-7 {
            width: 14px;
          }
        </style>
        <script>
          const getEUR_11_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-11-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_11_7;
            }, 43200000);
            getEUR_11_7();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-news-11-2 news-L">
        <div class="left-line-11-2"></div>
        <div><p id="header-news-11-2">------</p></div>
        <div class="left-line-11-2"></div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-2 {
            width: var(--size-4);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: calc(278px * 1.34);
            top: calc(409px * 1.34);
          }
          .widget-news-11-2 div:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .widget-news-11-2 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: center;
            padding-left: 32px;
            padding-right: 32px;
          }
          .left-line-11-2 {
            width: 40%;
            height: 3px;
            background-color: var(--text-color);
            margin-top: 26px;
            margin-bottom: 26px;
          }
        </style>
        <script>
          const getNews_11_2 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("header-news-11-2").innerHTML =
                  result[0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_2();
            }, 300000);
            getNews_11_2();
          }, 5000);
        </script>
      </div>
      <div class="design-4 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(671px * 1.34);
          }
          .video img {
            width: calc(770px * 1.34);
            height: calc(432px * 1.34);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-4 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-3: calc(377px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(273px * 1.34);
            height: calc(293px * 1.34);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(1119px * 1.34);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(483px * 1.34);
            height: calc(162px * 1.34);
            position: absolute;
            top: calc(1119px * 1.34);
            left: calc(305px * 1.34);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(483px * 1.34);
            height: var(--size-1);
            position: absolute;
            top: calc(1297px * 1.34);
            left: calc(305px * 1.34);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(802px * 1.34);
      height: calc(1426px * 1.34);
      background-image: url("http://212.41.9.251:8000/static/background1.svg");
      background-repeat: no-repeat;
    }
  </style>
</html>
`;

export const theme17hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 17 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-1 widget-digital-clock-XL-11-2 digital-clock-XL">
        <p id="hour-minutes11-2"></p>
        <p id="seconds11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-digital-clock-XL-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(639px * 1.34);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-digital-clock-XL-11-2 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
          .widget-digital-clock-XL-11-2 p:first-child {
            width: 380px;
            text-align: center;
          }
          .widget-digital-clock-XL-11-2 p:nth-child(2) {
            margin-top: 50px;
            width: 88px;
            font-size: 70px;
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          setInterval(function setTime_11_2() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-date-11-4 dates-M">
        <p id="previous-day-11-4-2"></p>
        <p id="previous-day-11-4-1"></p>
        <p id="current-day-11-4"></p>
        <p id="next-day-11-4-1"></p>
        <p id="next-day-11-4-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-date-11-4 {
            display: flex;
            justify-content: space-evenly;
            flex-direction: column;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(278px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-date-11-4 p {
            font-family: rubik;
            color: rgba(115, 115, 115, 1);
            font-size: 22px;
          }
          .widget-date-11-4 p:nth-child(3) {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
        </style>
        <script>
          const currentDate_11_4 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };

          const previous_day_11_4_1 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() - 1);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const previous_day_11_4_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() - 2);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const next_day_11_4_1 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() + 1);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          const next_day_11_4_2 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];
            let day = date.setDate(date.getDate() + 2);
            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };

          setInterval(() => {
            document.getElementById("current-day-11-4").innerHTML =
              currentDate_11_4();
            document.getElementById("previous-day-11-4-1").innerHTML =
              previous_day_11_4_1();
            document.getElementById("previous-day-11-4-2").innerHTML =
              previous_day_11_4_2();
            document.getElementById("next-day-11-4-1").innerHTML =
              next_day_11_4_1();
            document.getElementById("next-day-11-4-2").innerHTML =
              next_day_11_4_2();
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(540px * 1.34);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-traffic-S-11-3 traffic-XS">
        <p id="current-traffic-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --style3: "";
            --background-widgets: rgba(30, 30, 30, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-S-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-1);
            height: calc(153px * 1.34);
            position: absolute;
            top: calc(278px * 1.34);
            left: calc(540px * 1.34);
          }
          .widget-traffic-S-11-3 p {
            font-family: rubik;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 90px;
            background-color: var(--style3);
            border-radius: 50%;
            font-size: 70px;
            color: var(--background-widgets);
          }
        </style>
        <script>
          const getTraffic_11_3 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud3 = () => {
            let value = document.getElementById(
              "current-traffic-11-3"
            ).innerHTML;
            if (value == "10") {
              var style = \`rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style3\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-3").innerHTML =
            getTraffic_11_3();
          updateBackgroud3();
          setInterval(() => {
            document.getElementById("current-traffic-11-3").innerHTML =
              getTraffic_11_3();

            updateBackgroud3();
          }, 1800000);
        </script>
      </div>

      <div class="design-1 widget-rates-M-11-5 rates-S">
        <div>
          <p>USD</p>
          <div class="space-div-7-5"></div>
          <p id="usd-11-5">0,00</p>
        </div>
        <div>
          <p>EUR</p>
          <div class="space-div-7-5"></div>
          <p id="eur-11-5">0,00</p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-M-11-5 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(540px * 1.34);
            left: calc(278px * 1.34);
          }
          .widget-rates-M-11-5 div {
            display: flex;
            justify-content: center;
          }
          .widget-rates-M-11-5 div p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .widget-rates-M-11-5 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 26px;
            font-weight: 300;
          }
          .space-div-7-5 {
            width: 12px;
          }
        </style>
        <script>
          const getUSD_EUR_11_5 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-5").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                document.getElementById("eur-11-5").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_EUR_11_5;
            }, 43200000);
            getUSD_EUR_11_5();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(608px * 1.34);
            height: var(--size-1);
            position: absolute;
            top: calc(671px * 1.34);
            left: calc(278px * 1.34);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-1 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-3: calc(377px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(346px * 1.34);
            height: calc(208px * 1.34);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(447px * 1.34);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(902px * 1.34);
            top: calc(671px * 1.34);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>

      <div class="design-1 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-1 {
            width: var(--size-4);
            height: calc(208px * 1.34);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(902px * 1.34);
            top: calc(447px * 1.34);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>
      <div class="design-1 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(671px * 1.34);
            top: calc(16px * 1.34);
          }
          .video img {
            width: calc(739px * 1.34);
            height: calc(415px * 1.34);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1426px * 1.34);
      height: calc(802px * 1.34);
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;
export const theme17ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 17 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-1 widget-digital-clock-XL-11-2 digital-clock-XL">
        <p id="hour-minutes11-2"></p>
        <p id="seconds11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-digital-clock-XL-11-2 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
          .widget-digital-clock-XL-11-2 p:first-child {
            width: 380px;
            text-align: center;
          }
          .widget-digital-clock-XL-11-2 p:nth-child(2) {
            margin-top: 50px;
            width: 88px;
            font-size: 70px;
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          setInterval(function setTime_11_2() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
            document.getElementById(
              "seconds11-2"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              second: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(16px * 1.34);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-date-M-11-3 dates-L">
        <p id="current-day-11-3"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-date-M-11-3 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(278px * 1.34);
          }
          .widget-date-M-11-3 p {
            font-family: rubik;
            font-size: 32px;
            color: var(--text-color);
          }
        </style>
        <script>
          const currentDate_11_3 = () => {
            let date = new Date();
            let days = [
              "Воскресенье",
              "Понедельник",
              "Вторник",
              "Среда",
              "Четверг",
              "Пятница",
              "Суббота",
            ];
            let month = [
              "января",
              "февраля",
              "марта",
              "апреля",
              "мая",
              "июня",
              "июля",
              "августа",
              "сентября",
              "октября",
              "ноября",
              "декабря",
            ];

            return \`\${days[date.getDay()]}, \${date.getDate()} \${
              month[date.getMonth()]
            }\`;
          };
          setInterval(() => {
            document.getElementById("current-day-11-3").innerHTML =
              currentDate_11_3();
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --style2: "";
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            left: calc(540px * 1.34);
            top: calc(278px * 1.34);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-1 widget-rates-M-11-6 rates-S">
        <p>USD</p>
        <div class="space-div-7-6"></div>
        <p id="usd-11-6">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-6 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-rates-M-11-6 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-6 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-6 {
            width: 14px;
          }
        </style>
        <script>
          const getUSD_11_6 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("usd-11-6").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getUSD_11_6;
            }, 43200000);
            getUSD_11_6();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-rates-M-11-7 rates-S">
        <p>EUR</p>
        <div class="space-div-7-7"></div>
        <p id="eur-11-7">0,00</p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-2: calc(246px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-M-11-7 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(540px * 1.34);
            left: calc(16px * 1.34);
          }
          .widget-rates-M-11-7 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
            font-weight: 400;
          }
          .widget-rates-M-11-7 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-7 {
            width: 14px;
          }
        </style>
        <script>
          const getEUR_11_7 = () => {
            fetch("https://www.cbr-xml-daily.ru/daily_json.js", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("eur-11-7").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
              });
          };

          setTimeout(() => {
            setInterval(() => {
              getEUR_11_7;
            }, 43200000);
            getEUR_11_7();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-news-11-2 news-L">
        <div class="left-line-11-2"></div>
        <div><p id="header-news-11-2">------</p></div>
        <div class="left-line-11-2"></div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-2 {
            width: var(--size-4);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: calc(278px * 1.34);
            top: calc(409px * 1.34);
          }
          .widget-news-11-2 div:nth-child(2) {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .widget-news-11-2 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: center;
            padding-left: 32px;
            padding-right: 32px;
          }
          .left-line-11-2 {
            width: 40%;
            height: 3px;
            background-color: var(--text-color);
            margin-top: 26px;
            margin-bottom: 26px;
          }
        </style>
        <script>
          const getNews_11_2 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("header-news-11-2").innerHTML =
                  result[0];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_2();
            }, 300000);
            getNews_11_2();
          }, 5000);
        </script>
      </div>
      <div class="design-1 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(671px * 1.34);
          }
          .video img {
            width: calc(770px * 1.34);
            height: calc(432px * 1.34);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-1 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.34);
            --size-3: calc(377px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(273px * 1.34);
            height: calc(293px * 1.34);
            position: absolute;
            left: calc(16px * 1.34);
            top: calc(1119px * 1.34);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(483px * 1.34);
            height: calc(162px * 1.34);
            position: absolute;
            top: calc(1119px * 1.34);
            left: calc(305px * 1.34);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.34);
            --size-4: calc(508px * 1.34);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(483px * 1.34);
            height: var(--size-1);
            position: absolute;
            top: calc(1297px * 1.34);
            left: calc(305px * 1.34);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(802px * 1.34);
      height: calc(1426px * 1.34);
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;

export const theme18hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 18 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-3 widget-digital-clock-XL-11-1 digital-clock-XL">
        <p id="hour-minutes11-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-digital-clock-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(437px * 1.8);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(16px * 1.8);
          }
          .widget-digital-clock-XL-11-1 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
        </style>
        <script>
          setInterval(function setTime_11_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-3 widget-weather-XL-11-1 weather-XL">
        <div class="current-weather-11-1">
          <div>
            <p id="current-weather-11-1"></p>
            <p id="status-weather-11-1"></p>
          </div>
          <img id="current-status-img-11-1" src="" alt="" />
        </div>
        <div class="weather-per-day-11-1">
          <div>
            <img id="status-img-11-1-1" src="" alt="" />
            <p>Утро</p>
          </div>
          <div>
            <img id="status-img-11-1-2" src="" alt="" />
            <p>День</p>
          </div>
          <div>
            <img id="status-img-11-1-3" src="" alt="" />
            <p>Вечер</p>
          </div>
          <div>
            <img id="status-img-11-1-4" src="" alt="" />
            <p>Ночь</p>
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(437px * 1.8);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(278px * 1.8);
          }

          .current-weather-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .current-weather-11-1 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 70px;
            font-weight: 300;
            text-align: start;
          }
          .current-weather-11-1 p:nth-child(2) {
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .current-weather-11-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .weather-per-day-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .weather-per-day-11-1 p {
            font-family: rubik;
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .weather-per-day-11-1 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .weather-per-day-11-1 img {
            width: 46px;
            height: 46px;
          }
        </style>
        <script>
          const get_weather_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-1").innerHTML =
                  result[0][0];
                document.getElementById("status-weather-11-1").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/dark_weather_clear.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/dark_weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/dark_weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-11-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-11-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-11-1-3")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][3][1]) {
                    document
                      .getElementById("status-img-11-1-4")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              get_weather_11_1;
            }, 300000);
            get_weather_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-3 widget-calendar-XL-11-1 calendar-XL">
        <table id="calendar11-1">
          <thead>
            <tr>
              <td style="font-weight: 500; text-align: center" colspan="7"></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-11-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3: calc(377px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          #calendar11-1 {
            text-align: center;
            font-size: 26px;
            color: var(--text-color);
            font-weight: 300;
            border-spacing: 15px 5px;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .widget-calendar-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Rubik;
            width: var(--size-4);
            height: var(--size-3);
            position: absolute;
            top: calc(16px * 1.8);
            left: calc(469px * 1.8);
          }
          #today-11-1 {
            color: var(--background-widgets);
            background-color: var(--text-color);
            border-radius: 16px;
          }
          #body-calendar-11-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 50px;
          }
          thead tr td {
            width: 46px;
          }
        </style>

        <script>
          const getCalendar_11_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar11-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_11_1();
        </script>
      </div>

      <div class="design-3 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-2: calc(246px * 1.8);
            --style2: "";
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 1.8);
            left: calc(469px * 1.8);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-3 widget-metals-11-4 metal-S">
        <div>
          <p class="name-metal-11-4">Нефть</p>
          <div class="widget-metal-last-11-4">
            <p id="oil-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-4">Серебро</p>
          <div class="widget-metal-last-11-4">
            <p id="silver-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-4">Золото</p>
          <div class="widget-metal-last-11-4">
            <p id="gold-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-11-4 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(246px * 1.8);
            height: var(--size-1);
            position: absolute;
            left: calc(731px * 1.8);
            top: calc(409px * 1.8);
          }
          .widget-metals-11-4 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-4 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-4 {
            width: 6px;
          }
          .widget-metals-L-11-4 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-4 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_4 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-4").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-4-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-4").innerHTML = result[1];
              });
          };
          const getMetal_11_4 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-4").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-4-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-4").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-4").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-4-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-4").innerHTML =
                  result.rates.USDXAU.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_4();
              getMetal_11_4();
            }, 172800000);
            getOil_11_4();
            getMetal_11_4();
          }, 1000);
        </script>
      </div>
      <div class="design-3 widget-rates-L-11-1 rates-XL">
        <div>
          <p>\$</p>
          <div class="space-div-7-1"></div>
          <p id="usd-11-1">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-1" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-L-11-1 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(540px * 1.8);
          }

          .widget-rates-L-11-1 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-1 div:nth-child(3) {
            display: flex;
            justify-content: center;
          }
          .widget-rates-L-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-1 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getUSD_11_1 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const result = await response.json();
            return result;
          };
          const myChart_11_1 = new Chart(
            document.getElementById("diagram-11-1").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],

                    pointRadius: 0,
                    borderColor: "rgba(55,55,55,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getUSD_11_1().then((result) => {
                document.getElementById("usd-11-1").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                myChart_11_1.data.datasets[0].data.splice(0, 1);
                myChart_11_1.data.datasets[0].data.push(
                  result.Valute.USD.Value.toFixed(2)
                );
                myChart_11_1.update();
              });
            }, 43200000);
            getUSD_11_1().then((result) => {
              document.getElementById("usd-11-1").innerHTML =
                result.Valute.USD.Value.toFixed(2);

              const myChart_11_1_1 = new Chart(
                document.getElementById("diagram-11-1").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(55,55,55,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_1_1.data.datasets[0].data.splice(0, 1);
              myChart_11_1_1.data.datasets[0].data.push(
                result.Valute.USD.Value.toFixed(2)
              );
              myChart_11_1_1.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-rates-L-11-2 rates-XL">
        <div>
          <p>€</p>
          <div class="space-div-7-2"></div>
          <p id="eur-11-2">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-2" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-L-11-2 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(409px * 1.8);
            top: calc(540px * 1.8);
          }
          .widget-rates-L-11-2 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-2 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-2 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getEUR_11_2 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const data = await response.json();
            return data;
          };
          const myChart_11_2 = new Chart(
            document.getElementById("diagram-11-2").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
                    pointRadius: 0,
                    borderColor: "rgba(55,55,55,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getEUR_11_2().then((result) => {
                document.getElementById("eur-11-2").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
                myChart_11_2.data.datasets[0].data.splice(0, 1);
                myChart_11_2.data.datasets[0].data.push(
                  result.Valute.EUR.Value.toFixed(2)
                );
                myChart_11_2.update();
              });
            }, 43200000);
            getEUR_11_2().then((result) => {
              document.getElementById("eur-11-2").innerHTML =
                result.Valute.EUR.Value.toFixed(2);

              const myChart_11_2_2 = new Chart(
                document.getElementById("diagram-11-2").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(55,55,55,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_2_2.data.datasets[0].data.splice(0, 1);
              myChart_11_2_2.data.datasets[0].data.push(
                result.Valute.EUR.Value.toFixed(2)
              );
              myChart_11_2_2.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-1 {
            width: calc(572px * 1.8);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: calc(540px * 1.8);
            left: calc(802px * 1.8);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(1390px * 1.8);
            top: calc(540px * 1.8);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/dark_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/dark_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/dark_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/dark_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(1390px * 1.8);
            top: calc(671px * 1.8);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
      <div class="design-3 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(993px * 1.8);
            top: calc(16px * 1.8);
          }
          .video img {
            width: calc(905px * 1.8);
            height: calc(508px * 1.8);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1914px * 1.8);
      height: calc(802px * 1.8);
      background-color: rgba(234, 234, 234, 1);
    }
  </style>
</html>
`;
export const theme18ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 18 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-3 widget-digital-clock-XL-11-1 digital-clock-XL">
        <p id="hour-minutes11-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-digital-clock-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.8);
            left: calc(16px * 1.8);
          }
          .widget-digital-clock-XL-11-1 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
        </style>
        <script>
          setInterval(function setTime_11_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-3 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.8);
            top: calc(16px * 1.8);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/dark_weather_clear.svg",
                  Облачно:
                    "http://212.41.9.251:8000/static/dark_weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/dark_weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/dark_weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-calendar-XL-11-1 calendar-XL">
        <table id="calendar11-1">
          <thead>
            <tr>
              <td style="font-weight: 500; text-align: center" colspan="7"></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-11-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3: calc(377px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          #calendar11-1 {
            text-align: center;
            font-size: 26px;
            color: var(--text-color);
            font-weight: 300;
            border-spacing: 15px 5px;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .widget-calendar-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Rubik;
            width: var(--size-4);
            height: var(--size-3);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(278px * 1.8);
          }
          #today-11-1 {
            color: var(--background-widgets);
            background-color: var(--text-color);
            border-radius: 16px;
          }
          #body-calendar-11-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 50px;
          }
          thead tr td {
            width: 46px;
          }
        </style>

        <script>
          const getCalendar_11_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar11-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_11_1();
        </script>
      </div>

      <div class="design-3 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-2: calc(246px * 1.8);
            --style2: "";
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(278px * 1.8);
            left: calc(540px * 1.8);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-3 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.8);
            top: calc(409px * 1.8);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-3 widget-rates-L-11-1 rates-XL">
        <div>
          <p>\$</p>
          <div class="space-div-7-1"></div>
          <p id="usd-11-1">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-1" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-L-11-1 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(671px * 1.8);
          }

          .widget-rates-L-11-1 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-1 div:nth-child(3) {
            display: flex;
            justify-content: center;
          }
          .widget-rates-L-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-1 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getUSD_11_1 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const result = await response.json();
            return result;
          };
          const myChart_11_1 = new Chart(
            document.getElementById("diagram-11-1").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],

                    pointRadius: 0,
                    borderColor: "rgba(55,55,55,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getUSD_11_1().then((result) => {
                document.getElementById("usd-11-1").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                myChart_11_1.data.datasets[0].data.splice(0, 1);
                myChart_11_1.data.datasets[0].data.push(
                  result.Valute.USD.Value.toFixed(2)
                );
                myChart_11_1.update();
              });
            }, 43200000);
            getUSD_11_1().then((result) => {
              document.getElementById("usd-11-1").innerHTML =
                result.Valute.USD.Value.toFixed(2);

              const myChart_11_1_1 = new Chart(
                document.getElementById("diagram-11-1").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(55,55,55,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_1_1.data.datasets[0].data.splice(0, 1);
              myChart_11_1_1.data.datasets[0].data.push(
                result.Valute.USD.Value.toFixed(2)
              );
              myChart_11_1_1.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-rates-L-11-2 rates-XL">
        <div>
          <p>€</p>
          <div class="space-div-7-2"></div>
          <p id="eur-11-2">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-2" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-rates-L-11-2 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            top: calc(671px * 1.8);
            left: calc(409px * 1.8);
          }
          .widget-rates-L-11-2 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-2 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-2 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getEUR_11_2 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const data = await response.json();
            return data;
          };
          const myChart_11_2 = new Chart(
            document.getElementById("diagram-11-2").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
                    pointRadius: 0,
                    borderColor: "rgba(55,55,55,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getEUR_11_2().then((result) => {
                document.getElementById("eur-11-2").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
                myChart_11_2.data.datasets[0].data.splice(0, 1);
                myChart_11_2.data.datasets[0].data.push(
                  result.Valute.EUR.Value.toFixed(2)
                );
                myChart_11_2.update();
              });
            }, 43200000);
            getEUR_11_2().then((result) => {
              document.getElementById("eur-11-2").innerHTML =
                result.Valute.EUR.Value.toFixed(2);

              const myChart_11_2_2 = new Chart(
                document.getElementById("diagram-11-2").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(55,55,55,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_2_2.data.datasets[0].data.splice(0, 1);
              myChart_11_2_2.data.datasets[0].data.push(
                result.Valute.EUR.Value.toFixed(2)
              );
              myChart_11_2_2.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-3 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-news-11-1 {
            width: calc(770px * 1.8);
            height: calc(255px * 1.8);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(933px * 1.8);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>
      <div class="design-3 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1204px * 1.8);
          }
          .video img {
            width: calc(770px * 1.8);
            height: calc(432px * 1.8);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-3 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --text-color: rgba(55, 55, 55, 1);
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(770px * 1.8);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1652px * 1.8);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-3 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/dark_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/dark_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/dark_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/dark_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-3 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(770px * 1.8);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1783px * 1.8);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(802px * 1.8);
      height: calc(1914px * 1.8);
      background-color: rgba(234, 234, 234, 1);
    }
  </style>
</html>
`;

export const theme19hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 19 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-5 widget-digital-clock-XL-11-1 digital-clock-XL">
        <p id="hour-minutes11-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(437px * 1.8);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(16px * 1.8);
          }
          .widget-digital-clock-XL-11-1 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
        </style>
        <script>
          setInterval(function setTime_11_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-weather-XL-11-1 weather-XL">
        <div class="current-weather-11-1">
          <div>
            <p id="current-weather-11-1"></p>
            <p id="status-weather-11-1"></p>
          </div>
          <img id="current-status-img-11-1" src="" alt="" />
        </div>
        <div class="weather-per-day-11-1">
          <div>
            <img id="status-img-11-1-1" src="" alt="" />
            <p>Утро</p>
          </div>
          <div>
            <img id="status-img-11-1-2" src="" alt="" />
            <p>День</p>
          </div>
          <div>
            <img id="status-img-11-1-3" src="" alt="" />
            <p>Вечер</p>
          </div>
          <div>
            <img id="status-img-11-1-4" src="" alt="" />
            <p>Ночь</p>
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(437px * 1.8);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(278px * 1.8);
          }

          .current-weather-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .current-weather-11-1 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 70px;
            font-weight: 300;
            text-align: start;
          }
          .current-weather-11-1 p:nth-child(2) {
            font-size: 26px;
            font-weight: 300;
            color: var(--background-widgets);
          }
          .current-weather-11-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .weather-per-day-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .weather-per-day-11-1 p {
            font-family: rubik;
            font-size: 26px;
            font-weight: 300;
            color: var(--background-widgets);
          }
          .weather-per-day-11-1 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .weather-per-day-11-1 img {
            width: 46px;
            height: 46px;
          }
        </style>
        <script>
          const get_weather_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-1").innerHTML =
                  result[0][0];
                document.getElementById("status-weather-11-1").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-11-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-11-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-11-1-3")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][3][1]) {
                    document
                      .getElementById("status-img-11-1-4")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              get_weather_11_1;
            }, 300000);
            get_weather_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-5 widget-calendar-XL-11-1 calendar-XL">
        <table id="calendar11-1">
          <thead>
            <tr>
              <td
                style="
                  font-weight: 500;
                  text-align: center;
                  width: 100%;
                  height: 100%;
                "
                colspan="7"
              ></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-11-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3: calc(377px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          #calendar11-1 {
            text-align: center;
            font-size: 26px;
            color: var(--text-color);
            font-weight: 300;
            border-spacing: 15px 5px;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .widget-calendar-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Rubik;
            width: var(--size-4);
            height: var(--size-3);
            position: absolute;
            top: calc(16px * 1.8);
            left: calc(469px * 1.8);
          }
          #today-11-1 {
            color: var(--background-widgets);
            background-color: var(--text-color);
            border-radius: 16px;
          }
          #body-calendar-11-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 50px;
          }
          thead tr td {
            width: 46px;
          }
        </style>

        <script>
          const getCalendar_11_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar11-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_11_1();
        </script>
      </div>

      <div class="design-5 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-2: calc(246px * 1.8);
            --style2: "";
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 1.8);
            left: calc(469px * 1.8);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-5 widget-metals-11-4 metal-S">
        <div>
          <p class="name-metal-11-4">Нефть</p>
          <div class="widget-metal-last-11-4">
            <p id="oil-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-4">Серебро</p>
          <div class="widget-metal-last-11-4">
            <p id="silver-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-4">Золото</p>
          <div class="widget-metal-last-11-4">
            <p id="gold-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-11-4 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(246px * 1.8);
            height: calc(115px * 1.8);
            position: absolute;
            top: calc(409px * 1.8);
            left: calc(731px * 1.8);
          }
          .widget-metals-11-4 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-4 {
            text-align: start;
            width: 106px;
            color: var(--background-widgets);
          }
          .space-div-8-4 {
            width: 6px;
          }
          .widget-metals-L-11-4 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-4 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_4 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-4").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-4-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-4").innerHTML = result[1];
              });
          };
          const getMetal_11_4 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-4").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-4-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-4").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-4").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-4-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-4").innerHTML =
                  result.rates.USDXAU.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_4();
              getMetal_11_4();
            }, 172800000);
            getOil_11_4();
            getMetal_11_4();
          }, 1000);
        </script>
      </div>

      <div class="design-5 widget-rates-L-11-1 rates-XL">
        <div>
          <p>\$</p>
          <div class="space-div-7-1"></div>
          <p id="usd-11-1">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-1" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-1 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(540px * 1.8);
          }

          .widget-rates-L-11-1 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-1 div:nth-child(3) {
            display: flex;
            justify-content: center;
          }
          .widget-rates-L-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-1 p:first-child {
            color: var(--background-widgets);
          }
          .space-div-7-1 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getUSD_11_1 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const result = await response.json();
            return result;
          };
          const myChart_11_1 = new Chart(
            document.getElementById("diagram-11-1").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],

                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getUSD_11_1().then((result) => {
                document.getElementById("usd-11-1").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                myChart_11_1.data.datasets[0].data.splice(0, 1);
                myChart_11_1.data.datasets[0].data.push(
                  result.Valute.USD.Value.toFixed(2)
                );
                myChart_11_1.update();
              });
            }, 43200000);
            getUSD_11_1().then((result) => {
              document.getElementById("usd-11-1").innerHTML =
                result.Valute.USD.Value.toFixed(2);

              const myChart_11_1_1 = new Chart(
                document.getElementById("diagram-11-1").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          87.37, 87.21, 87.07, 88.05, 88.0, 84.96, 85.75, 87.99,
                          87.95, 88.12,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_1_1.data.datasets[0].data.splice(0, 1);
              myChart_11_1_1.data.datasets[0].data.push(
                result.Valute.USD.Value.toFixed(2)
              );
              myChart_11_1_1.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-rates-L-11-2 rates-XL">
        <div>
          <p>€</p>
          <div class="space-div-7-2"></div>
          <p id="eur-11-2">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-2" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-2 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(409px * 1.8);
            top: calc(540px * 1.8);
          }
          .widget-rates-L-11-2 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-2 p:first-child {
            color: var(--background-widgets);
          }
          .space-div-7-2 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getEUR_11_2 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const data = await response.json();
            return data;
          };
          const myChart_11_2 = new Chart(
            document.getElementById("diagram-11-2").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getEUR_11_2().then((result) => {
                document.getElementById("eur-11-2").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
                myChart_11_2.data.datasets[0].data.splice(0, 1);
                myChart_11_2.data.datasets[0].data.push(
                  result.Valute.EUR.Value.toFixed(2)
                );
                myChart_11_2.update();
              });
            }, 43200000);
            getEUR_11_2().then((result) => {
              document.getElementById("eur-11-2").innerHTML =
                result.Valute.EUR.Value.toFixed(2);

              const myChart_11_2_2 = new Chart(
                document.getElementById("diagram-11-2").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          94.08, 93.74, 94.11, 90.99, 92.39, 93.96, 93.69,
                          94.58, 94.98, 95.1,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_2_2.data.datasets[0].data.splice(0, 1);
              myChart_11_2_2.data.datasets[0].data.push(
                result.Valute.EUR.Value.toFixed(2)
              );
              myChart_11_2_2.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: calc(572px * 1.8);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: calc(540px * 1.8);
            left: calc(802px * 1.8);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(1390px * 1.8);
            top: calc(540px * 1.8);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: var(--background-widgets);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(1390px * 1.8);
            top: calc(671px * 1.8);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
      <div class="design-5 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(993px * 1.8);
            top: calc(16px * 1.8);
          }
          .video img {
            width: calc(905px * 1.8);
            height: calc(508px * 1.8);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1914px * 1.8);
      height: calc(802px * 1.8);
      background-image: url("http://212.41.9.251:8000/static/background2.svg");
      background-size: cover;
    }
  </style>
</html>
`;
export const theme19ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 19 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-5 widget-digital-clock-XL-11-1 digital-clock-XL">
        <p id="hour-minutes11-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.8);
            left: calc(16px * 1.8);
          }
          .widget-digital-clock-XL-11-1 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
        </style>
        <script>
          setInterval(function setTime_11_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-5 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.8);
            top: calc(16px * 1.8);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: var(--background-widgets);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-calendar-XL-11-1 calendar-XL">
        <table id="calendar11-1">
          <thead>
            <tr>
              <td
                style="
                  font-weight: 500;
                  text-align: center;
                  width: 100%;
                  height: 100%;
                "
                colspan="7"
              ></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-11-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3: calc(377px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          #calendar11-1 {
            text-align: center;
            font-size: 26px;
            color: var(--text-color);
            font-weight: 300;
            border-spacing: 15px 5px;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .widget-calendar-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Rubik;
            width: var(--size-4);
            height: var(--size-3);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(278px * 1.8);
          }
          #today-11-1 {
            color: var(--background-widgets);
            background-color: var(--text-color);
            border-radius: 16px;
          }
          #body-calendar-11-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 50px;
          }
          thead tr td {
            width: 46px;
          }
        </style>

        <script>
          const getCalendar_11_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar11-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_11_1();
        </script>
      </div>

      <div class="design-5 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-2: calc(246px * 1.8);
            --style2: "";
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(278px * 1.8);
            left: calc(540px * 1.8);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-5 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.8);
            top: calc(409px * 1.8);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: var(--background-widgets);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-5 widget-rates-L-11-1 rates-XL">
        <div>
          <p>\$</p>
          <div class="space-div-7-1"></div>
          <p id="usd-11-1">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-1" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-1 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(671px * 1.8);
          }

          .widget-rates-L-11-1 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-1 div:nth-child(3) {
            display: flex;
            justify-content: center;
          }
          .widget-rates-L-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-1 p:first-child {
            color: var(--background-widgets);
          }
          .space-div-7-1 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getUSD_11_1 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const result = await response.json();
            return result;
          };
          const myChart_11_1 = new Chart(
            document.getElementById("diagram-11-1").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],

                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getUSD_11_1().then((result) => {
                document.getElementById("usd-11-1").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                myChart_11_1.data.datasets[0].data.splice(0, 1);
                myChart_11_1.data.datasets[0].data.push(
                  result.Valute.USD.Value.toFixed(2)
                );
                myChart_11_1.update();
              });
            }, 43200000);
            getUSD_11_1().then((result) => {
              document.getElementById("usd-11-1").innerHTML =
                result.Valute.USD.Value.toFixed(2);

              const myChart_11_1_1 = new Chart(
                document.getElementById("diagram-11-1").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          87.37, 87.21, 87.07, 88.05, 88.0, 84.96, 85.75, 87.99,
                          87.95, 88.12,
                        ],

                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_1_1.data.datasets[0].data.splice(0, 1);
              myChart_11_1_1.data.datasets[0].data.push(
                result.Valute.USD.Value.toFixed(2)
              );
              myChart_11_1_1.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-rates-L-11-2 rates-XL">
        <div>
          <p>€</p>
          <div class="space-div-7-2"></div>
          <p id="eur-11-2">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-2" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-2 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            top: calc(671px * 1.8);
            left: calc(409px * 1.8);
          }
          .widget-rates-L-11-2 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-2 p:first-child {
            color: var(--background-widgets);
          }
          .space-div-7-2 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getEUR_11_2 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const data = await response.json();
            return data;
          };
          const myChart_11_2 = new Chart(
            document.getElementById("diagram-11-2").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getEUR_11_2().then((result) => {
                document.getElementById("eur-11-2").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
                myChart_11_2.data.datasets[0].data.splice(0, 1);
                myChart_11_2.data.datasets[0].data.push(
                  result.Valute.EUR.Value.toFixed(2)
                );
                myChart_11_2.update();
              });
            }, 43200000);
            getEUR_11_2().then((result) => {
              document.getElementById("eur-11-2").innerHTML =
                result.Valute.EUR.Value.toFixed(2);

              const myChart_11_2_2 = new Chart(
                document.getElementById("diagram-11-2").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          94.08, 93.74, 94.11, 90.99, 92.39, 93.96, 93.69,
                          94.58, 94.98, 95.1,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_2_2.data.datasets[0].data.splice(0, 1);
              myChart_11_2_2.data.datasets[0].data.push(
                result.Valute.EUR.Value.toFixed(2)
              );
              myChart_11_2_2.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-5 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: calc(770px * 1.8);
            height: calc(255px * 1.8);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(933px * 1.8);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>
      <div class="design-5 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1204px * 1.8);
          }
          .video img {
            width: calc(770px * 1.8);
            height: calc(432px * 1.8);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-5 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(770px * 1.8);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1652px * 1.8);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: var(--background-widgets);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-5 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(208, 208, 208, 0.4);
            --color-icon: "";
          }
          .design-5 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(770px * 1.8);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1783px * 1.8);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(802px * 1.8);
      height: calc(1914px * 1.8);
      background-image: url("http://212.41.9.251:8000/static/background2.svg");
    }
  </style>
</html>
`;

export const theme20hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 20 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-4 widget-digital-clock-XL-11-1 digital-clock-XL">
        <p id="hour-minutes11-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(437px * 1.8);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(16px * 1.8);
          }
          .widget-digital-clock-XL-11-1 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
        </style>
        <script>
          setInterval(function setTime_11_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-4 widget-weather-XL-11-1 weather-XL">
        <div class="current-weather-11-1">
          <div>
            <p id="current-weather-11-1"></p>
            <p id="status-weather-11-1"></p>
          </div>
          <img id="current-status-img-11-1" src="" alt="" />
        </div>
        <div class="weather-per-day-11-1">
          <div>
            <img id="status-img-11-1-1" src="" alt="" />
            <p>Утро</p>
          </div>
          <div>
            <img id="status-img-11-1-2" src="" alt="" />
            <p>День</p>
          </div>
          <div>
            <img id="status-img-11-1-3" src="" alt="" />
            <p>Вечер</p>
          </div>
          <div>
            <img id="status-img-11-1-4" src="" alt="" />
            <p>Ночь</p>
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(437px * 1.8);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(278px * 1.8);
          }

          .current-weather-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .current-weather-11-1 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 70px;
            font-weight: 300;
            text-align: start;
          }
          .current-weather-11-1 p:nth-child(2) {
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .current-weather-11-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .weather-per-day-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .weather-per-day-11-1 p {
            font-family: rubik;
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .weather-per-day-11-1 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .weather-per-day-11-1 img {
            width: 46px;
            height: 46px;
          }
        </style>
        <script>
          const get_weather_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-1").innerHTML =
                  result[0][0];
                document.getElementById("status-weather-11-1").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-11-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-11-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-11-1-3")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][3][1]) {
                    document
                      .getElementById("status-img-11-1-4")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              get_weather_11_1;
            }, 300000);
            get_weather_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-4 widget-calendar-XL-11-1 calendar-XL">
        <table id="calendar11-1">
          <thead>
            <tr>
              <td
                style="
                  font-weight: 500;
                  text-align: center;
                  width: 100%;
                  height: 100%;
                "
                colspan="7"
              ></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-11-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3: calc(377px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          #calendar11-1 {
            text-align: center;
            font-size: 26px;
            color: var(--text-color);
            font-weight: 300;
            border-spacing: 15px 5px;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .widget-calendar-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Rubik;
            width: var(--size-4);
            height: var(--size-3);
            position: absolute;
            top: calc(16px * 1.8);
            left: calc(469px * 1.8);
          }
          #today-11-1 {
            color: var(--background-widgets);
            background-color: var(--text-color);
            border-radius: 16px;
          }
          #body-calendar-11-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 50px;
          }
          thead tr td {
            width: 46px;
          }
        </style>

        <script>
          const getCalendar_11_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar11-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_11_1();
        </script>
      </div>

      <div class="design-4 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-2: calc(246px * 1.8);
            --style2: "";
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 1.8);
            left: calc(469px * 1.8);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-4 widget-metals-11-4 metal-S">
        <div>
          <p class="name-metal-11-4">Нефть</p>
          <div class="widget-metal-last-11-4">
            <p id="oil-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-4">Серебро</p>
          <div class="widget-metal-last-11-4">
            <p id="silver-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-4">Золото</p>
          <div class="widget-metal-last-11-4">
            <p id="gold-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-11-4 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(246px * 1.8);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 1.8);
            left: calc(731px * 1.8);
          }
          .widget-metals-11-4 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-4 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-4 {
            width: 6px;
          }
          .widget-metals-L-11-4 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-4 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_4 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-4").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-4-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-4").innerHTML = result[1];
              });
          };
          const getMetal_11_4 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-4").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-4-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-4").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-4").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-4-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-4").innerHTML =
                  result.rates.USDXAU.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_4();
              getMetal_11_4();
            }, 172800000);
            getOil_11_4();
            getMetal_11_4();
          }, 1000);
        </script>
      </div>

      <div class="design-4 widget-rates-L-11-1 rates-XL">
        <div>
          <p>\$</p>
          <div class="space-div-7-1"></div>
          <p id="usd-11-1">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-1" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-1 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(540px * 1.8);
          }

          .widget-rates-L-11-1 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-1 div:nth-child(3) {
            display: flex;
            justify-content: center;
          }
          .widget-rates-L-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-1 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getUSD_11_1 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const result = await response.json();
            return result;
          };
          const myChart_11_1 = new Chart(
            document.getElementById("diagram-11-1").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],

                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getUSD_11_1().then((result) => {
                document.getElementById("usd-11-1").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                myChart_11_1.data.datasets[0].data.splice(0, 1);
                myChart_11_1.data.datasets[0].data.push(
                  result.Valute.USD.Value.toFixed(2)
                );
                myChart_11_1.update();
              });
            }, 43200000);
            getUSD_11_1().then((result) => {
              document.getElementById("usd-11-1").innerHTML =
                result.Valute.USD.Value.toFixed(2);

              const myChart_11_1_1 = new Chart(
                document.getElementById("diagram-11-1").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          87.37, 87.21, 87.07, 88.05, 88.0, 84.96, 85.75, 87.99,
                          87.95, 88.12,
                        ],

                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_1_1.data.datasets[0].data.splice(0, 1);
              myChart_11_1_1.data.datasets[0].data.push(
                result.Valute.USD.Value.toFixed(2)
              );
              myChart_11_1_1.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-rates-L-11-2 rates-XL">
        <div>
          <p>€</p>
          <div class="space-div-7-2"></div>
          <p id="eur-11-2">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-2" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-2 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(409px * 1.8);
            top: calc(540px * 1.8);
          }
          .widget-rates-L-11-2 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-2 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-2 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getEUR_11_2 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const data = await response.json();
            return data;
          };
          const myChart_11_2 = new Chart(
            document.getElementById("diagram-11-2").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getEUR_11_2().then((result) => {
                document.getElementById("eur-11-2").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
                myChart_11_2.data.datasets[0].data.splice(0, 1);
                myChart_11_2.data.datasets[0].data.push(
                  result.Valute.EUR.Value.toFixed(2)
                );
                myChart_11_2.update();
              });
            }, 43200000);
            getEUR_11_2().then((result) => {
              document.getElementById("eur-11-2").innerHTML =
                result.Valute.EUR.Value.toFixed(2);

              const myChart_11_2_2 = new Chart(
                document.getElementById("diagram-11-2").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          94.08, 93.74, 94.11, 90.99, 92.39, 93.96, 93.69,
                          94.58, 94.98, 95.1,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_2_2.data.datasets[0].data.splice(0, 1);
              myChart_11_2_2.data.datasets[0].data.push(
                result.Valute.EUR.Value.toFixed(2)
              );
              myChart_11_2_2.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: calc(572px * 1.8);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: calc(540px * 1.8);
            left: calc(802px * 1.8);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(1390px * 1.8);
            top: calc(540px * 1.8);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(1390px * 1.8);
            top: calc(671px * 1.8);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
      <div class="design-4 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(993px * 1.8);
            top: calc(16px * 1.8);
          }
          .video img {
            width: calc(905px * 1.8);
            height: calc(508px * 1.8);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1914px * 1.8);
      height: calc(802px * 1.8);
      background-image: url("http://212.41.9.251:8000/static/background1.svg");
      background-size: cover;
    }
  </style>
</html>
`;
export const theme20ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 20 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-4 widget-digital-clock-XL-11-1 digital-clock-XL">
        <p id="hour-minutes11-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.8);
            left: calc(16px * 1.8);
          }
          .widget-digital-clock-XL-11-1 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
        </style>
        <script>
          setInterval(function setTime_11_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-4 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.8);
            top: calc(16px * 1.8);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-calendar-XL-11-1 calendar-XL">
        <table id="calendar11-1">
          <thead>
            <tr>
              <td
                style="
                  font-weight: 500;
                  text-align: center;
                  width: 100%;
                  height: 100%;
                "
                colspan="7"
              ></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-11-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3: calc(377px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          #calendar11-1 {
            text-align: center;
            font-size: 26px;
            color: var(--text-color);
            font-weight: 300;
            border-spacing: 15px 5px;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .widget-calendar-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Rubik;
            width: var(--size-4);
            height: var(--size-3);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(278px * 1.8);
          }
          #today-11-1 {
            color: var(--background-widgets);
            background-color: var(--text-color);
            border-radius: 16px;
          }
          #body-calendar-11-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 50px;
          }
          thead tr td {
            width: 46px;
          }
        </style>

        <script>
          const getCalendar_11_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar11-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_11_1();
        </script>
      </div>

      <div class="design-4 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-2: calc(246px * 1.8);
            --style2: "";
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(278px * 1.8);
            left: calc(540px * 1.8);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-4 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.8);
            top: calc(409px * 1.8);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-4 widget-rates-L-11-1 rates-XL">
        <div>
          <p>\$</p>
          <div class="space-div-7-1"></div>
          <p id="usd-11-1">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-1" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-1 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(671px * 1.8);
          }

          .widget-rates-L-11-1 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-1 div:nth-child(3) {
            display: flex;
            justify-content: center;
          }
          .widget-rates-L-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-1 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getUSD_11_1 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const result = await response.json();
            return result;
          };
          const myChart_11_1 = new Chart(
            document.getElementById("diagram-11-1").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],

                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getUSD_11_1().then((result) => {
                document.getElementById("usd-11-1").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                myChart_11_1.data.datasets[0].data.splice(0, 1);
                myChart_11_1.data.datasets[0].data.push(
                  result.Valute.USD.Value.toFixed(2)
                );
                myChart_11_1.update();
              });
            }, 43200000);
            getUSD_11_1().then((result) => {
              document.getElementById("usd-11-1").innerHTML =
                result.Valute.USD.Value.toFixed(2);

              const myChart_11_1_1 = new Chart(
                document.getElementById("diagram-11-1").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          87.37, 87.21, 87.07, 88.05, 88.0, 84.96, 85.75, 87.99,
                          87.95, 88.12,
                        ],

                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_1_1.data.datasets[0].data.splice(0, 1);
              myChart_11_1_1.data.datasets[0].data.push(
                result.Valute.USD.Value.toFixed(2)
              );
              myChart_11_1_1.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-rates-L-11-2 rates-XL">
        <div>
          <p>€</p>
          <div class="space-div-7-2"></div>
          <p id="eur-11-2">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-2" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-2 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            top: calc(671px * 1.8);
            left: calc(409px * 1.8);
          }
          .widget-rates-L-11-2 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-2 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-2 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getEUR_11_2 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const data = await response.json();
            return data;
          };
          const myChart_11_2 = new Chart(
            document.getElementById("diagram-11-2").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getEUR_11_2().then((result) => {
                document.getElementById("eur-11-2").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
                myChart_11_2.data.datasets[0].data.splice(0, 1);
                myChart_11_2.data.datasets[0].data.push(
                  result.Valute.EUR.Value.toFixed(2)
                );
                myChart_11_2.update();
              });
            }, 43200000);
            getEUR_11_2().then((result) => {
              document.getElementById("eur-11-2").innerHTML =
                result.Valute.EUR.Value.toFixed(2);

              const myChart_11_2_2 = new Chart(
                document.getElementById("diagram-11-2").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          94.08, 93.74, 94.11, 90.99, 92.39, 93.96, 93.69,
                          94.58, 94.98, 95.1,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_2_2.data.datasets[0].data.splice(0, 1);
              myChart_11_2_2.data.datasets[0].data.push(
                result.Valute.EUR.Value.toFixed(2)
              );
              myChart_11_2_2.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-4 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: calc(770px * 1.8);
            height: calc(255px * 1.8);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(933px * 1.8);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>
      <div class="design-4 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1204px * 1.8);
          }
          .video img {
            width: calc(770px * 1.8);
            height: calc(432px * 1.8);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-4 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(770px * 1.8);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1652px * 1.8);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-4 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(0, 0, 0, 0.4);
            --color-icon: "";
          }
          .design-4 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(770px * 1.8);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1783px * 1.8);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(802px * 1.8);
      height: calc(1914px * 1.8);
      background-image: url("http://212.41.9.251:8000/static/background1.svg");
    }
  </style>
</html>
`;

export const theme21hor = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 21 горизонтальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-1 widget-digital-clock-XL-11-1 digital-clock-XL">
        <p id="hour-minutes11-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: calc(437px * 1.8);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(16px * 1.8);
          }
          .widget-digital-clock-XL-11-1 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
        </style>
        <script>
          setInterval(function setTime_11_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-weather-XL-11-1 weather-XL">
        <div class="current-weather-11-1">
          <div>
            <p id="current-weather-11-1"></p>
            <p id="status-weather-11-1"></p>
          </div>
          <img id="current-status-img-11-1" src="" alt="" />
        </div>
        <div class="weather-per-day-11-1">
          <div>
            <img id="status-img-11-1-1" src="" alt="" />
            <p>Утро</p>
          </div>
          <div>
            <img id="status-img-11-1-2" src="" alt="" />
            <p>День</p>
          </div>
          <div>
            <img id="status-img-11-1-3" src="" alt="" />
            <p>Вечер</p>
          </div>
          <div>
            <img id="status-img-11-1-4" src="" alt="" />
            <p>Ночь</p>
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-XL-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(437px * 1.8);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(278px * 1.8);
          }

          .current-weather-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .current-weather-11-1 p {
            color: var(--text-color);
            font-family: rubik;
            font-size: 70px;
            font-weight: 300;
            text-align: start;
          }
          .current-weather-11-1 p:nth-child(2) {
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .current-weather-11-1 img {
            width: 80px;
            height: 80px;
            filter: var(--color-icon);
          }
          .weather-per-day-11-1 {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
          .weather-per-day-11-1 p {
            font-family: rubik;
            font-size: 26px;
            font-weight: 300;
            color: rgba(115, 115, 115, 1);
          }
          .weather-per-day-11-1 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .weather-per-day-11-1 img {
            width: 46px;
            height: 46px;
          }
        </style>
        <script>
          const get_weather_11_1 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-1").innerHTML =
                  result[0][0];
                document.getElementById("status-weather-11-1").innerHTML =
                  result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][0][1]) {
                    document
                      .getElementById("status-img-11-1-1")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][1][1]) {
                    document
                      .getElementById("status-img-11-1-2")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][2][1]) {
                    document
                      .getElementById("status-img-11-1-3")
                      .setAttribute("src", weather[key]);
                  }
                  if (key == result[1][3][1]) {
                    document
                      .getElementById("status-img-11-1-4")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              get_weather_11_1;
            }, 300000);
            get_weather_11_1();
          }, 1000);
        </script>
      </div>

      <div class="design-1 widget-calendar-XL-11-1 calendar-XL">
        <table id="calendar11-1">
          <thead>
            <tr>
              <td
                style="
                  font-weight: 500;
                  text-align: center;
                  width: 100%;
                  height: 100%;
                "
                colspan="7"
              ></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-11-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3: calc(377px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          #calendar11-1 {
            text-align: center;
            font-size: 26px;
            color: var(--text-color);
            font-weight: 300;
            border-spacing: 15px 5px;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .widget-calendar-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Rubik;
            width: var(--size-4);
            height: var(--size-3);
            position: absolute;
            top: calc(16px * 1.8);
            left: calc(469px * 1.8);
          }
          #today-11-1 {
            color: var(--background-widgets);
            background-color: var(--text-color);
            border-radius: 16px;
          }
          #body-calendar-11-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 50px;
          }
          thead tr td {
            width: 46px;
          }
        </style>

        <script>
          const getCalendar_11_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar11-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_11_1();
        </script>
      </div>

      <div class="design-1 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-2: calc(246px * 1.8);
            --style2: "";
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(409px * 1.8);
            left: calc(469px * 1.8);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-1 widget-metals-11-4 metal-S">
        <div>
          <p class="name-metal-11-4">Нефть</p>
          <div class="widget-metal-last-11-4">
            <p id="oil-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-4">Серебро</p>
          <div class="widget-metal-last-11-4">
            <p id="silver-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-4">Золото</p>
          <div class="widget-metal-last-11-4">
            <p id="gold-price-11-4">---,--</p>
            <div class="space-div-8-4"></div>
            <img
              id="updown-11-4-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-11-4 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(246px * 1.8);
            height: var(--size-1);
            position: absolute;
            left: calc(731px * 1.8);
            top: calc(409px * 1.8);
          }
          .widget-metals-11-4 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-4 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-4 {
            width: 6px;
          }
          .widget-metals-L-11-4 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-4 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_4 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-4").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-4-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-4").innerHTML = result[1];
              });
          };
          const getMetal_11_4 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-4").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-4-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-4").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-4").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-4-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-4-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-4").innerHTML =
                  result.rates.USDXAU.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_4();
              getMetal_11_4();
            }, 172800000);
            getOil_11_4();
            getMetal_11_4();
          }, 1000);
        </script>
      </div>

      <div class="design-1 widget-rates-L-11-1 rates-XL">
        <div>
          <p>\$</p>
          <div class="space-div-7-1"></div>
          <p id="usd-11-1">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-1" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-1 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(540px * 1.8);
          }

          .widget-rates-L-11-1 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-1 div:nth-child(3) {
            display: flex;
            justify-content: center;
          }
          .widget-rates-L-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-1 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getUSD_11_1 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const result = await response.json();
            return result;
          };
          const myChart_11_1 = new Chart(
            document.getElementById("diagram-11-1").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],

                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getUSD_11_1().then((result) => {
                document.getElementById("usd-11-1").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                myChart_11_1.data.datasets[0].data.splice(0, 1);
                myChart_11_1.data.datasets[0].data.push(
                  result.Valute.USD.Value.toFixed(2)
                );
                myChart_11_1.update();
              });
            }, 43200000);
            getUSD_11_1().then((result) => {
              document.getElementById("usd-11-1").innerHTML =
                result.Valute.USD.Value.toFixed(2);

              const myChart_11_1_1 = new Chart(
                document.getElementById("diagram-11-1").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          87.37, 87.21, 87.07, 88.05, 88.0, 84.96, 85.75, 87.99,
                          87.95, 88.12,
                        ],

                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_1_1.data.datasets[0].data.splice(0, 1);
              myChart_11_1_1.data.datasets[0].data.push(
                result.Valute.USD.Value.toFixed(2)
              );
              myChart_11_1_1.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-rates-L-11-2 rates-XL">
        <div>
          <p>€</p>
          <div class="space-div-7-2"></div>
          <p id="eur-11-2">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-2" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-2 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(409px * 1.8);
            top: calc(540px * 1.8);
          }
          .widget-rates-L-11-2 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-2 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-2 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getEUR_11_2 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const data = await response.json();
            return data;
          };
          const myChart_11_2 = new Chart(
            document.getElementById("diagram-11-2").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getEUR_11_2().then((result) => {
                document.getElementById("eur-11-2").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
                myChart_11_2.data.datasets[0].data.splice(0, 1);
                myChart_11_2.data.datasets[0].data.push(
                  result.Valute.EUR.Value.toFixed(2)
                );
                myChart_11_2.update();
              });
            }, 43200000);
            getEUR_11_2().then((result) => {
              document.getElementById("eur-11-2").innerHTML =
                result.Valute.EUR.Value.toFixed(2);

              const myChart_11_2_2 = new Chart(
                document.getElementById("diagram-11-2").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          94.08, 93.74, 94.11, 90.99, 92.39, 93.96, 93.69,
                          94.58, 94.98, 95.1,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_2_2.data.datasets[0].data.splice(0, 1);
              myChart_11_2_2.data.datasets[0].data.push(
                result.Valute.EUR.Value.toFixed(2)
              );
              myChart_11_2_2.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: calc(572px * 1.8);
            height: var(--size-2);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: calc(540px * 1.8);
            left: calc(802px * 1.8);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(1390px * 1.8);
            top: calc(540px * 1.8);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: var(--size-4);
            height: var(--size-1);
            position: absolute;
            left: calc(1390px * 1.8);
            top: calc(671px * 1.8);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
      <div class="design-1 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(993px * 1.8);
            top: calc(16px * 1.8);
          }
          .video img {
            width: calc(905px * 1.8);
            height: calc(508px * 1.8);
            border-radius: 32px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(1914px * 1.8);
      height: calc(802px * 1.8);
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;
export const theme21ver = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Тема 21 вертикальная</title>
  </head>
  <body>
    <div class="container">
      <div class="design-1 widget-digital-clock-XL-11-1 digital-clock-XL">
        <p id="hour-minutes11-1"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-digital-clock-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-4);
            height: var(--size-2);
            position: absolute;
            top: calc(16px * 1.8);
            left: calc(16px * 1.8);
          }
          .widget-digital-clock-XL-11-1 p {
            font-family: rubik;
            font-size: 140px;
            font-weight: 300;
            color: var(--text-color);
          }
        </style>
        <script>
          setInterval(function setTime_11_1() {
            d = new Date();
            document.getElementById(
              "hour-minutes11-1"
            ).innerHTML = \`\${d.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}\`;
          }, 100);
        </script>
      </div>

      <div class="design-1 widget-weather-M-11-3 weather-M">
        <div>
          <img id="current-status-img-11-3" src="" alt="" />
          <p id="current-status-weather-11-3"></p>
          <p id="current-weather-11-3"></p>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-weather-M-11-3 {
            display: flex;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.8);
            top: calc(16px * 1.8);
          }
          .widget-weather-M-11-3 div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px;
          }
          .widget-weather-M-11-3 p {
            font-family: rubik;
            font-weight: 300;
          }
          .widget-weather-M-11-3 p:nth-child(2) {
            text-align: start;
            color: rgba(115, 115, 115, 1);
            font-size: 26px;
          }
          .widget-weather-M-11-3 p:nth-child(3) {
            color: var(--text-color);
            font-size: 70px;
          }
          .widget-weather-M-11-3 img {
            width: 80px;
            height: 70px;
            filter: var(--color-icon);
          }
          .current-status-weather-11-3 {
            text-align: start;
          }
        </style>
        <script>
          const currentWeather_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_weather", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                document.getElementById("current-weather-11-3").innerHTML =
                  result[0][0];
                document.getElementById(
                  "current-status-weather-11-3"
                ).innerHTML = result[0][1];

                const weather = {
                  Ясно: "http://212.41.9.251:8000/static/weather_clear.svg",
                  Облачно: "http://212.41.9.251:8000/static/weather_cloudy.svg",
                  "Переменная облачность":
                    "http://212.41.9.251:8000/static/weather_p_cloudy.svg",
                  "Местами дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Местами грозы": "",
                  "Местами легкий дождь с грозой":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                  "Моросящий дождь":
                    "http://212.41.9.251:8000/static/weather_rain.svg",
                };

                for (key in weather) {
                  if (key == result[0][1]) {
                    document
                      .getElementById("current-status-img-11-3")
                      .setAttribute("src", weather[key]);
                  }
                }
              });
          };
          setTimeout(() => {
            setInterval(() => {
              currentWeather_11_3;
            }, 300000);
            currentWeather_11_3();
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-calendar-XL-11-1 calendar-XL">
        <table id="calendar11-1">
          <thead>
            <tr>
              <td
                style="
                  font-weight: 500;
                  text-align: center;
                  width: 100%;
                  height: 100%;
                "
                colspan="7"
              ></td>
              <td>
                <tr style="font-weight: 500">
                  <td>пн</td>
                  <td>вт</td>
                  <td>ср</td>
                  <td>чт</td>
                  <td>пт</td>
                  <td>сб</td>
                  <td>вс</td>
                </tr>
              </td>
            </tr>
          </thead>
          <tbody id="body-calendar-11-1"></tbody>
        </table>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-3: calc(377px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          #calendar11-1 {
            text-align: center;
            font-size: 26px;
            color: var(--text-color);
            font-weight: 300;
            border-spacing: 15px 5px;
            margin: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          }
          .widget-calendar-XL-11-1 {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: Rubik;
            width: var(--size-4);
            height: var(--size-3);
            position: absolute;
            top: calc(278px * 1.8);
            left: calc(16px * 1.8);
          }
          #today-11-1 {
            color: var(--background-widgets);
            background-color: var(--text-color);
            border-radius: 16px;
          }
          #body-calendar-11-1 tr td {
            width: 46px;
            height: 46px;
            text-align: center;
          }
          thead tr:nth-child(1) {
            display: flex;
            justify-content: center;
          }
          thead tr:nth-child(2) {
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            height: 50px;
          }
          thead tr td {
            width: 46px;
          }
        </style>

        <script>
          const getCalendar_11_1 = () => {
            var D1 = new Date(),
              D1last = new Date(
                D1.getFullYear(),
                D1.getMonth() + 1,
                0
              ).getDate(), // последний день месяца
              D1Nlast = new Date(
                D1.getFullYear(),
                D1.getMonth(),
                D1last
              ).getDay(), // день недели последнего дня месяца
              D1Nfirst = new Date(D1.getFullYear(), D1.getMonth(), 1).getDay(), // день недели первого дня месяца
              calendar1 = "<tr>",
              month = [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь",
              ]; // название месяца, вместо цифр 0-11

            // пустые клетки до первого дня текущего месяца
            if (D1Nfirst != 0) {
              for (var i = 1; i < D1Nfirst; i++) calendar1 += "<td>";
            } else {
              // если первый день месяца выпадает на воскресенье, то требуется 7 пустых клеток
              for (var i = 0; i < 6; i++) calendar1 += "<td>";
            }

            // дни месяца
            for (var i = 1; i <= D1last; i++) {
              if (i != D1.getDate()) {
                calendar1 += "<td>" + i;
              } else {
                calendar1 += '<td id="today-11-1">' + i; // сегодняшней дате можно задать стиль CSS
              }
              if (new Date(D1.getFullYear(), D1.getMonth(), i).getDay() == 0) {
                // если день выпадает на воскресенье, то перевод строки
                calendar1 += "<tr>";
              }
            }

            // пустые клетки после последнего дня месяца
            if (D1Nlast != 0) {
              for (var i = D1Nlast; i < 7; i++) calendar1 += "<td>";
            }

            document.querySelector("#calendar11-1 tbody").innerHTML = calendar1;
            // document.querySelector('#calendar11-1 thead td:last-child').innerHTML = D1.getFullYear();
            document.querySelector(
              "#calendar11-1 thead td:first-child"
            ).innerHTML = month[D1.getMonth()];
          };
          getCalendar_11_1();
        </script>
      </div>
      <div class="design-1 widget-traffic-M-11-2 traffic-M">
        <p>Пробки</p>
        <div class="space-div-5-2"></div>
        <p id="current-traffic-11-2"></p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-2: calc(246px * 1.8);
            --style2: "";
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-traffic-M-11-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: var(--size-2);
            height: var(--size-1);
            position: absolute;
            top: calc(278px * 1.8);
            left: calc(540px * 1.8);
          }
          .widget-traffic-M-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 32px;
          }
          .widget-traffic-M-11-2 p:nth-child(3) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 54px;
            height: 54px;
            border: var(--style2);
            border-radius: 50%;
          }
          .space-div-5-2 {
            width: 6px;
          }
        </style>
        <script>
          const getTraffic_11_2 = () => {
            min = Math.ceil(1);
            max = Math.floor(8);
            return Math.floor(Math.random() * (max - min) + min);
          };
          const updateBackgroud2 = () => {
            let value = document.getElementById(
              "current-traffic-11-2"
            ).innerHTML;
            if (value == "10") {
              var style = \`6px solid rgba(250, 46, 35, 1)\`;
            } else if (value == "9") {
              var style = \`6px solid rgba(249, 80, 32, 1)\`;
            } else if (value == "8") {
              var style = \`6px solid rgba(248, 111, 28, 1)\`;
            } else if (value == "7") {
              var style = \`6px solid rgba(247, 138, 25, 1)\`;
            } else if (value == "6") {
              var style = \`6px solid rgba(247, 165, 22, 1)\`;
            } else if (value == "5") {
              var style = \`6px solid rgba(245, 191, 19, 1)\`;
            } else if (value == "4") {
              var style = \`6px solid rgba(239, 222, 21, 1)\`;
            } else if (value == "3") {
              var style = \`6px solid rgba(210, 250, 11, 1)\`;
            } else if (value == "2") {
              var style = \`6px solid rgba(164, 243, 18, 1)\`;
            } else if (value == "1") {
              var style = \`6px solid rgba(144, 243, 13, 1)\`;
            } else {
              var style = \`6px solid rgba(77, 243, 12, 1)\`;
            }
            document.documentElement.style.setProperty(\`--style2\`, \`\${style}\`);
          };
          document.getElementById("current-traffic-11-2").innerHTML =
            getTraffic_11_2();
          updateBackgroud2();
          setInterval(() => {
            document.getElementById("current-traffic-11-2").innerHTML =
              getTraffic_11_2();

            updateBackgroud2();
          }, 1800000);
        </script>
      </div>

      <div class="design-1 widget-metals-L-11-3 metal-M">
        <div>
          <p class="name-metal-11-3">Нефть</p>
          <div class="widget-metal-last-11-3">
            <p id="oil-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-1"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Серебро</p>
          <div class="widget-metal-last-11-3">
            <p id="silver-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-2"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Золото</p>
          <div class="widget-metal-last-11-3">
            <p id="gold-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-3"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Платина</p>
          <div class="widget-metal-last-11-3">
            <p id="platinum-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-4"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <div>
          <p class="name-metal-11-3">Палладий</p>
          <div class="widget-metal-last-11-3">
            <p id="palladium-price-11-3">---,--</p>
            <div class="space-div-8-3"></div>
            <img
              id="updown-11-3-5"
              src="http://212.41.9.251:8000/static/red_triangle.svg"
            />
          </div>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
          }
          .widget-metals-L-11-3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: var(--size-2);
            height: var(--size-2);
            position: absolute;
            left: calc(540px * 1.8);
            top: calc(409px * 1.8);
          }
          .widget-metals-L-11-3 div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            color: var(--text-color);
            font-size: 18;
            font-family: Rubik;
          }
          .name-metal-11-3 {
            text-align: start;
            width: 106px;
            color: rgba(115, 115, 115, 1);
          }
          .space-div-8-3 {
            width: 6px;
          }
          .widget-metals-L-11-3 img {
            width: 12px;
            height: 11px;
          }
          .widget-metal-last-11-3 p {
            width: 100px;
            text-align: end;
          }
        </style>
        <script>
          const getOil_11_3 = () => {
            fetch("http://212.41.9.251:8000/get_brent", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                var old_data =
                  document.getElementById("oil-price-11-3").innerHTML;
                var new_data = result[1];
                if (new_data >= old_data) {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-1")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("oil-price-11-3").innerHTML = result[1];
              });
          };
          const getMetal_11_3 = () => {
            fetch("http://212.41.9.251:8000/metal", {
              method: "GET",
            })
              .then((response) => response.json())
              .then((result) => {
                var old_silver_price =
                  document.getElementById("silver-price-11-3").innerHTML;
                var new_silver_price = result.rates.USDXAG;

                if (new_silver_price >= old_silver_price) {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-2")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("silver-price-11-3").innerHTML =
                  result.rates.USDXAG.toFixed(2);
                //------------------------------------
                var old_gold_price =
                  document.getElementById("gold-price-11-3").innerHTML;
                var new_gold_price = result.rates.USDXAU;

                if (new_gold_price >= old_gold_price) {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-3")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("gold-price-11-3").innerHTML =
                  result.rates.USDXAU.toFixed(2);
                //------------------------------------
                var old_platinum_price = document.getElementById(
                  "platinum-price-11-3"
                ).innerHTML;
                var new_platinum_price = result.rates.USDXPT.toFixed(2);

                if (new_platinum_price >= old_platinum_price) {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-4")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("platinum-price-11-3").innerHTML =
                  result.rates.USDXPT.toFixed(2);
                //------------------------------------
                var old_palladium_price = document.getElementById(
                  "palladium-price-11-3"
                ).innerHTML;
                var new_palladium_price = result.rates.USDXPD;

                if (new_palladium_price >= old_palladium_price) {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/green_triangle.svg"
                    );
                } else {
                  document
                    .getElementById("updown-11-3-5")
                    .setAttribute(
                      "src",
                      "http://212.41.9.251:8000/static/red_triangle.svg"
                    );
                }
                document.getElementById("palladium-price-11-3").innerHTML =
                  result.rates.USDXPD.toFixed(2);
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getOil_11_3();
              getMetal_11_3();
            }, 172800000);
            getOil_11_3();
            getMetal_11_3();
          }, 1000);
        </script>
      </div>

      <div class="design-1 widget-rates-L-11-1 rates-XL">
        <div>
          <p>\$</p>
          <div class="space-div-7-1"></div>
          <p id="usd-11-1">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-1" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-1 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(671px * 1.8);
          }

          .widget-rates-L-11-1 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-1 div:nth-child(3) {
            display: flex;
            justify-content: center;
          }
          .widget-rates-L-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-1 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getUSD_11_1 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const result = await response.json();
            return result;
          };
          const myChart_11_1 = new Chart(
            document.getElementById("diagram-11-1").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],

                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getUSD_11_1().then((result) => {
                document.getElementById("usd-11-1").innerHTML =
                  result.Valute.USD.Value.toFixed(2);
                myChart_11_1.data.datasets[0].data.splice(0, 1);
                myChart_11_1.data.datasets[0].data.push(
                  result.Valute.USD.Value.toFixed(2)
                );
                myChart_11_1.update();
              });
            }, 43200000);
            getUSD_11_1().then((result) => {
              document.getElementById("usd-11-1").innerHTML =
                result.Valute.USD.Value.toFixed(2);

              const myChart_11_1_1 = new Chart(
                document.getElementById("diagram-11-1").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          87.37, 87.21, 87.07, 88.05, 88.0, 84.96, 85.75, 87.99,
                          87.95, 88.12,
                        ],

                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_1_1.data.datasets[0].data.splice(0, 1);
              myChart_11_1_1.data.datasets[0].data.push(
                result.Valute.USD.Value.toFixed(2)
              );
              myChart_11_1_1.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-rates-L-11-2 rates-XL">
        <div>
          <p>€</p>
          <div class="space-div-7-2"></div>
          <p id="eur-11-2">0,00</p>
        </div>
        <div style="padding-left: 32px; padding-right: 32px">
          <canvas id="diagram-11-2" width="350" height="180"></canvas>
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-3: calc(377px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-rates-L-11-2 {
            display: flex;
            flex-direction: column;
            width: var(--size-3);
            height: var(--size-2);
            position: absolute;
            top: calc(671px * 1.8);
            left: calc(409px * 1.8);
          }
          .widget-rates-L-11-2 div:first-child {
            display: flex;
            margin-left: 32px;
          }
          .widget-rates-L-11-2 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 70px;
            font-weight: 300;
          }
          .widget-rates-L-11-2 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
          .space-div-7-2 {
            width: 18px;
          }
        </style>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.min.js"></script>
        <script>
          const getEUR_11_2 = async () => {
            const response = await fetch(
              "https://www.cbr-xml-daily.ru/daily_json.js",
              {
                method: "GET",
              }
            );
            const data = await response.json();
            return data;
          };
          const myChart_11_2 = new Chart(
            document.getElementById("diagram-11-2").getContext("2d"),
            {
              type: "line",
              data: {
                labels: ["", "", "", "", "", "", "", "", "", ""],
                datasets: [
                  {
                    label: "\$",
                    lineTension: 0,
                    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
                    pointRadius: 0,
                    borderColor: "rgba(255,255,255,1)",
                    borderWidth: 4,
                    fill: false,
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                  maintainAspectRatio: false,
                },
              },
            }
          );
          setTimeout(() => {
            setInterval(() => {
              getEUR_11_2().then((result) => {
                document.getElementById("eur-11-2").innerHTML =
                  result.Valute.EUR.Value.toFixed(2);
                myChart_11_2.data.datasets[0].data.splice(0, 1);
                myChart_11_2.data.datasets[0].data.push(
                  result.Valute.EUR.Value.toFixed(2)
                );
                myChart_11_2.update();
              });
            }, 43200000);
            getEUR_11_2().then((result) => {
              document.getElementById("eur-11-2").innerHTML =
                result.Valute.EUR.Value.toFixed(2);

              const myChart_11_2_2 = new Chart(
                document.getElementById("diagram-11-2").getContext("2d"),
                {
                  type: "line",
                  data: {
                    labels: ["", "", "", "", "", "", "", "", "", ""],
                    datasets: [
                      {
                        label: "\$",
                        lineTension: 0,
                        data: [
                          94.08, 93.74, 94.11, 90.99, 92.39, 93.96, 93.69,
                          94.58, 94.98, 95.1,
                        ],
                        pointRadius: 0,
                        borderColor: "rgba(255,255,255,1)",
                        borderWidth: 4,
                        fill: false,
                      },
                    ],
                  },
                  options: {
                    legend: {
                      display: false,
                      maintainAspectRatio: false,
                    },
                  },
                }
              );
              myChart_11_2_2.data.datasets[0].data.splice(0, 1);
              myChart_11_2_2.data.datasets[0].data.push(
                result.Valute.EUR.Value.toFixed(2)
              );
              myChart_11_2_2.update();
            });
          }, 5000);
        </script>
      </div>

      <div class="design-1 widget-news-11-1 news-L">
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-1">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-2">
          ------
        </p>
        <p style="margin-top: 15px; margin-bottom: 15px" id="header-news-11-3">
          ------
        </p>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-2: calc(246px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-news-11-1 {
            width: calc(770px * 1.8);
            height: calc(255px * 1.8);
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(933px * 1.8);
          }
          .widget-news-11-1 p {
            color: var(--text-color);
            font-family: Rubik;
            font-weight: 300;
            font-size: 26px;
            text-align: start;
            margin-left: 32px;
            padding-left: 16px;
            margin-right: 32px;
            border-left: 3px solid var(--text-color);
          }
        </style>
        <script>
          const getNews_11_1 = () => {
            fetch("http://212.41.9.251:8000/news", {
              method: "GET",
              headers: {
                accept: "application/json",
              },
            })
              .then((response) => response.json())
              .then((result) => {
                const news = result.filter((item) => {
                  return item.length >= 15 && item.length <= 60;
                });
                document.getElementById("header-news-11-1").innerHTML = news[0];
                document.getElementById("header-news-11-2").innerHTML = news[1];
                document.getElementById("header-news-11-3").innerHTML = news[2];
              });
          };
          setTimeout(() => {
            setInterval(() => {
              getNews_11_1();
            }, 300000);
            getNews_11_1();
          }, 5000);
        </script>
      </div>
      <div class="design-1 video">
        <img src="https://legacy.reactjs.org/logo-og.png" alt="" />
        <style>
          .video {
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1204px * 1.8);
          }
          .video img {
            width: calc(770px * 1.8);
            height: calc(432px * 1.8);
            border-radius: 32px;
          }
        </style>
      </div>

      <div class="design-1 widget-about-company-11-1 company-L">
        <div>
          <p>Лифт обслуживает компания</p>
          <input
            type="text"
            id="text1"
            name="input1"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <div>
          <p>Телефон поддержки</p>
          <input
            type="text"
            name="input1"
            id="text2"
            style="
              text-align: end;
              background-color: rgba(0, 0, 0, 0);
              border: none;
              color: white;
              font-family: rubik;
              color: var(--text-color);
              font-size: 18px;
              width: 180px;
            "
          />
        </div>
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --text-color: rgba(255, 255, 255, 1);
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-1 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            width: calc(770px * 1.8);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1652px * 1.8);
          }
          .widget-about-company-11-1 div {
            display: flex;
            justify-content: space-around;
          }
          .widget-about-company-11-1 p {
            font-family: rubik;
            color: var(--text-color);
            font-size: 18px;
            width: 255px;
            text-align: start;
          }
          .widget-about-company-11-1 p:first-child {
            color: rgba(115, 115, 115, 1);
          }
        </style>
        <script>
          const submit_action = (e) => {
            if (e.key === "Enter") {
              // Получаем все input элементы внутри формы
              const inputs = document.querySelectorAll('input[type="text"]');

              // Проходимся по всем input элементам и заменяем их на новые с обновленными значениями
              inputs.forEach((input) => {
                const newValue = input.value;
                const newInput = document.createElement("input");
                newInput.type = "text";
                newInput.name = input.name;
                newInput.value = newValue;
                newInput.style.color = "black";
                input.outerHTML =
                  input.outerHTML.slice(0, 6) +
                  \` value="\${newValue}" \` +
                  input.outerHTML.slice(6);
                console.log(input.outerHTML);
              });
            }
          };
          document.addEventListener("keypress", submit_action);
        </script>
      </div>

      <div class="design-1 widget-about-company-11-2 company-L">
        <img src="http://212.41.9.251:8000/static/light_qr.svg" alt="" />
        <div>
          <img
            style="width: 116px; height: 12px"
            src="http://212.41.9.251:8000/static/light_ipanel.svg"
            alt=""
          />
          <div class="space-div-9-2"></div>
          <img
            src="http://212.41.9.251:8000/static/light_liftbrand.svg"
            alt=""
          />
        </div>
        <img
          src="http://212.41.9.251:8000/static/light_videovision.svg"
          alt=""
        />
        <style>
          @import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");
          * {
            margin: 0;
            padding: 0;
          }
          :root {
            --size-1: calc(115px * 1.8);
            --size-4: calc(508px * 1.8);
            --background-widgets: rgba(30, 30, 30, 1);
            --color-icon: "";
          }
          .design-1 {
            background-color: var(--background-widgets);
            border-radius: 32px;
            backdrop-filter: blur(60px);
          }
          .widget-about-company-11-2 {
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: calc(770px * 1.8);
            height: var(--size-1);
            position: absolute;
            left: calc(16px * 1.8);
            top: calc(1783px * 1.8);
          }
          .widget-about-company-11-2 div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .widget-about-company-11-2 img {
            filter: var(--color-icon);
          }
          .space-div-9-2 {
            height: 16px;
          }
        </style>
      </div>
    </div>
  </body>
  <style>
    * {
      margin: 0;
      padding: 0;
    }
    .container {
      position: relative;
      width: calc(802px * 1.8);
      height: calc(1914px * 1.8);
      background-color: rgba(16, 16, 16, 1);
    }
  </style>
</html>
`;
